var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _path16, _g37, _path17, _g38, _path18, _g39, _path19, _path20, _path21, _g40, _g41, _g42, _path22, _g43, _path23, _path24, _path25, _path26, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _path27, _g52, _path28, _g53, _g54, _g55, _g56, _g57;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 810 810",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ht"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.586 489h714.75v320.76h-714.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m51 490h708v317.29h-708z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m296.07 807.14c-9.3164 0-18.207-1.8789-24.852-5.7148l-209.7-121.08c-7.332-4.2344-10.543-10.047-9.8008-16.027 0.74609-5.9805 5.4375-12.121 13.906-17.008l55.859-32.254 1.2344 0.70703-53.227 30.73c-8.3711 4.8359-13.008 10.906-13.746 16.82-0.73438 5.9102 2.4375 11.66 9.6836 15.844l207.34 119.72c6.5703 3.7969 15.367 5.6523 24.574 5.6523 11.113 0 22.844-2.7109 32-7.9961l411.29-237.48c16.746-9.6719 18.562-24.293 4.0586-32.668l-59.789-34.523 2.3984-1.3828 61.223 35.352c14.66 8.4688 12.82 23.258-4.1094 33.039l-415.98 240.18c-9.2617 5.3477-21.121 8.0859-32.363 8.0859"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m296.07 807.14c-9.3164 0-18.207-1.8789-24.852-5.7148l-209.7-121.08c-7.332-4.2344-10.543-10.047-9.8008-16.027 0.74609-5.9805 5.4375-12.121 13.906-17.008l55.859-32.254 1.2344 0.70703-53.227 30.73c-8.3711 4.8359-13.008 10.906-13.746 16.82-0.73438 5.9102 2.4375 11.66 9.6836 15.844l207.34 119.72c6.5703 3.7969 15.367 5.6523 24.574 5.6523 11.113 0 22.844-2.7109 32-7.9961l411.29-237.48c16.746-9.6719 18.562-24.293 4.0586-32.668l-59.789-34.523 2.3984-1.3828 61.223 35.352c14.66 8.4688 12.82 23.258-4.1094 33.039l-415.98 240.18c-9.2617 5.3477-21.121 8.0859-32.363 8.0859"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m834.92 789.52-112.14-462.11-744.37 180.68 112.15 462.11z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dm",
    x1: 0.093038,
    x2: 0.80214,
    gradientTransform: "matrix(-1045.7 253.82 -253.79 -1045.8 862.72 492.08)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfdfd",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfdfd",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfdfd",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdfdfd",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfdfd",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfdfd",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfdfd",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfdfd",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.145 491.45h699.64v313.55h-699.64z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ey"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.34 804.53c-9.207 0-18.004-1.8555-24.574-5.6523l-207.34-119.72c-7.2461-4.1836-10.418-9.9336-9.6836-15.844 0.73828-5.9141 5.375-11.984 13.746-16.82l53.227-30.73 1.2266 0.71484-50.582 29.203c-8.2734 4.7734-12.859 10.777-13.586 16.625-0.72656 5.8438 2.4062 11.527 9.5742 15.664l204.97 118.36c6.4961 3.75 15.188 5.5859 24.289 5.5859 10.996 0.007813 22.582-2.6758 31.637-7.9062l406.6-234.77c16.555-9.5586 18.352-24.016 4.0156-32.293l-58.355-33.703 2.3906-1.3789 59.789 34.523c14.504 8.375 12.688 22.996-4.0586 32.668l-411.29 237.48c-9.1562 5.2852-20.887 7.9961-32 7.9961"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.34 804.53c-9.207 0-18.004-1.8555-24.574-5.6523l-207.34-119.72c-7.2461-4.1836-10.418-9.9336-9.6836-15.844 0.73828-5.9141 5.375-11.984 13.746-16.82l53.227-30.73 1.2266 0.71484-50.582 29.203c-8.2734 4.7734-12.859 10.777-13.586 16.625-0.72656 5.8438 2.4062 11.527 9.5742 15.664l204.97 118.36c6.4961 3.75 15.188 5.5859 24.289 5.5859 10.996 0.007813 22.582-2.6758 31.637-7.9062l406.6-234.77c16.555-9.5586 18.352-24.016 4.0156-32.293l-58.355-33.703 2.3906-1.3789 59.789 34.523c14.504 8.375 12.688 22.996-4.0586 32.668l-411.29 237.48c-9.1562 5.2852-20.887 7.9961-32 7.9961"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m830.84 787.13-110.83-456.68-736.66 178.81 110.83 456.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gn",
    x1: 0.093626,
    x2: 0.80198,
    gradientTransform: "matrix(-1033.9 250.96 -250.93 -1034 857.55 492.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfcfd",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfcfd",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfcfd",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfcfd",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfcfc",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcfcfc",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbfbfc",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbfbfc",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbfbfc",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbfbfc",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m59.676 493h691.32v309h-691.32z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m298.61 801.91c-9.1016 0-17.793-1.8359-24.289-5.5859l-204.97-118.36c-7.168-4.1367-10.301-9.8203-9.5742-15.664 0.72656-5.8477 5.3125-11.852 13.586-16.625l50.582-29.203 1.2344 0.70703-47.941 27.68c-8.1836 4.7227-12.715 10.664-13.438 16.438-0.71875 5.7773 2.3789 11.391 9.4648 15.484l202.61 116.99c6.4219 3.707 15.016 5.5195 24.012 5.5195 10.867 0 22.324-2.6445 31.273-7.8125l401.91-232.06c16.363-9.4531 18.137-23.738 3.9727-31.922l-56.926-32.867 2.3945-1.3906 58.355 33.703c14.336 8.2773 12.539 22.734-4.0156 32.293l-406.6 234.77c-9.0547 5.2305-20.641 7.9141-31.637 7.9062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m298.61 801.91c-9.1016 0-17.793-1.8359-24.289-5.5859l-204.97-118.36c-7.168-4.1367-10.301-9.8203-9.5742-15.664 0.72656-5.8477 5.3125-11.852 13.586-16.625l50.582-29.203 1.2344 0.70703-47.941 27.68c-8.1836 4.7227-12.715 10.664-13.438 16.438-0.71875 5.7773 2.3789 11.391 9.4648 15.484l202.61 116.99c6.4219 3.707 15.016 5.5195 24.012 5.5195 10.867 0 22.324-2.6445 31.273-7.8125l401.91-232.06c16.363-9.4531 18.137-23.738 3.9727-31.922l-56.926-32.867 2.3945-1.3906 58.355 33.703c14.336 8.2773 12.539 22.734-4.0156 32.293l-406.6 234.77c-9.0547 5.2305-20.641 7.9141-31.637 7.9062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m825.94 784.74-109.46-451.07-728.17 176.75 109.47 451.07z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hs",
    x1: 0.092873,
    x2: 0.80151,
    gradientTransform: "matrix(-1022.1 248.1 -248.07 -1022.2 852.43 493.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbfcfc",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbfcfc",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbfbfc",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbfbfc",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafbfc",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafbfc",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafbfc",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafbfb",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafbfb",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafafb",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafafb",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafb",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafb",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafb",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63 494.46h684v305.27h-684z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ec"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m299.89 799.3c-8.9961 0-17.59-1.8125-24.012-5.5195l-202.61-116.99c-7.0859-4.0938-10.184-9.707-9.4648-15.484 0.72266-5.7734 5.2539-11.715 13.438-16.438l47.941-27.68 1.2266 0.70703-45.305 26.16c-8.0781 4.668-12.566 10.535-13.273 16.246-0.70703 5.707 2.3555 11.262 9.3555 15.301l200.25 115.63c6.3398 3.6602 14.832 5.4609 23.73 5.4609 10.734 0 22.059-2.6211 30.906-7.7305l397.22-229.36c16.168-9.3359 17.926-23.465 3.918-31.547l-55.492-32.043 2.3984-1.3789 56.926 32.867c14.164 8.1836 12.391 22.469-3.9727 31.922l-401.91 232.06c-8.9492 5.168-20.406 7.8125-31.273 7.8125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m299.89 799.3c-8.9961 0-17.59-1.8125-24.012-5.5195l-202.61-116.99c-7.0859-4.0938-10.184-9.707-9.4648-15.484 0.72266-5.7734 5.2539-11.715 13.438-16.438l47.941-27.68 1.2266 0.70703-45.305 26.16c-8.0781 4.668-12.566 10.535-13.273 16.246-0.70703 5.707 2.3555 11.262 9.3555 15.301l200.25 115.63c6.3398 3.6602 14.832 5.4609 23.73 5.4609 10.734 0 22.059-2.6211 30.906-7.7305l397.22-229.36c16.168-9.3359 17.926-23.465 3.918-31.547l-55.492-32.043 2.3984-1.3789 56.926 32.867c14.164 8.1836 12.391 22.469-3.9727 31.922l-401.91 232.06c-8.9492 5.168-20.406 7.8125-31.273 7.8125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m821.03 782.35-108.1-445.45-719.67 174.68 108.11 445.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iu",
    x1: 0.09352,
    x2: 0.8021,
    gradientTransform: "matrix(-1010.3 245.24 -245.21 -1010.4 847.32 494.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafbfc",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafbfc",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafbfb",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafbfb",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafafb",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fafafb",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafb",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafb",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafb",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafa",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafa",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9f9fa",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9f9fa",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "he"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.23 496h675.46v300.71h-675.46z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m301.16 796.69c-8.8984 0-17.391-1.8008-23.73-5.4609l-200.25-115.63c-7-4.0391-10.062-9.5938-9.3555-15.301 0.70703-5.7109 5.1953-11.578 13.273-16.246l45.305-26.16 1.2344 0.71484-42.664 24.637c-7.9922 4.6094-12.422 10.406-13.121 16.051-0.70312 5.6367 2.3242 11.129 9.2422 15.117l197.89 114.27c6.2656 3.6172 14.66 5.3906 23.445 5.3945 10.613 0 21.805-2.5859 30.547-7.6328l392.52-226.65c15.984-9.2266 17.719-23.18 3.8789-31.176l-54.062-31.215 2.3945-1.3828 55.492 32.043c14.008 8.082 12.25 22.211-3.918 31.547l-397.22 229.36c-8.8477 5.1094-20.172 7.7305-30.906 7.7305"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m301.16 796.69c-8.8984 0-17.391-1.8008-23.73-5.4609l-200.25-115.63c-7-4.0391-10.062-9.5938-9.3555-15.301 0.70703-5.7109 5.1953-11.578 13.273-16.246l45.305-26.16 1.2344 0.71484-42.664 24.637c-7.9922 4.6094-12.422 10.406-13.121 16.051-0.70312 5.6367 2.3242 11.129 9.2422 15.117l197.89 114.27c6.2656 3.6172 14.66 5.3906 23.445 5.3945 10.613 0 21.805-2.5859 30.547-7.6328l392.52-226.65c15.984-9.2266 17.719-23.18 3.8789-31.176l-54.062-31.215 2.3945-1.3828 55.492 32.043c14.008 8.082 12.25 22.211-3.918 31.547l-397.22 229.36c-8.8477 5.1094-20.172 7.7305-30.906 7.7305"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ft"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m816.12 779.96-106.75-439.84-711.17 172.62 106.74 439.84z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ib",
    x1: 0.094174,
    x2: 0.80199,
    gradientTransform: "matrix(-998.56 242.38 -242.35 -998.66 842.21 495.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafb",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafb",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9fafb",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9f9fb",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fb",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.058594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8fa",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8fa",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8fa",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8fa",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8fa",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8f9",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m71 497h668v298h-668z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m302.43 794.07c-8.7852-0.003906-17.18-1.7773-23.445-5.3945l-197.89-114.27c-6.918-3.9883-9.9453-9.4805-9.2422-15.117 0.69922-5.6445 5.1289-11.441 13.121-16.051l42.664-24.637 1.2266 0.71094-40.02 23.109c-7.8984 4.5586-12.273 10.285-12.961 15.855-0.69922 5.5742 2.293 11 9.1289 14.949l195.52 112.89c6.1914 3.5781 14.484 5.332 23.168 5.332 10.484 0 21.539-2.5586 30.176-7.5469l387.84-223.94c15.789-9.1133 17.508-22.91 3.832-30.805l-52.629-30.391 2.3906-1.3789 54.062 31.215c13.84 7.9961 12.105 21.949-3.8789 31.176l-392.52 226.65c-8.7422 5.0469-19.934 7.6328-30.547 7.6328"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "em"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m302.43 794.07c-8.7852-0.003906-17.18-1.7773-23.445-5.3945l-197.89-114.27c-6.918-3.9883-9.9453-9.4805-9.2422-15.117 0.69922-5.6445 5.1289-11.441 13.121-16.051l42.664-24.637 1.2266 0.71094-40.02 23.109c-7.8984 4.5586-12.273 10.285-12.961 15.855-0.69922 5.5742 2.293 11 9.1289 14.949l195.52 112.89c6.1914 3.5781 14.484 5.332 23.168 5.332 10.484 0 21.539-2.5586 30.176-7.5469l387.84-223.94c15.789-9.1133 17.508-22.91 3.832-30.805l-52.629-30.391 2.3906-1.3789 54.062 31.215c13.84 7.9961 12.105 21.949-3.8789 31.176l-392.52 226.65c-8.7422 5.0469-19.934 7.6328-30.547 7.6328"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m811.21 777.57-105.38-434.23-702.67 170.56 105.38 434.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 0.093477,
    x2: 0.80217,
    gradientTransform: "matrix(-986.78 239.52 -239.49 -986.87 837.17 496.67)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f9fa",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8fa",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8fa",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f7f8",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f7f8",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f7f8",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f7f8",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f7f8",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f7f8",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m75 498h660v294h-660z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m303.71 791.46c-8.6836 0-16.977-1.7539-23.168-5.332l-195.52-112.89c-6.8359-3.9492-9.8281-9.375-9.1289-14.949 0.6875-5.5703 5.0625-11.297 12.961-15.855l40.02-23.109 1.2305 0.71484-37.383 21.582c-7.7969 4.5039-12.121 10.156-12.805 15.664-0.68359 5.5078 2.2656 10.863 9.0195 14.766l193.16 111.53c6.1211 3.5312 14.309 5.2656 22.891 5.2656 10.355 0 21.281-2.5273 29.809-7.4492l383.16-221.24c15.594-9.0078 17.289-22.633 3.7852-30.434l-51.203-29.555 2.3984-1.3906 52.629 30.391c13.676 7.8945 11.957 21.691-3.832 30.805l-387.84 223.94c-8.6367 4.9883-19.691 7.5469-30.176 7.5469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m303.71 791.46c-8.6836 0-16.977-1.7539-23.168-5.332l-195.52-112.89c-6.8359-3.9492-9.8281-9.375-9.1289-14.949 0.6875-5.5703 5.0625-11.297 12.961-15.855l40.02-23.109 1.2305 0.71484-37.383 21.582c-7.7969 4.5039-12.121 10.156-12.805 15.664-0.68359 5.5078 2.2656 10.863 9.0195 14.766l193.16 111.53c6.1211 3.5312 14.309 5.2656 22.891 5.2656 10.355 0 21.281-2.5273 29.809-7.4492l383.16-221.24c15.594-9.0078 17.289-22.633 3.7852-30.434l-51.203-29.555 2.3984-1.3906 52.629 30.391c13.676 7.8945 11.957 21.691-3.832 30.805l-387.84 223.94c-8.6367 4.9883-19.691 7.5469-30.176 7.5469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m806.31 775.18-104.02-428.62-694.17 168.5 104.01 428.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dw",
    x1: 0.094072,
    x2: 0.80209,
    gradientTransform: "matrix(-974.99 236.65 -236.63 -975.09 831.98 497.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8fa",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8f8fa",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8fa",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f8f9",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f8f9",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f7f9",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f7f8",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f7f8",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f6f8",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.16016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m79.32 500h651.68v289h-651.68z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m304.98 788.84c-8.582 0-16.77-1.7344-22.891-5.2656l-193.16-111.53c-6.7539-3.9023-9.7031-9.2578-9.0195-14.766 0.68359-5.5078 5.0078-11.16 12.805-15.664l37.383-21.582 1.2305 0.70703-34.742 20.059c-7.7031 4.4531-11.969 10.035-12.648 15.48-0.67969 5.4336 2.2422 10.727 8.9141 14.578l190.79 110.17c6.043 3.4883 14.137 5.2031 22.605 5.2031 10.23 0 21.02-2.5 29.449-7.3633l378.46-218.53c15.406-8.8984 17.082-22.352 3.7383-30.062l-49.762-28.73 2.3906-1.3789 51.203 29.555c13.504 7.8008 11.809 21.426-3.7852 30.434l-383.16 221.24c-8.5273 4.9219-19.453 7.4492-29.809 7.4492"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m304.98 788.84c-8.582 0-16.77-1.7344-22.891-5.2656l-193.16-111.53c-6.7539-3.9023-9.7031-9.2578-9.0195-14.766 0.68359-5.5078 5.0078-11.16 12.805-15.664l37.383-21.582 1.2305 0.70703-34.742 20.059c-7.7031 4.4531-11.969 10.035-12.648 15.48-0.67969 5.4336 2.2422 10.727 8.9141 14.578l190.79 110.17c6.043 3.4883 14.137 5.2031 22.605 5.2031 10.23 0 21.02-2.5 29.449-7.3633l378.46-218.53c15.406-8.8984 17.082-22.352 3.7383-30.062l-49.762-28.73 2.3906-1.3789 51.203 29.555c13.504 7.8008 11.809 21.426-3.7852 30.434l-383.16 221.24c-8.5273 4.9219-19.453 7.4492-29.809 7.4492"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m801.4 772.78-102.66-423-685.68 166.44 102.66 423z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hw",
    x1: 0.09325,
    x2: 0.80197,
    gradientTransform: "matrix(-963.2 233.79 -233.77 -963.3 826.82 498.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7f8f9",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f8f9",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f7f9",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f7f9",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f7f9",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f7f8",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f7f8",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f6f8",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.058594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f5f8",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f8",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f8",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f8",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f7",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f7",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f4f7",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f4f7",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f4f7",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f4f7",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f4f7",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f4f7",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m83 501h644v286h-644z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.25 786.23c-8.4688 0-16.562-1.7148-22.605-5.2031l-190.79-110.17c-6.6719-3.8516-9.5938-9.1445-8.9141-14.578 0.67969-5.4453 4.9453-11.027 12.648-15.48l34.742-20.059 1.2344 0.70703-32.105 18.539c-7.6055 4.3945-11.828 9.9102-12.496 15.289-0.66406 5.3633 2.2148 10.59 8.8008 14.398l188.43 108.8c5.9688 3.4414 13.961 5.1367 22.332 5.1367 10.105 0 20.758-2.4609 29.082-7.2656l373.78-215.82c15.219-8.7852 16.871-22.078 3.6914-29.688l-48.332-27.906 2.3945-1.3828 49.762 28.73c13.344 7.7109 11.668 21.164-3.7383 30.062l-378.46 218.53c-8.4297 4.8633-19.219 7.3633-29.449 7.3633"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m306.25 786.23c-8.4688 0-16.562-1.7148-22.605-5.2031l-190.79-110.17c-6.6719-3.8516-9.5938-9.1445-8.9141-14.578 0.67969-5.4453 4.9453-11.027 12.648-15.48l34.742-20.059 1.2344 0.70703-32.105 18.539c-7.6055 4.3945-11.828 9.9102-12.496 15.289-0.66406 5.3633 2.2148 10.59 8.8008 14.398l188.43 108.8c5.9688 3.4414 13.961 5.1367 22.332 5.1367 10.105 0 20.758-2.4609 29.082-7.2656l373.78-215.82c15.219-8.7852 16.871-22.078 3.6914-29.688l-48.332-27.906 2.3945-1.3828 49.762 28.73c13.344 7.7109 11.668 21.164-3.7383 30.062l-378.46 218.53c-8.4297 4.8633-19.219 7.3633-29.449 7.3633"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m796.49 770.39-101.29-417.38-677.18 164.38 101.29 417.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ex",
    x1: 0.093967,
    x2: 0.8021,
    gradientTransform: "matrix(-951.42 230.93 -230.91 -951.51 821.75 499.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6f7f8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f7f8",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f6f8",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f6f8",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f5f8",
    offset: 0.050781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f5f8",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f5f8",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f8",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f7",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f7",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f4f7",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f4f7",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f4f7",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f4f6",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.16016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f3f6",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f3f6",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f3f6",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87 502.02h636v281.98h-636z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m307.53 783.61c-8.3711 0-16.363-1.6953-22.332-5.1367l-188.43-108.8c-6.5859-3.8086-9.4648-9.0352-8.8008-14.398 0.66797-5.3789 4.8906-10.895 12.496-15.289l32.105-18.539 1.2266 0.71484-29.465 17.012c-7.5078 4.3359-11.676 9.7891-12.336 15.09-0.65625 5.3086 2.1914 10.469 8.6953 14.223l186.07 107.44c5.8945 3.3984 13.789 5.0703 22.051 5.0703 9.9766 0 20.5-2.4336 28.719-7.1797l369.09-213.12c15.027-8.6719 16.656-21.801 3.6445-29.309l-46.902-27.082 2.3984-1.3828 48.332 27.906c13.18 7.6094 11.527 20.902-3.6914 29.688l-373.78 215.82c-8.3242 4.8047-18.977 7.2656-29.082 7.2656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m307.53 783.61c-8.3711 0-16.363-1.6953-22.332-5.1367l-188.43-108.8c-6.5859-3.8086-9.4648-9.0352-8.8008-14.398 0.66797-5.3789 4.8906-10.895 12.496-15.289l32.105-18.539 1.2266 0.71484-29.465 17.012c-7.5078 4.3359-11.676 9.7891-12.336 15.09-0.65625 5.3086 2.1914 10.469 8.6953 14.223l186.07 107.44c5.8945 3.3984 13.789 5.0703 22.051 5.0703 9.9766 0 20.5-2.4336 28.719-7.1797l369.09-213.12c15.027-8.6719 16.656-21.801 3.6445-29.309l-46.902-27.082 2.3984-1.3828 48.332 27.906c13.18 7.6094 11.527 20.902-3.6914 29.688l-373.78 215.82c-8.3242 4.8047-18.977 7.2656-29.082 7.2656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m791.59 768-99.934-411.77-668.68 162.31 99.926 411.77z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 0.094633,
    x2: 0.80205,
    gradientTransform: "matrix(-939.63 228.07 -228.05 -939.72 816.62 500.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5f7f8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f6f8",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f6f8",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f8",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f7",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f5f7",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f4f7",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f4f7",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f4f6",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f4f6",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f3f6",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f3f6",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f3f6",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff3f5",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff2f5",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff2f5",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef1f5",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef1f5",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef1f5",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m91.41 504h628.59v277h-628.59z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "du"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.8 781c-8.2617 0-16.156-1.6719-22.051-5.0703l-186.07-107.44c-6.5039-3.7539-9.3516-8.9141-8.6953-14.223 0.66016-5.3008 4.8281-10.754 12.336-15.09l29.465-17.012 1.2344 0.70703-26.828 15.492c-7.418 4.2812-11.527 9.6641-12.176 14.898-0.65625 5.2383 2.1562 10.332 8.5781 14.039l183.7 106.07c5.8203 3.3672 13.613 5.0117 21.77 5.0117 9.8516 0 20.242-2.4023 28.355-7.082l364.4-210.41c14.836-8.5664 16.445-21.523 3.5977-28.938l-45.465-26.258 2.3906-1.3789 46.902 27.082c13.012 7.5078 11.383 20.637-3.6445 29.309l-369.09 213.12c-8.2188 4.7461-18.742 7.1797-28.719 7.1797"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m308.8 781c-8.2617 0-16.156-1.6719-22.051-5.0703l-186.07-107.44c-6.5039-3.7539-9.3516-8.9141-8.6953-14.223 0.66016-5.3008 4.8281-10.754 12.336-15.09l29.465-17.012 1.2344 0.70703-26.828 15.492c-7.418 4.2812-11.527 9.6641-12.176 14.898-0.65625 5.2383 2.1562 10.332 8.5781 14.039l183.7 106.07c5.8203 3.3672 13.613 5.0117 21.77 5.0117 9.8516 0 20.242-2.4023 28.355-7.082l364.4-210.41c14.836-8.5664 16.445-21.523 3.5977-28.938l-45.465-26.258 2.3906-1.3789 46.902 27.082c13.012 7.5078 11.383 20.637-3.6445 29.309l-369.09 213.12c-8.2188 4.7461-18.742 7.1797-28.719 7.1797"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m786.68 765.6-98.566-406.14-660.19 160.24 98.566 406.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 0.093858,
    x2: 0.80201,
    gradientTransform: "matrix(-927.85 225.21 -225.19 -927.94 811.53 501.38)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f5f8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4f5f8",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f7",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f4f7",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f4f7",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f4f7",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f3f7",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f2f6",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f2f6",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f1f5",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff0f5",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef0f4",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef0f4",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef0f4",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef0f4",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eeeff4",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edeff4",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edeff4",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "in"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m95 505.04h620.49v273.54h-620.49z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m310.07 778.38c-8.1562 0-15.949-1.6445-21.77-5.0117l-183.7-106.07c-6.4219-3.707-9.2344-8.8008-8.5781-14.039 0.64844-5.2344 4.7578-10.617 12.176-14.898l26.828-15.492 1.2305 0.71094-24.184 13.965c-7.3281 4.2266-11.383 9.543-12.023 14.711-0.64453 5.168 2.1289 10.195 8.4688 13.855l181.34 104.71c5.75 3.3203 13.441 4.9492 21.492 4.9492 9.7227 0 19.98-2.375 27.992-6.9961l359.71-207.7c14.641-8.4531 16.234-21.246 3.5508-28.566l-44.035-25.426 2.3945-1.3867 45.465 26.258c12.848 7.4141 11.238 20.371-3.5977 28.938l-364.4 210.41c-8.1133 4.6797-18.504 7.082-28.355 7.082"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "is"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m310.07 778.38c-8.1562 0-15.949-1.6445-21.77-5.0117l-183.7-106.07c-6.4219-3.707-9.2344-8.8008-8.5781-14.039 0.64844-5.2344 4.7578-10.617 12.176-14.898l26.828-15.492 1.2305 0.71094-24.184 13.965c-7.3281 4.2266-11.383 9.543-12.023 14.711-0.64453 5.168 2.1289 10.195 8.4688 13.855l181.34 104.71c5.75 3.3203 13.441 4.9492 21.492 4.9492 9.7227 0 19.98-2.375 27.992-6.9961l359.71-207.7c14.641-8.4531 16.234-21.246 3.5508-28.566l-44.035-25.426 2.3945-1.3867 45.465 26.258c12.848 7.4141 11.238 20.371-3.5977 28.938l-364.4 210.41c-8.1133 4.6797-18.504 7.082-28.355 7.082"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ck"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m781.77 763.21-97.207-400.53-651.69 158.18 97.203 400.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 0.094579,
    x2: 0.8021,
    gradientTransform: "matrix(-916.06 222.35 -222.33 -916.15 806.42 502.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3f5f7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f4f7",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2f4f7",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f4f6",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f2f6",
    offset: 0.042969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f6",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef1f5",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef0f4",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f4",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f4",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f4",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edeff4",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff4",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceef3",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef3",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef3",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ho"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m99 507h613v269h-613z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m311.34 775.77c-8.0508 0-15.742-1.6289-21.492-4.9492l-181.34-104.71c-6.3398-3.6602-9.1133-8.6875-8.4688-13.855 0.64062-5.168 4.6953-10.484 12.023-14.711l24.184-13.965 1.2305 0.71484-21.551 12.438c-7.2227 4.1719-11.227 9.4141-11.863 14.516-0.63281 5.1055 2.1016 10.066 8.3594 13.68l178.98 103.34c5.6719 3.2773 13.262 4.8828 21.207 4.8828 9.5977 0 19.723-2.3359 27.625-6.9062l355.03-204.99c14.453-8.3398 16.023-20.969 3.5039-28.195l-42.605-24.598 2.3984-1.3828 44.035 25.426c12.684 7.3203 11.09 20.113-3.5508 28.566l-359.71 207.7c-8.0117 4.6211-18.27 6.9961-27.992 6.9961"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m311.34 775.77c-8.0508 0-15.742-1.6289-21.492-4.9492l-181.34-104.71c-6.3398-3.6602-9.1133-8.6875-8.4688-13.855 0.64062-5.168 4.6953-10.484 12.023-14.711l24.184-13.965 1.2305 0.71484-21.551 12.438c-7.2227 4.1719-11.227 9.4141-11.863 14.516-0.63281 5.1055 2.1016 10.066 8.3594 13.68l178.98 103.34c5.6719 3.2773 13.262 4.8828 21.207 4.8828 9.5977 0 19.723-2.3359 27.625-6.9062l355.03-204.99c14.453-8.3398 16.023-20.969 3.5039-28.195l-42.605-24.598 2.3984-1.3828 44.035 25.426c12.684 7.3203 11.09 20.113-3.5508 28.566l-359.71 207.7c-8.0117 4.6211-18.27 6.9961-27.992 6.9961"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "db"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m776.86 760.82-95.84-394.92-643.2 156.12 95.836 394.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cf",
    x1: 0.09384,
    x2: 0.80219,
    gradientTransform: "matrix(-904.27 219.49 -219.47 -904.36 801.39 503.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f4f7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f4f6",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1f3f6",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f3f6",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f2f5",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff2f5",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef1f5",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef1f4",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef0f4",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef0f4",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f4",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f4",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edeff4",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edeff3",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceef3",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef2",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef2",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef1",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebedf1",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebedf1",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m103.5 508.07h604.44v265.93h-604.44z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m312.61 773.15c-7.9453 0-15.535-1.6055-21.207-4.8828l-178.98-103.34c-6.2578-3.6133-8.9922-8.5742-8.3594-13.68 0.63672-5.1016 4.6406-10.344 11.863-14.516l21.551-12.438 1.2305 0.70703-18.906 10.914c-7.1328 4.1211-11.086 9.293-11.711 14.328-0.625 5.0352 2.0781 9.9375 8.25 13.5l176.62 101.98c5.5938 3.2266 13.078 4.8164 20.926 4.8164 9.4727 0 19.461-2.3086 27.258-6.8125l350.34-202.29c14.258-8.2344 15.805-20.691 3.457-27.824l-41.172-23.77 2.3906-1.3828 42.605 24.598c12.52 7.2266 10.949 19.855-3.5039 28.195l-355.03 204.99c-7.9023 4.5703-18.027 6.9062-27.625 6.9062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "an"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m312.61 773.15c-7.9453 0-15.535-1.6055-21.207-4.8828l-178.98-103.34c-6.2578-3.6133-8.9922-8.5742-8.3594-13.68 0.63672-5.1016 4.6406-10.344 11.863-14.516l21.551-12.438 1.2305 0.70703-18.906 10.914c-7.1328 4.1211-11.086 9.293-11.711 14.328-0.625 5.0352 2.0781 9.9375 8.25 13.5l176.62 101.98c5.5938 3.2266 13.078 4.8164 20.926 4.8164 9.4727 0 19.461-2.3086 27.258-6.8125l350.34-202.29c14.258-8.2344 15.805-20.691 3.457-27.824l-41.172-23.77 2.3906-1.3828 42.605 24.598c12.52 7.2266 10.949 19.855-3.5039 28.195l-355.03 204.99c-7.9023 4.5703-18.027 6.9062-27.625 6.9062"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m771.95 758.43-94.48-389.3-634.7 154.06 94.48 389.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "it",
    x1: 0.094481,
    x2: 0.80203,
    gradientTransform: "matrix(-892.49 216.63 -216.61 -892.58 796.19 504.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f3f6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f2f6",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0f2f5",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef0f4",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f4",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edeff4",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceef3",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceef3",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef2",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebedf2",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebedf1",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaecf1",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaecf1",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaecf1",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf0",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ebf0",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ebf0",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ebf0",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ebf0",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ebf0",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ci"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108 509.58h595.41v261.42h-595.41z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m313.89 770.54c-7.8477 0-15.332-1.5898-20.926-4.8164l-176.62-101.98c-6.1719-3.5625-8.875-8.4648-8.25-13.5 0.625-5.0352 4.5781-10.207 11.711-14.328l18.906-10.914 1.2266 0.71484-16.262 9.3906c-7.0352 4.0625-10.938 9.1641-11.559 14.133-0.61328 4.9648 2.0508 9.8008 8.1406 13.32l174.25 100.61c5.5195 3.1875 12.91 4.75 20.648 4.75 9.3438 0 19.195-2.2773 26.895-6.7227l345.64-199.58c14.074-8.125 15.602-20.414 3.418-27.453l-39.742-22.945 2.3945-1.3789 41.172 23.77c12.348 7.1328 10.801 19.59-3.457 27.824l-350.34 202.29c-7.7969 4.5039-17.785 6.8125-27.258 6.8125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m313.89 770.54c-7.8477 0-15.332-1.5898-20.926-4.8164l-176.62-101.98c-6.1719-3.5625-8.875-8.4648-8.25-13.5 0.625-5.0352 4.5781-10.207 11.711-14.328l18.906-10.914 1.2266 0.71484-16.262 9.3906c-7.0352 4.0625-10.938 9.1641-11.559 14.133-0.61328 4.9648 2.0508 9.8008 8.1406 13.32l174.25 100.61c5.5195 3.1875 12.91 4.75 20.648 4.75 9.3438 0 19.195-2.2773 26.895-6.7227l345.64-199.58c14.074-8.125 15.602-20.414 3.418-27.453l-39.742-22.945 2.3945-1.3789 41.172 23.77c12.348 7.1328 10.801 19.59-3.457 27.824l-350.34 202.29c-7.7969 4.5039-17.785 6.8125-27.258 6.8125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m767.04 756.03-93.117-383.69-626.2 152 93.117 383.69z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ii",
    x1: 0.095065,
    x2: 0.80192,
    gradientTransform: "matrix(-880.7 213.77 -213.75 -880.79 790.9 505.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff1f5",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef0f4",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f4",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f4",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.035156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeff3",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef3",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef2",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf2",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf1",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf1",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf0",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ecf0",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ev"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m112 511.09h588v256.91h-588z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m315.16 767.92c-7.7383 0-15.129-1.5625-20.648-4.75l-174.25-100.61c-6.0898-3.5195-8.7539-8.3555-8.1406-13.32 0.62109-4.9688 4.5234-10.07 11.559-14.133l16.262-9.3906 1.2344 0.70703-13.629 7.8711c-6.9375 4.0078-10.785 9.043-11.395 13.938-0.61328 4.9062 2.0195 9.668 8.0273 13.141l171.89 99.246c5.4414 3.1445 12.73 4.6875 20.363 4.6875 9.2188 0 18.941-2.2422 26.531-6.6289l340.96-196.88c13.879-8.0117 15.387-20.137 3.3633-27.082l-38.309-22.117 2.3984-1.3828 39.742 22.945c12.184 7.0391 10.656 19.328-3.418 27.453l-345.64 199.58c-7.6992 4.4453-17.551 6.7227-26.895 6.7227"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m315.16 767.92c-7.7383 0-15.129-1.5625-20.648-4.75l-174.25-100.61c-6.0898-3.5195-8.7539-8.3555-8.1406-13.32 0.62109-4.9688 4.5234-10.07 11.559-14.133l16.262-9.3906 1.2344 0.70703-13.629 7.8711c-6.9375 4.0078-10.785 9.043-11.395 13.938-0.61328 4.9062 2.0195 9.668 8.0273 13.141l171.89 99.246c5.4414 3.1445 12.73 4.6875 20.363 4.6875 9.2188 0 18.941-2.2422 26.531-6.6289l340.96-196.88c13.879-8.0117 15.387-20.137 3.3633-27.082l-38.309-22.117 2.3984-1.3828 39.742 22.945c12.184 7.0391 10.656 19.328-3.418 27.453l-345.64 199.58c-7.6992 4.4453-17.551 6.7227-26.895 6.7227"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "il"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m762.14 753.64-91.754-378.07-617.71 149.93 91.75 378.08z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 0.094375,
    x2: 0.80209,
    gradientTransform: "matrix(-868.92 210.91 -210.89 -869 785.96 506.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef1f4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eef1f4",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f4",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf0f3",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeff2",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef2",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef1",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9edf1",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf0",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf0",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf0",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7eaee",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaee",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaee",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaee",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaee",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaee",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m116 512.6h579.85v253.4h-579.85z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m316.43 765.3c-7.6328 0-14.922-1.543-20.363-4.6875l-171.89-99.246c-6.0078-3.4727-8.6406-8.2344-8.0273-13.141 0.60938-4.8945 4.457-9.9297 11.395-13.938l13.629-7.8711 1.2344 0.71094-10.992 6.3438c-6.8477 3.9492-10.637 8.9219-11.238 13.75-0.60156 4.8359 1.9883 9.5312 7.9219 12.957l169.52 97.883c5.3711 3.0977 12.562 4.6211 20.086 4.6211 9.0898 0 18.676-2.2109 26.168-6.5391l336.27-194.16c13.691-7.9102 15.184-19.863 3.3242-26.707l-36.875-21.301 2.3906-1.3789 38.309 22.117c12.023 6.9453 10.516 19.07-3.3633 27.082l-340.96 196.88c-7.5898 4.3867-17.312 6.6289-26.531 6.6289"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m316.43 765.3c-7.6328 0-14.922-1.543-20.363-4.6875l-171.89-99.246c-6.0078-3.4727-8.6406-8.2344-8.0273-13.141 0.60938-4.8945 4.457-9.9297 11.395-13.938l13.629-7.8711 1.2344 0.71094-10.992 6.3438c-6.8477 3.9492-10.637 8.9219-11.238 13.75-0.60156 4.8359 1.9883 9.5312 7.9219 12.957l169.52 97.883c5.3711 3.0977 12.562 4.6211 20.086 4.6211 9.0898 0 18.676-2.2109 26.168-6.5391l336.27-194.16c13.691-7.9102 15.184-19.863 3.3242-26.707l-36.875-21.301 2.3906-1.3789 38.309 22.117c12.023 6.9453 10.516 19.07-3.3633 27.082l-340.96 196.88c-7.5898 4.3867-17.312 6.6289-26.531 6.6289"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m757.23 751.25-90.391-372.46-609.21 147.88 90.387 372.46z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 0.095169,
    x2: 0.80206,
    gradientTransform: "matrix(-857.13 208.05 -208.03 -857.21 780.87 507.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edeff4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edeff3",
    offset: 0.0039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef3",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf2",
    offset: 0.035156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaecf1",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaecf1",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf1",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf1",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ecf0",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebf0",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7eaef",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaef",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaef",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5e9ee",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e9ee",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e9ee",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e9ee",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e8ee",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e8ed",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e8ed",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e8ed",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e8ed",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e8ed",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120 513h572v250h-572z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m317.71 762.69c-7.5234 0-14.715-1.5234-20.086-4.6211l-169.52-97.883c-5.9336-3.4258-8.5234-8.1211-7.9219-12.957 0.60156-4.8281 4.3906-9.8008 11.238-13.75l10.992-6.3438 1.2266 0.71094-8.3477 4.8203c-6.75 3.8945-10.488 8.793-11.086 13.559-0.58984 4.7617 1.9688 9.4023 7.8125 12.773l167.16 96.52c5.2969 3.0586 12.387 4.5586 19.812 4.5586 8.9609 0 18.414-2.1836 25.801-6.4453l331.58-191.46c13.5-7.8008 14.965-19.59 3.2773-26.34l-35.445-20.461 2.3945-1.3906 36.875 21.301c11.859 6.8438 10.367 18.797-3.3242 26.707l-336.27 194.16c-7.4922 4.3281-17.078 6.5391-26.168 6.5391"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m317.71 762.69c-7.5234 0-14.715-1.5234-20.086-4.6211l-169.52-97.883c-5.9336-3.4258-8.5234-8.1211-7.9219-12.957 0.60156-4.8281 4.3906-9.8008 11.238-13.75l10.992-6.3438 1.2266 0.71094-8.3477 4.8203c-6.75 3.8945-10.488 8.793-11.086 13.559-0.58984 4.7617 1.9688 9.4023 7.8125 12.773l167.16 96.52c5.2969 3.0586 12.387 4.5586 19.812 4.5586 8.9609 0 18.414-2.1836 25.801-6.4453l331.58-191.46c13.5-7.8008 14.965-19.59 3.2773-26.34l-35.445-20.461 2.3945-1.3906 36.875 21.301c11.859 6.8438 10.367 18.797-3.3242 26.707l-336.27 194.16c-7.4922 4.3281-17.078 6.5391-26.168 6.5391"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "av"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m752.32 748.86-89.023-366.85-600.71 145.81 89.023 366.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fu",
    x1: 0.094263,
    x2: 0.80209,
    gradientTransform: "matrix(-845.34 205.19 -205.17 -845.43 775.74 507.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eceff3",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef2",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebedf1",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.027344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaecf1",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaecf1",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf1",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf0",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7eaef",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7eaef",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaef",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaee",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6e9ee",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5e9ee",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5e9ee",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e8ee",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e8ed",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e8ed",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e8ed",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e7ed",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e7ec",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e7ec",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e7ec",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e7ec",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e7ec",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124 515h564v245.45h-564z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m318.98 760.07c-7.4258 0-14.516-1.5-19.812-4.5586l-167.16-96.52c-5.8438-3.3711-8.4023-8.0117-7.8125-12.773 0.59766-4.7656 4.3359-9.6641 11.086-13.559l8.3477-4.8203 1.2344 0.71094-5.7148 3.293c-6.6523 3.8438-10.34 8.6719-10.926 13.371-0.58594 4.6992 1.9375 9.2695 7.7031 12.59l164.79 95.156c5.2227 3.0195 12.211 4.4922 19.527 4.4922 8.8359 0 18.156-2.1523 25.434-6.3555l326.9-188.75c13.305-7.6875 14.75-19.312 3.2305-25.965l-34.012-19.641 2.3906-1.3789 35.445 20.461c11.688 6.75 10.223 18.539-3.2773 26.34l-331.58 191.46c-7.3867 4.2617-16.84 6.4453-25.801 6.4453"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m318.98 760.07c-7.4258 0-14.516-1.5-19.812-4.5586l-167.16-96.52c-5.8438-3.3711-8.4023-8.0117-7.8125-12.773 0.59766-4.7656 4.3359-9.6641 11.086-13.559l8.3477-4.8203 1.2344 0.71094-5.7148 3.293c-6.6523 3.8438-10.34 8.6719-10.926 13.371-0.58594 4.6992 1.9375 9.2695 7.7031 12.59l164.79 95.156c5.2227 3.0195 12.211 4.4922 19.527 4.4922 8.8359 0 18.156-2.1523 25.434-6.3555l326.9-188.75c13.305-7.6875 14.75-19.312 3.2305-25.965l-34.012-19.641 2.3906-1.3789 35.445 20.461c11.688 6.75 10.223 18.539-3.2773 26.34l-331.58 191.46c-7.3867 4.2617-16.84 6.4453-25.801 6.4453"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m747.41 746.46-87.664-361.23-592.21 143.75 87.664 361.23z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.095023,
    x2: 0.80205,
    gradientTransform: "matrix(-833.56 202.33 -202.31 -833.64 770.61 508.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebeef2",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.011719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf1",
    offset: 0.027344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ebf0",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.035156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebef",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ebef",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaef",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaee",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5e9ee",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5e9ee",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e9ee",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e9ed",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e8ed",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e8ed",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e8ed",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e8ed",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e7ec",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e7ec",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e7ec",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1e6ec",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1e6eb",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1e6eb",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0e6eb",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0e6eb",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0e6eb",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128 516h555.76v242h-555.76z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320.25 757.46c-7.3164 0-14.305-1.4727-19.527-4.4922l-164.79-95.156c-5.7656-3.3203-8.2891-7.8906-7.7031-12.59 0.58594-4.6992 4.2734-9.5273 10.926-13.371l5.7148-3.293 1.2266 0.70703-3.0703 1.7773c-6.5547 3.7852-10.191 8.543-10.766 13.176-0.57812 4.6289 1.9062 9.1328 7.5859 12.414l162.43 93.785c5.1484 2.9727 12.035 4.4297 19.25 4.4297 8.7109 0 17.898-2.1211 25.07-6.2656l322.21-186.05c13.113-7.5664 14.543-19.027 3.1797-25.586l-32.578-18.812 2.3984-1.3828 34.012 19.641c11.52 6.6523 10.074 18.277-3.2305 25.965l-326.9 188.75c-7.2773 4.2031-16.598 6.3555-25.434 6.3555"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320.25 757.46c-7.3164 0-14.305-1.4727-19.527-4.4922l-164.79-95.156c-5.7656-3.3203-8.2891-7.8906-7.7031-12.59 0.58594-4.6992 4.2734-9.5273 10.926-13.371l5.7148-3.293 1.2266 0.70703-3.0703 1.7773c-6.5547 3.7852-10.191 8.543-10.766 13.176-0.57812 4.6289 1.9062 9.1328 7.5859 12.414l162.43 93.785c5.1484 2.9727 12.035 4.4297 19.25 4.4297 8.7109 0 17.898-2.1211 25.07-6.2656l322.21-186.05c13.113-7.5664 14.543-19.027 3.1797-25.586l-32.578-18.812 2.3984-1.3828 34.012 19.641c11.52 6.6523 10.074 18.277-3.2305 25.965l-326.9 188.75c-7.2773 4.2031-16.598 6.3555-25.434 6.3555"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m742.5 744.07-86.305-355.62-583.72 141.69 86.301 355.61z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hy",
    x1: 0.095977,
    x2: 0.80215,
    gradientTransform: "matrix(-821.77 199.46 -199.45 -821.85 765.6 509.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaedf1",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaecf1",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ebf0",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebef",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebef",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7eaef",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7eaef",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6e9ef",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6e9ee",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5e9ee",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5e8ee",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e8ed",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e7ed",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e7ed",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e7ed",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e6ec",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e6ec",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e6ec",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1e5ec",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1e5eb",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1e4eb",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0e4eb",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0e4eb",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0e4eb",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe3eb",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe3eb",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe3eb",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ez"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m132 518h548v237h-548z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.53 754.84c-7.2148 0-14.102-1.457-19.25-4.4297l-162.43-93.785c-5.6797-3.2812-8.1641-7.7852-7.5859-12.414 0.57422-4.6328 4.2109-9.3906 10.766-13.176l3.0703-1.7773 123.57 71.355c6.7188 3.875 15.715 5.7773 25.129 5.7773 11.375 0 23.363-2.7734 32.73-8.1836l311.88-180.08 32.578 18.812c11.363 6.5586 9.9336 18.02-3.1797 25.586l-322.21 186.05c-7.1719 4.1445-16.359 6.2656-25.07 6.2656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "br"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.53 754.84c-7.2148 0-14.102-1.457-19.25-4.4297l-162.43-93.785c-5.6797-3.2812-8.1641-7.7852-7.5859-12.414 0.57422-4.6328 4.2109-9.3906 10.766-13.176l3.0703-1.7773 123.57 71.355c6.7188 3.875 15.715 5.7773 25.129 5.7773 11.375 0 23.363-2.7734 32.73-8.1836l311.88-180.08 32.578 18.812c11.363 6.5586 9.9336 18.02-3.1797 25.586l-322.21 186.05c-7.1719 4.1445-16.359 6.2656-25.07 6.2656"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m737.59 741.68-84.934-350-575.23 139.62 84.938 350z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ek",
    x1: 0.094966,
    x2: 0.80209,
    gradientTransform: "matrix(-809.99 196.6 -196.59 -810.07 760.4 510.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaecf1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ecf1",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.011719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ebf0",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebf0",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ebef",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6eaef",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5eaef",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5e9ee",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e8ee",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4e8ed",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3e7ed",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e7ed",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2e6ec",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1e6ec",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1e5eb",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0e5eb",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe4eb",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe4eb",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe4eb",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe3eb",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe3ea",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe3ea",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe3ea",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfe3ea",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dee2ea",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dee2ea",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dee2ea",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m511.04 293.66h8.1641v0.15234h-8.1641zm-2.1133 0.15234h12.238v0.14844h-12.238zm-1.5078 0.14844h15.258v0.15625h-15.258zm-1.3672 0.15625h17.988v0.15234h-17.988zm-1.2031 0.15234h20.094v0.14844h-20.094zm-1.0625 0.14844h22.066v0.15234h-22.066zm-0.75391 0.15234h23.727v0.14844h-23.727zm-0.90234 0.14844h25.535v0.15234h-25.535zm-0.75781 0.15234h26.898v0.15234h-26.898zm-0.91016 0.15234h28.41v0.14844h-28.41zm-0.60156 0.14844h29.77v0.15234h-29.77zm-0.60547 0.15234h30.977v0.14844h-30.977zm-0.75781 0.14844h32.344v0.15234h-32.344zm-0.60156 0.15234h33.547v0.15625h-33.547zm-0.60156 0.15625h34.602v0.14453h-34.602zm-0.60938 0.14453h35.664v0.15625h-35.664zm-0.60156 0.15625h36.723v0.14844h-36.723zm-0.45312 0.14844h37.625v0.15234h-37.625zm-0.60156 0.15234h38.68v0.15234h-38.68zm-0.45703 0.15234h39.746v0.14844h-39.746zm-0.45312 0.14844h40.5v0.15234h-40.5zm-0.60156 0.15234h41.555v0.14844h-41.555zm-0.45312 0.14844h42.309v0.15234h-42.309zm-0.45703 0.15234h43.219v0.15625h-43.219zm-0.45312 0.15625h43.977v0.14453h-43.977zm-0.30078 0.14453h44.73v0.15625h-44.73zm-0.45703 0.15625h45.488v0.14453h-45.488zm-0.45312 0.14453h46.395v0.15625h-46.395zm-0.44922 0.15625h47.145v0.15234h-47.145zm-0.30469 0.15234h47.75v0.14844h-47.75zm-0.44922 0.14844h48.504v0.15234h-48.504zm-0.45703 0.15234h49.262v0.14844h-49.262zm-0.30078 0.14844h49.867v0.15234h-49.867zm-0.30469 0.15234h50.473v0.15234h-50.473zm-0.44922 0.15234h51.223v0.14844h-51.223zm-0.30859 0.14844h51.832v0.15625h-51.832zm-0.30078 0.15625h52.434v0.14453h-52.434zm-0.45313 0.14453h53.043v0.15625h-53.043zm-0.30078 0.15625h53.645v0.15234h-53.645zm-0.30078 0.15234h54.246v0.14844h-54.246zm-0.30078 0.14844h54.852v0.15234h-54.852zm-0.45703 0.15234h55.457v0.14844h-55.457zm-0.30078 0.14844h56.059v0.15234h-56.059zm-0.30078 0.15234h56.668v0.15234h-56.668zm-0.30469 0.15234h57.121v0.14844h-57.121zm-0.30078 0.14844h57.723v0.15234h-57.723zm-0.30078 0.15234h58.328v0.14844h-58.328zm-0.15625 0.14844h58.785v0.15234h-58.785zm-0.30078 0.15234h59.234v0.15625h-59.234zm-0.30078 0.15625h59.844v0.14844h-59.844zm-0.30078 0.14844h60.445v0.15234h-60.445zm-0.30078 0.15234h61.047v0.14844h-61.047zm-0.30859 0.14844h61.508v0.15234h-61.508zm-0.30078 0.15234h62.109v0.15234h-62.109zm-0.14453 0.15234h62.555v0.14844h-62.555zm-0.30859 0.14844h63.164v0.15234h-63.164zm-0.30078 0.15234h63.621v0.14844h-63.621zm-0.14844 0.14844h64.07v0.15234h-64.07zm-0.30469 0.15234h64.676v0.15625h-64.676zm-0.30078 0.15625h65.129v0.14453h-65.129zm-0.30469 0.14453h65.734v0.15625h-65.734zm-0.15234 0.15625h66.188v0.14844h-66.188zm-0.30078 0.14844h66.789v0.15234h-66.789zm-0.30078 0.15234h67.246v0.15234h-67.246zm-0.30078 0.15234h67.848v0.14844h-67.848zm-0.15234 0.14844h68.301v0.15234h-68.301zm-0.30078 0.15234h68.906v0.14844h-68.906zm-0.30078 0.14844h69.355v0.15234h-69.355zm-0.30469 0.15234h69.961v0.15625h-69.961zm-0.15234 0.15625h70.422v0.14453h-70.422zm-0.30078 0.14453h70.867v0.15625h-70.867zm-0.30078 0.15625h71.469v0.14453h-71.469zm-0.15234 0.14453h71.93v0.15625h-71.93zm-0.30078 0.15625h72.531v0.15234h-72.531zm-0.30078 0.15234h72.98v0.14844h-72.98zm-0.30859 0.14844h73.594v0.15234h-73.594zm-0.14844 0.15234h74.047v0.14844h-74.047zm-0.30078 0.14844h74.648v0.15234h-74.648zm-0.30469 0.15234h75.105v0.15234h-75.105zm-0.30078 0.15234h75.707v0.14844h-75.707zm-0.14844 0.14844h76.156v0.15234h-76.156zm-0.30859 0.15234h76.766v0.14844h-76.766zm-0.30078 0.14844h77.219v0.15625h-77.219zm-0.14844 0.15625h77.668v0.15234h-77.668zm-0.30469 0.15234h78.277v0.14844h-78.277zm-0.30078 0.14844h78.73v0.15234h-78.73zm-0.30078 0.15234h79.332v0.14844h-79.332zm-0.15625 0.14844h79.789v0.15234h-79.789zm-0.30078 0.15234h80.391v0.15234h-80.391zm-0.30078 0.15234h80.844v0.14844h-80.844zm-0.30078 0.14844h81.445v0.15234h-81.445zm-0.15234 0.15234h81.898v0.14844h-81.898zm-0.30078 0.14844h82.508v0.15234h-82.508zm-0.30078 0.15234h82.957v0.15625h-82.957zm-0.30078 0.15625h83.559v0.14844h-83.559zm-0.15625 0.14844h84.02v0.15234h-84.02zm-0.30078 0.15234h84.621v0.14844h-84.621zm-0.30078 0.14844h85.07v0.15234h-85.07zm-0.15234 0.15234h85.531v0.15234h-85.531zm-0.30078 0.15234h86.133v0.14844h-86.133zm-0.30078 0.14844h86.582v0.15234h-86.582zm-0.30859 0.15234h87.195v0.14844h-87.195zm-0.14453 0.14844h87.641v0.15234h-87.641zm-0.30469 0.15234h88.246v0.15625h-88.246zm-0.30469 0.15625h88.707v0.14453h-88.707zm-0.30078 0.14453h89.309v0.15625h-89.309zm-0.14844 0.15625h89.758v0.14453h-89.758zm-0.30859 0.14453h90.367v0.15625h-90.367zm-0.30078 0.15625h90.82v0.15234h-90.82zm-0.30078 0.15234h91.422v0.14844h-91.422zm-0.15234 0.14844h91.875v0.15234h-91.875zm-0.30078 0.15234h92.477v0.14844h-92.477zm-0.30078 0.14844h92.934v0.15234h-92.934zm-0.15234 0.15234h93.387v0.15625h-93.387zm-0.30078 0.15625h93.988v0.14453h-93.988zm-0.30469 0.14453h94.445v0.15625h-94.445zm-0.30078 0.15625h95.047v0.14453h-95.047zm-0.15234 0.14453h95.5v0.15625h-95.5zm-0.30078 0.15625h96.109v0.15234h-96.109zm-0.30078 0.15234h96.559v0.14844h-96.559zm-0.30078 0.14844h97.16v0.15234h-97.16zm-0.15234 0.15234h97.617v0.14844h-97.617zm-0.30078 0.14844h98.219v0.15234h-98.219zm-0.30078 0.15234h98.668v0.15234h-98.668zm-0.30859 0.15234h99.285v0.14844h-99.285zm-0.14844 0.14844h99.734v0.15234h-99.734zm-0.30078 0.15234h100.18v0.14844h-100.18zm-0.30469 0.14844h100.79v0.15625h-100.79zm-0.14844 0.15625h101.24v0.15234h-101.24zm-0.30078 0.15234h101.84v0.14844h-101.84zm-0.30859 0.14844h102.3v0.15234h-102.3zm-0.30078 0.15234h102.91v0.14844h-102.91zm-0.14844 0.14844h103.36v0.15234h-103.36zm-0.30469 0.15234h103.96v0.15234h-103.96zm-0.30078 0.15234h104.42v0.14844h-104.42zm-0.30078 0.14844h105.02v0.15234h-105.02zm-0.15625 0.15234h105.48v0.14844h-105.48zm-0.30078 0.14844h106.08v0.15234h-106.08zm-0.30078 0.15234h106.53v0.15625h-106.53zm-0.15234 0.15625h106.98v0.14453h-106.98zm-0.30078 0.14453h107.59v0.15625h-107.59zm-0.30078 0.15625h108.04v0.14844h-108.04zm-0.30078 0.14844h108.64v0.15234h-108.64zm-0.15625 0.15234h109.1v0.15234h-109.1zm-0.30078 0.15234h109.71v0.14844h-109.71zm-0.30078 0.14844h110.16v0.15234h-110.16zm-0.30078 0.15234h110.76v0.14844h-110.76zm-0.15234 0.14844h111.22v0.15234h-111.22zm-0.30078 0.15234h111.82v0.15625h-111.82zm-0.30078 0.15625h112.27v0.14453h-112.27zm-0.30859 0.14453h112.88v0.15625h-112.88zm-0.14844 0.15625h113.33v0.14453h-113.33zm-0.30078 0.14453h113.94v0.15625h-113.94zm-0.30469 0.15625h114.39v0.15234h-114.39zm-0.14844 0.15234h114.84v0.14844h-114.84zm-0.30078 0.14844h115.45v0.15234h-115.45zm-0.30859 0.15234h115.91v0.14844h-115.91zm-0.30078 0.14844h116.51v0.15234h-116.51zm-0.14844 0.15234h116.96v0.15234h-116.96zm-0.30469 0.15234h117.56v0.14844h-117.56zm-0.30078 0.14844h118.02v0.15625h-118.02zm-0.30078 0.15625h118.62v0.14453h-118.62zm-0.15625 0.14453h119.08v0.15625h-119.08zm-0.30078 0.15625h119.68v0.15234h-119.68zm-0.30078 0.15234h120.13v0.14844h-120.13zm-0.30078 0.14844h120.73v0.15234h-120.73zm-0.15234 0.15234h121.19v0.14844h-121.19zm-0.30078 0.14844h121.64v0.15234h-121.64zm-0.30078 0.15234h122.25v0.15234h-122.25zm-0.15234 0.15234h122.7v0.14844h-122.7zm-0.30469 0.14844h123.31v0.15234h-123.31zm-0.30078 0.15234h123.76v0.14844h-123.76zm-0.30078 0.14844h124.36v0.15234h-124.36zm-0.15234 0.15234h124.82v0.15625h-124.82zm-0.30078 0.15625h125.42v0.14844h-125.42zm-0.30078 0.14844h125.87v0.15234h-125.87zm-0.30859 0.15234h126.48v0.14844h-126.48zm-0.14453 0.14844h126.93v0.15234h-126.93zm-0.30078 0.15234h127.53v0.15234h-127.53zm-0.30859 0.15234h128v0.14844h-128zm-0.30078 0.14844h128.6v0.15234h-128.6zm-0.14844 0.15234h129.05v0.14844h-129.05zm-0.30469 0.14844h129.5v0.15234h-129.5zm-0.30469 0.15234h130.11v0.15625h-130.11zm-0.14453 0.15625h130.55v0.14453h-130.55zm-0.30859 0.14453h131.16v0.15625h-131.16zm-0.30078 0.15625h131.62v0.14844h-131.62zm-0.30078 0.14844h132.22v0.15234h-132.22zm-0.15234 0.15234h132.68v0.15234h-132.68zm-0.30078 0.15234h133.28v0.14844h-133.28zm-0.30078 0.14844h133.73v0.15234h-133.73zm-0.30469 0.15234h134.34v0.14844h-134.34zm-0.15234 0.14844h134.79v0.15234h-134.79zm-0.30078 0.15234h135.4v0.15625h-135.4zm-0.30078 0.15625h135.84v0.14453h-135.84zm-0.15234 0.14453h136.3v0.15625h-136.3zm-0.30078 0.15625h136.91v0.14453h-136.91zm-0.30078 0.14453h137.36v0.15625h-137.36zm-0.30078 0.15625h137.96v0.15234h-137.96zm-0.15625 0.15234h138.42v0.14844h-138.42zm-0.30078 0.14844h139.02v0.15234h-139.02zm-0.30078 0.15234h139.47v0.14844h-139.47zm-0.30469 0.14844h140.08v0.15234h-140.08zm-0.14844 0.15234h140.53v0.15234h-140.53zm-0.30078 0.15234h141.13v0.14844h-141.13zm-0.30859 0.14844h141.59v0.15234h-141.59zm-0.30078 0.15234h142.2v0.14844h-142.2zm-0.14844 0.14844h142.65v0.15625h-142.65zm-0.30469 0.15625h143.25v0.15234h-143.25zm-0.30078 0.15234h143.71v0.14844h-143.71zm-0.14844 0.14844h144.16v0.15234h-144.16zm-0.30859 0.15234h144.77v0.14844h-144.77zm-0.30078 0.14844h145.22v0.15234h-145.22zm-0.30078 0.15234h145.82v0.15234h-145.82zm-0.15234 0.15234h146.27v0.14844h-146.27zm-0.30078 0.14844h146.88v0.15234h-146.88zm-0.30078 0.15234h147.33v0.14844h-147.33zm-0.30078 0.14844h147.93v0.15234h-147.93zm-0.15625 0.15234h148.39v0.15625h-148.39zm-0.30078 0.15625h149v0.14844h-149zm-0.30078 0.14844h149.45v0.15234h-149.45zm-0.30078 0.15234h150.05v0.14844h-150.05zm-0.15234 0.14844h150.51v0.15234h-150.51zm-0.30078 0.15234h150.96v0.15234h-150.96zm-0.30078 0.15234h151.56v0.14844h-151.56zm-0.15625 0.14844h152.02v0.15234h-152.02zm-0.30078 0.15234h152.62v0.14844h-152.62zm-0.30078 0.14844h153.07v0.15234h-153.07zm-0.30469 0.15234h153.68v0.15625h-153.68zm-0.14844 0.15625h154.13v0.14453h-154.13zm-0.30078 0.14453h154.73v0.15625h-154.73zm-0.30859 0.15625h155.2v0.14453h-155.2zm-0.30078 0.14453h155.8v0.15625h-155.8zm-0.14453 0.15625h156.24v0.15234h-156.24zm-0.30859 0.15234h156.85v0.14844h-156.85zm-0.30078 0.14844h157.31v0.15234h-157.31zm-0.30078 0.15234h157.91v0.14844h-157.91zm-0.15234 0.14844h158.36v0.15234h-158.36zm-0.30469 0.15234h158.82v0.15234h-158.82zm-0.30078 0.15234h159.42v0.14844h-159.42zm-0.15234 0.14844h159.88v0.15625h-159.88zm-0.30078 0.15625h160.48v0.14453h-160.48zm-0.30078 0.14453h160.93v0.15625h-160.93zm-0.30078 0.15625h161.54v0.15234h-161.54zm-0.15234 0.15234h161.99v0.14844h-161.99zm-0.30078 0.14844h162.59v0.15234h-162.59zm-0.30469 0.15234h163.05v0.14844h-163.05zm-0.30078 0.14844h163.65v0.15234h-163.65zm-0.15234 0.15234h164.11v0.15234h-164.11zm-0.30078 0.15234h164.71v0.14844h-164.71zm-0.30078 0.14844h165.16v0.15234h-165.16zm-0.15234 0.15234h165.62v0.14844h-165.62zm-0.30078 0.14844h166.22v0.15625h-166.22zm-0.30078 0.15625h166.67v0.15234h-166.67zm-0.30859 0.15234h167.29v0.14844h-167.29zm-0.14844 0.14844h167.73v0.15234h-167.73zm-0.30078 0.15234h168.34v0.14844h-168.34zm-0.30469 0.14844h168.79v0.15234h-168.79zm-0.30078 0.15234h169.39v0.15234h-169.39zm-0.14844 0.15234h169.84v0.14844h-169.84zm-0.30859 0.14844h170.45v0.15234h-170.45zm-0.30078 0.15234h170.91v0.14844h-170.91zm-0.30078 0.14844h171.51v0.15234h-171.51zm-0.15234 0.15234h171.96v0.15625h-171.96zm-0.30078 0.15625h172.57v0.14453h-172.57zm-0.30078 0.14453h173.02v0.15625h-173.02zm-0.15625 0.15625h173.48v0.14844h-173.48zm-0.30078 0.14844h174.08v0.15234h-174.08zm-0.30078 0.15234h174.53v0.15234h-174.53zm-0.30078 0.15234h175.13v0.14844h-175.13zm-0.15234 0.14844h175.59v0.15234h-175.59zm-0.30078 0.15234h176.2v0.14844h-176.2zm-0.30078 0.14844h176.64v0.15234h-176.64zm-0.30078 0.15234h177.25v0.15625h-177.25zm-0.15625 0.15625h177.71v0.14453h-177.71zm-0.30078 0.14453h178.31v0.15625h-178.31zm-0.30078 0.15625h178.76v0.14453h-178.76zm-0.30469 0.14453h179.37v0.15625h-179.37zm-0.14844 0.15625h179.82v0.15234h-179.82zm-0.30078 0.15234h180.27v0.14844h-180.27zm-0.30859 0.14844h180.88v0.15234h-180.88zm-0.14844 0.15234h181.33v0.14844h-181.33zm-0.30078 0.14844h181.93v0.15234h-181.93zm-0.30469 0.15234h182.39v0.15234h-182.39zm-0.30078 0.15234h183v0.14844h-183zm-0.14844 0.14844h183.45v0.15625h-183.45zm-0.30859 0.15625h184.05v0.14453h-184.05zm-0.30078 0.14453h184.51v0.15625h-184.51zm-0.30078 0.15625h185.11v0.15234h-185.11zm-0.15234 0.15234h185.56v0.14844h-185.56zm-0.30078 0.14844h186.16v0.15234h-186.16zm-0.30078 0.15234h186.62v0.14844h-186.62zm-0.15234 0.14844h187.07v0.15234h-187.07zm-0.30469 0.15234h187.68v0.15234h-187.68zm-0.30078 0.15234h188.13v0.14844h-188.13zm-0.30078 0.14844h188.73v0.15234h-188.73zm-0.15234 0.15234h189.19v0.14844h-189.19zm-0.30078 0.14844h189.8v0.15234h-189.8zm-0.30078 0.15234h190.25v0.15625h-190.25zm-0.30078 0.15625h190.85v0.14844h-190.85zm-0.15234 0.14844h191.3v0.15234h-191.3zm-0.30469 0.15234h191.91v0.14844h-191.91zm-0.30078 0.14844h192.36v0.15234h-192.36zm-0.30469 0.15234h192.97v0.15234h-192.97zm-0.14844 0.15234h193.42v0.14844h-193.42zm-0.30078 0.14844h194.02v0.15234h-194.02zm-0.30859 0.15234h194.48v0.14844h-194.48zm-0.14453 0.14844h194.93v0.15234h-194.93zm-0.30078 0.15234h195.53v0.15625h-195.53zm-0.30859 0.15625h196v0.14453h-196zm-0.30078 0.14453h196.6v0.15625h-196.6zm-0.14844 0.15625h197.05v0.14844h-197.05zm-0.30469 0.14844h197.65v0.15234h-197.65zm-0.30078 0.15234h198.11v0.15234h-198.11zm-0.30469 0.15234h198.71v0.14844h-198.71zm-0.15234 0.14844h199.16v0.15234h-199.16zm-0.30078 0.15234h199.77v0.14844h-199.77zm-0.30078 0.14844h200.22v0.15234h-200.22zm-0.30078 0.15234h200.82v0.15625h-200.82zm-0.15234 0.15625h201.28v0.14453h-201.28zm-0.30078 0.14453h201.88v0.15625h-201.88zm-0.30078 0.15625h202.33v0.14453h-202.33zm-0.15625 0.14453h202.79v0.15625h-202.79zm-0.30078 0.15625h203.4v0.15234h-203.4zm-0.30078 0.15234h203.84v0.14844h-203.84zm-0.30078 0.14844h204.45v0.15234h-204.45zm-0.15234 0.15234h204.91v0.14844h-204.91zm-0.30078 0.14844h205.51v0.15234h-205.51zm-0.30078 0.15234h205.96v0.15234h-205.96zm-0.30859 0.15234h206.57v0.14844h-206.57zm-0.14844 0.14844h207.02v0.15234h-207.02zm-0.30078 0.15234h207.62v0.14844h-207.62zm-0.30469 0.14844h208.08v0.15625h-208.08zm-0.30078 0.15625h208.68v0.15234h-208.68zm-0.14844 0.15234h209.13v0.14844h-209.13zm-0.30859 0.14844h209.59v0.15234h-209.59zm-0.30078 0.15234h210.2v0.14844h-210.2zm-0.14844 0.14844h210.64v0.15234h-210.64zm-0.30469 0.15234h211.25v0.15234h-211.25zm-0.30078 0.15234h211.71v0.14844h-211.71zm-0.30078 0.14844h212.31v0.15234h-212.31zm-0.15625 0.15234h212.77v0.14844h-212.77zm-0.30078 0.14844h213.37v0.15234h-213.37zm-0.30078 0.15234h213.82v0.15625h-213.82zm-0.30078 0.15625h214.42v0.14844h-214.42zm-0.15234 0.14844h214.88v0.15234h-214.88zm-0.30078 0.15234h215.48v0.14844h-215.48zm-0.30078 0.14844h215.93v0.15234h-215.93zm-0.15625 0.15234h216.39v0.15234h-216.39zm-0.30078 0.15234h217v0.14844h-217zm-0.30078 0.14844h217.45v0.15234h-217.45zm-0.30078 0.15234h218.05v0.14844h-218.05zm-0.15234 0.14844h218.51v0.15234h-218.51zm-0.30078 0.15234h219.11v0.15625h-219.11zm-0.30078 0.15625h219.56v0.14453h-219.56zm-0.30859 0.14453h220.17v0.15625h-220.17zm-0.14844 0.15625h220.62v0.14453h-220.62zm-0.30078 0.14453h221.22v0.15625h-221.22zm-0.30469 0.15625h221.68v0.15234h-221.68zm-0.30078 0.15234h222.29v0.14844h-222.29zm-0.14844 0.14844h222.73v0.15234h-222.73zm-0.30859 0.15234h223.34v0.14844h-223.34zm-0.30078 0.14844h223.8v0.15234h-223.8zm-0.14453 0.15234h224.24v0.15234h-224.24zm-0.30859 0.15234h224.85v0.14844h-224.85zm-0.30078 0.14844h225.31v0.15625h-225.31zm-0.30078 0.15625h225.91v0.14453h-225.91zm-0.15234 0.14453h226.36v0.15625h-226.36zm-0.30078 0.15625h226.96v0.15234h-226.96zm-0.30469 0.15234h227.42v0.14844h-227.42zm-0.30078 0.14844h228.02v0.15234h-228.02zm-0.15234 0.15234h228.48v0.14844h-228.48zm-0.30078 0.14844h229.09v0.15234h-229.09zm-0.30078 0.15234h229.54v0.15234h-229.54zm-0.30078 0.15234h230.14v0.14844h-230.14zm-0.15234 0.14844h230.59v0.15234h-230.59zm-0.30078 0.15234h231.04v0.14844h-231.04zm-0.30469 0.14844h231.65v0.15625h-231.65zm-0.15234 0.15625h232.11v0.15234h-232.11zm-0.30078 0.15234h232.71v0.14844h-232.71zm-0.30078 0.14844h233.16v0.15234h-233.16zm-0.30859 0.15234h233.77v0.14844h-233.77zm-0.14453 0.14844h234.22v0.15234h-234.22zm-0.30078 0.15234h234.82v0.15234h-234.82zm-0.30859 0.15234h235.28v0.14844h-235.28zm-0.30078 0.14844h235.89v0.15234h-235.89zm-0.14844 0.15234h236.34v0.14844h-236.34zm-0.30469 0.14844h236.94v0.15234h-236.94zm-0.30078 0.15234h237.39v0.15625h-237.39zm-0.30078 0.15625h238v0.14453h-238zm-0.15625 0.14453h238.45v0.15625h-238.45zm-0.30078 0.15625h238.91v0.14844h-238.91zm-0.30078 0.14844h239.51v0.15234h-239.51zm-0.15234 0.15234h239.96v0.15234h-239.96zm-0.30078 0.15234h240.57v0.14844h-240.57zm-0.30078 0.14844h241.02v0.15234h-241.02zm-0.30078 0.15234h241.62v0.14844h-241.62zm-0.15625 0.14844h242.08v0.15234h-242.08zm-0.30078 0.15234h242.69v0.15625h-242.69zm-0.30078 0.15625h243.13v0.14453h-243.13zm-0.30078 0.14453h243.73v0.15625h-243.73zm-0.15234 0.15625h244.2v0.14453h-244.2zm-0.30078 0.14453h244.8v0.15625h-244.8zm-0.30078 0.15625h245.25v0.15234h-245.25zm-0.15625 0.15234h245.71v0.14844h-245.71zm-0.30078 0.14844h246.31v0.15234h-246.31zm-0.30078 0.15234h246.76v0.14844h-246.76zm-0.30469 0.14844h247.37v0.15234h-247.37zm-0.14844 0.15234h247.82v0.15234h-247.82zm-0.30078 0.15234h248.42v0.14844h-248.42zm-0.30859 0.14844h248.88v0.15625h-248.88zm-0.30078 0.15625h249.48v0.14453h-249.48zm-0.14844 0.14453h249.93v0.15625h-249.93zm-0.30469 0.15625h250.54v0.15234h-250.54zm-0.30078 0.15234h251v0.14844h-251zm-0.30078 0.14844h251.6v0.15234h-251.6zm-0.15625 0.15234h252.05v0.14844h-252.05zm-0.30078 0.14844h252.66v0.15234h-252.66zm-0.30078 0.15234h253.11v0.15234h-253.11zm-0.15234 0.15234h253.56v0.14844h-253.56zm-0.30078 0.14844h254.16v0.15234h-254.16zm-0.30078 0.15234h254.62v0.14844h-254.62zm-0.30078 0.14844h255.22v0.15234h-255.22zm-0.15234 0.15234h255.68v0.15625h-255.68zm-0.30469 0.15625h256.29v0.14844h-256.29zm-0.30078 0.14844h256.73v0.15234h-256.73zm-0.30078 0.15234h257.34v0.14844h-257.34zm-0.15234 0.14844h257.8v0.15234h-257.8zm-0.30078 0.15234h258.4v0.15234h-258.4zm-0.30078 0.15234h258.85v0.14844h-258.85zm-0.30859 0.14844h259.46v0.15234h-259.46zm-0.14453 0.15234h259.91v0.14844h-259.91zm-0.30469 0.14844h260.36v0.15234h-260.36zm-0.30469 0.15234h260.97v0.15625h-260.97zm-0.14844 0.15625h261.42v0.14453h-261.42zm-0.30078 0.14453h262.02v0.15625h-262.02zm-0.30859 0.15625h262.48v0.14453h-262.48zm-0.30078 0.14453h263.09v0.15625h-263.09zm-0.14453 0.15625h263.53v0.15234h-263.53zm-0.30859 0.15234h264.14v0.14844h-264.14zm-0.30078 0.14844h264.6v0.15234h-264.6zm-0.30078 0.15234h265.2v0.14844h-265.2zm-0.15234 0.14844h265.65v0.15234h-265.65zm-0.30078 0.15234h266.25v0.15625h-266.25zm-0.30078 0.15625h266.71v0.14453h-266.71zm-0.30469 0.14453h267.31v0.15625h-267.31zm-0.15234 0.15625h267.77v0.14453h-267.77zm-0.30078 0.14453h268.22v0.15625h-268.22zm-0.30078 0.15625h268.82v0.15234h-268.82zm-0.15234 0.15234h269.28v0.14844h-269.28zm-0.30078 0.14844h269.88v0.15234h-269.88zm-0.30078 0.15234h270.33v0.14844h-270.33zm-0.30078 0.14844h270.93v0.15234h-270.93zm-0.15625 0.15234h271.4v0.15234h-271.4zm-0.30078 0.15234h272v0.14844h-272zm-0.30078 0.14844h272.45v0.15234h-272.45zm-0.30469 0.15234h273.06v0.14844h-273.06zm-0.14844 0.14844h273.51v0.15625h-273.51zm-0.30078 0.15625h274.11v0.15234h-274.11zm-0.30859 0.15234h274.57v0.14844h-274.57zm-0.14844 0.14844h275.02v0.15234h-275.02zm-0.30078 0.15234h275.62v0.14844h-275.62zm-0.30469 0.14844h276.08v0.15234h-276.08zm-0.30078 0.15234h276.68v0.15234h-276.68zm-0.14844 0.15234h277.13v0.14844h-277.13zm-0.30859 0.14844h277.74v0.15234h-277.74zm-0.30078 0.15234h278.2v0.14844h-278.2zm-0.30078 0.14844h278.8v0.15234h-278.8zm-0.15234 0.15234h279.25v0.15625h-279.25zm-0.30078 0.15625h279.86v0.14844h-279.86zm-0.30078 0.14844h280.31v0.15234h-280.31zm-0.30078 0.15234h280.91v0.14844h-280.91zm-0.15625 0.14844h281.37v0.15234h-281.37zm-0.30078 0.15234h281.98v0.15234h-281.98zm-0.30078 0.15234h282.42v0.14844h-282.42zm-0.15234 0.14844h282.88v0.15234h-282.88zm-0.30078 0.15234h283.48v0.14844h-283.48zm-0.30078 0.14844h283.93v0.15234h-283.93zm-0.30078 0.15234h284.54v0.15625h-284.54zm-0.15625 0.15625h285v0.14453h-285zm-0.30078 0.14453h285.6v0.15625h-285.6zm-0.30078 0.15625h286.05v0.14453h-286.05zm-0.30469 0.14453h286.66v0.15625h-286.66zm-0.14844 0.15625h287.11v0.15234h-287.11zm-0.30078 0.15234h287.71v0.14844h-287.71zm-0.30859 0.14844h288.17v0.15234h-288.17zm-0.30078 0.15234h288.77v0.14844h-288.77zm-0.14844 0.14844h289.22v0.15234h-289.22zm-0.30469 0.15234h289.68v0.15234h-289.68zm-0.30078 0.15234h290.29v0.14844h-290.29zm-0.14844 0.14844h290.73v0.15625h-290.73zm-0.30859 0.15625h291.34v0.14453h-291.34zm-0.30078 0.14453h291.8v0.15625h-291.8zm-0.30078 0.15625h292.4v0.15234h-292.4zm-0.15234 0.15234h292.85v0.14844h-292.85zm-0.30078 0.14844h293.45v0.15234h-293.45zm-0.30078 0.15234h293.91v0.14844h-293.91zm-0.30078 0.14844h294.51v0.15234h-294.51zm-0.15234 0.15234h294.96v0.15234h-294.96zm-0.30078 0.15234h295.57v0.14844h-295.57zm-0.30469 0.14844h296.02v0.15234h-296.02zm-0.15234 0.15234h296.48v0.14844h-296.48zm-0.30078 0.14844h297.09v0.15625h-297.09zm-0.30078 0.15625h297.54v0.15234h-297.54zm-0.30078 0.15234h298.14v0.14844h-298.14zm-0.15234 0.14844h298.59v0.15234h-298.59zm-0.30078 0.15234h299.2v0.14844h-299.2zm-0.30078 0.14844h299.64v0.15234h-299.64zm-0.30859 0.15234h300.26v0.15234h-300.26zm-0.14844 0.15234h300.71v0.14844h-300.71zm-0.30078 0.14844h301.31v0.15234h-301.31zm-0.30469 0.15234h301.77v0.14844h-301.77zm-0.30469 0.14844h302.38v0.15234h-302.38zm-0.14453 0.15234h302.82v0.15625h-302.82zm-0.30859 0.15625h303.43v0.14453h-303.43zm-0.30078 0.14453h303.88v0.15625h-303.88zm-0.14844 0.15625h304.34v0.14844h-304.34zm-0.30469 0.14844h304.94v0.15234h-304.94zm-0.30078 0.15234h305.39v0.15234h-305.39zm-0.30078 0.15234h306v0.14844h-306zm-0.15625 0.14844h306.45v0.15234h-306.45zm-0.30078 0.15234h307.05v0.14844h-307.05zm-0.30078 0.14844h307.51v0.15234h-307.51zm-0.30078 0.15234h308.11v0.15625h-308.11zm-0.15234 0.15625h308.57v0.14453h-308.57zm-0.30078 0.14453h309.17v0.15625h-309.17zm-0.30078 0.15625h309.62v0.14453h-309.62zm-0.30078 0.14453h310.22v0.15625h-310.22zm-0.15625 0.15625h310.69v0.15234h-310.69zm-0.30078 0.15234h311.29v0.14844h-311.29zm-0.30078 0.14844h311.73v0.15234h-311.73zm-0.15234 0.15234h312.2v0.14844h-312.2zm-0.30078 0.14844h312.8v0.15234h-312.8zm-0.30078 0.15234h313.25v0.15234h-313.25zm-0.30859 0.15234h313.86v0.14844h-313.86zm-0.14844 0.14844h314.31v0.15625h-314.31zm-0.30078 0.15625h314.91v0.14453h-314.91zm-0.30469 0.14453h315.37v0.15625h-315.37zm-0.30078 0.15625h315.97v0.15234h-315.97zm-0.14844 0.15234h316.42v0.14844h-316.42zm-0.30859 0.14844h317.03v0.15234h-317.03zm-0.30078 0.15234h317.48v0.14844h-317.48zm-0.30078 0.14844h318.09v0.15234h-318.09zm-0.15234 0.15234h318.54v0.15234h-318.54zm-0.30078 0.15234h319v0.14844h-319zm-0.30078 0.14844h319.6v0.15234h-319.6zm-0.15234 0.15234h320.05v0.14844h-320.05zm-0.30469 0.14844h320.66v0.15234h-320.66zm-0.30078 0.15234h321.11v0.15625h-321.11zm-0.30078 0.15625h321.71v0.14844h-321.71zm-0.15234 0.14844h322.16v0.15234h-322.16zm-0.30078 0.15234h322.77v0.14844h-322.77zm-0.30078 0.14844h323.22v0.15234h-323.22zm-0.30078 0.15234h323.82v0.15234h-323.82zm-0.15234 0.15234h324.28v0.14844h-324.28zm-0.30469 0.14844h324.89v0.15234h-324.89zm-0.30078 0.15234h325.34v0.14844h-325.34zm-0.15234 0.14844h325.8v0.15234h-325.8zm-0.30078 0.15234h326.4v0.15625h-326.4zm-0.30078 0.15625h326.85v0.14453h-326.85zm-0.30859 0.14453h327.46v0.15625h-327.46zm-0.14453 0.15625h327.91v0.14453h-327.91zm-0.30078 0.14453h328.51v0.15625h-328.51zm-0.30859 0.15625h328.97v0.15234h-328.97zm-0.30078 0.15234h329.57v0.14844h-329.57zm-0.14844 0.14844h330.02v0.15234h-330.02zm-0.30469 0.15234h330.63v0.14844h-330.63zm-0.30469 0.14844h331.09v0.15234h-331.09zm-0.30078 0.15234h331.69v0.15625h-331.69zm-0.15234 0.15625h332.14v0.14453h-332.14zm-0.30078 0.14453h332.74v0.15625h-332.74zm-0.30078 0.15625h333.2v0.14453h-333.2zm-0.15234 0.14453h333.65v0.15625h-333.65zm-0.30078 0.15625h334.25v0.15234h-334.25zm-0.30078 0.15234h334.71v0.14844h-334.71zm-0.30078 0.14844h335.31v0.15234h-335.31zm-0.15625 0.15234h335.77v0.14844h-335.77zm-0.30078 0.14844h336.38v0.15234h-336.38zm-0.30078 0.15234h336.82v0.15234h-336.82zm-0.30078 0.15234h337.43v0.14844h-337.43zm-0.15234 0.14844h337.88v0.15234h-337.88zm-0.30078 0.15234h338.48v0.14844h-338.48zm-0.30078 0.14844h338.93v0.15625h-338.93zm-0.30859 0.15625h339.55v0.15234h-339.55zm-0.14844 0.15234h340v0.14844h-340zm-0.30078 0.14844h340.45v0.15234h-340.45zm-0.30469 0.15234h341.06v0.14844h-341.06zm-0.14844 0.14844h341.51v0.15234h-341.51zm-0.30078 0.15234h342.11v0.15234h-342.11zm-0.30859 0.15234h342.57v0.14844h-342.57zm-0.30078 0.14844h343.17v0.15234h-343.17zm-0.14844 0.15234h343.62v0.14844h-343.62zm-0.30469 0.14844h344.23v0.15234h-344.23zm-0.30078 0.15234h344.68v0.15625h-344.68zm-0.30078 0.15625h345.29v0.14844h-345.29zm-0.15625 0.14844h345.74v0.15234h-345.74zm-0.30078 0.15234h346.34v0.14844h-346.34zm-0.30078 0.14844h346.8v0.15234h-346.8zm-0.30078 0.15234h347.4v0.15234h-347.4zm-0.15234 0.15234h347.85v0.14844h-347.85zm-0.30078 0.14844h348.31v0.15234h-348.31zm-0.30078 0.15234h348.91v0.14844h-348.91zm-0.15625 0.14844h349.37v0.15234h-349.37zm-0.30078 0.15234h349.97v0.15625h-349.97zm-0.30078 0.15625h350.42v0.14453h-350.42zm-0.30078 0.14453h351.02v0.15625h-351.02zm-0.15234 0.15625h351.48v0.14453h-351.48zm-0.30078 0.14453h352.09v0.15625h-352.09zm-0.30078 0.15625h352.54v0.15234h-352.54zm-0.30859 0.15234h353.15v0.14844h-353.15zm-0.14844 0.14844h353.6v0.15234h-353.6zm-0.30078 0.15234h354.2v0.14844h-354.2zm-0.30469 0.14844h354.66v0.15234h-354.66zm-0.14844 0.15234h355.11v0.15234h-355.11zm-0.30078 0.15234h355.71v0.14844h-355.71zm-0.30859 0.14844h356.17v0.15625h-356.17zm-0.30078 0.15625h356.77v0.14453h-356.77zm-0.14453 0.14453h357.22v0.15625h-357.22zm-0.30859 0.15625h357.83v0.15234h-357.83zm-0.30078 0.15234h358.29v0.14844h-358.29zm-0.30078 0.14844h358.89v0.15234h-358.89zm-0.15234 0.15234h359.34v0.14844h-359.34zm-0.30469 0.14844h359.95v0.15234h-359.95zm-0.30078 0.15234h360.4v0.15234h-360.4zm-0.30078 0.15234h361v0.14844h-361zm-0.15234 0.14844h361.45v0.15234h-361.45zm-0.30078 0.15234h362.06v0.14844h-362.06zm-0.30078 0.14844h362.51v0.15625h-362.51zm-0.15234 0.15625h362.96v0.15234h-362.96zm-0.30078 0.15234h363.57v0.14844h-363.57zm-0.30078 0.14844h364.02v0.15234h-364.02zm-0.30469 0.15234h364.62v0.14844h-364.62zm-0.15234 0.14844h365.09v0.15234h-365.09zm-0.30078 0.15234h365.69v0.15234h-365.69zm-0.30078 0.15234h366.14v0.14844h-366.14zm-0.30859 0.14844h366.75v0.15234h-366.75zm-0.14453 0.15234h367.2v0.14844h-367.2zm-0.30078 0.14844h367.8v0.15234h-367.8zm-0.30859 0.15234h368.26v0.15625h-368.26zm-0.30078 0.15625h368.86v0.14453h-368.86zm-0.14844 0.14453h369.31v0.15625h-369.31zm-0.30469 0.15625h369.77v0.14844h-369.77zm-0.30078 0.14844h370.37v0.15234h-370.37zm-0.14844 0.15234h370.82v0.15234h-370.82zm-0.30859 0.15234h371.43v0.14844h-371.43zm-0.30078 0.14844h371.88v0.15234h-371.88zm-0.30078 0.15234h372.48v0.14844h-372.48zm-0.15234 0.14844h372.94v0.15234h-372.94zm-0.30078 0.15234h373.54v0.15625h-373.54zm-0.30078 0.15625h374v0.14453h-374zm-0.30078 0.14453h374.6v0.15625h-374.6zm-0.15625 0.15625h375.05v0.14453h-375.05zm-0.30078 0.14453h375.66v0.15625h-375.66zm-0.30078 0.15625h376.11v0.15234h-376.11zm-0.30078 0.15234h376.71v0.14844h-376.71zm-0.15234 0.14844h377.17v0.15234h-377.17zm-0.30078 0.15234h377.62v0.14844h-377.62zm-0.30078 0.14844h378.22v0.15234h-378.22zm-0.15625 0.15234h378.68v0.15234h-378.68zm-0.30078 0.15234h379.29v0.14844h-379.29zm-0.30078 0.14844h379.73v0.15625h-379.73zm-0.30469 0.15625h380.35v0.14453h-380.35zm-0.14844 0.14453h380.8v0.15625h-380.8zm-0.30078 0.15625h381.4v0.15234h-381.4zm-0.30859 0.15234h381.86v0.14844h-381.86zm-0.30078 0.14844h382.46v0.15234h-382.46zm-0.14844 0.15234h382.91v0.14844h-382.91zm-0.30469 0.14844h383.52v0.15234h-383.52zm-0.30078 0.15234h383.97v0.15234h-383.97zm-0.14844 0.15234h384.42v0.14844h-384.42zm-0.30859 0.14844h385.03v0.15234h-385.03zm-0.30078 0.15234h385.48v0.14844h-385.48zm-0.30078 0.14844h386.09v0.15234h-386.09zm-0.15234 0.15234h386.54v0.15625h-386.54zm-0.30078 0.15625h387.14v0.14844h-387.14zm-0.30078 0.14844h387.6v0.15234h-387.6zm-0.30078 0.15234h388.2v0.14844h-388.2zm-0.15234 0.14844h388.65v0.15234h-388.65zm-0.30469 0.15234h389.26v0.15234h-389.26zm-0.30078 0.15234h389.71v0.14844h-389.71zm-0.30078 0.14844h390.31v0.15234h-390.31zm-0.15234 0.15234h390.77v0.14844h-390.77zm-0.30078 0.14844h391.38v0.15234h-391.38zm-0.30078 0.15234h391.82v0.15625h-391.82zm-0.15234 0.15625h392.28v0.14453h-392.28zm-0.30078 0.14453h392.88v0.15625h-392.88zm-0.30469 0.15625h393.34v0.14453h-393.34zm-0.30469 0.14453h393.95v0.15625h-393.95zm-0.14844 0.15625h394.4v0.15234h-394.4zm-0.30078 0.15234h395v0.14844h-395zm-0.30859 0.14844h395.46v0.15234h-395.46zm-0.30078 0.15234h396.06v0.14844h-396.06zm-0.14453 0.14844h396.51v0.15234h-396.51zm-0.30859 0.15234h397.12v0.15625h-397.12zm-0.30078 0.15625h397.57v0.14453h-397.57zm-0.30078 0.14453h398.18v0.15625h-398.18zm-0.15234 0.15625h398.63v0.14453h-398.63zm-0.30078 0.14453h399.08v0.15625h-399.08zm-0.30469 0.15625h399.69v0.15234h-399.69zm-0.15234 0.15234h400.14v0.14844h-400.14zm-0.30078 0.14844h400.74v0.15234h-400.74zm-0.30078 0.15234h401.2v0.14844h-401.2zm-0.30078 0.14844h401.8v0.15234h-401.8zm-0.15234 0.15234h402.25v0.15234h-402.25zm-0.30078 0.15234h402.86v0.14844h-402.86zm-0.30078 0.14844h403.31v0.15234h-403.31zm-0.30078 0.15234h403.91v0.14844h-403.91zm-0.15625 0.14844h404.38v0.15625h-404.38zm-0.30078 0.15625h404.98v0.15234h-404.98zm-0.30078 0.15234h405.42v0.14844h-405.42zm-0.15234 0.14844h405.88v0.15234h-405.88zm-0.30078 0.15234h406.48v0.14844h-406.48zm-0.30078 0.14844h406.93v0.15234h-406.93zm-0.30859 0.15234h407.55v0.15234h-407.55zm-0.14844 0.15234h408v0.14844h-408zm-0.30078 0.14844h408.6v0.15234h-408.6zm-0.30469 0.15234h409.06v0.14844h-409.06zm-0.30078 0.14844h409.66v0.15234h-409.66zm-0.14844 0.15234h410.11v0.15625h-410.11zm-0.30859 0.15625h410.72v0.14453h-410.72zm-0.30078 0.14453h411.17v0.15625h-411.17zm-0.30078 0.15625h411.77v0.14844h-411.77zm-0.15234 0.14844h412.23v0.15234h-412.23zm-0.30078 0.15234h412.83v0.15234h-412.83zm-0.30078 0.15234h413.29v0.14844h-413.29zm-0.15625 0.14844h413.74v0.15234h-413.74zm-0.30078 0.15234h414.34v0.14844h-414.34zm455.6 0.14844h0.45313v0.15234h-0.45313zm-455.9 0h414.8v0.15234h-414.8zm-0.30078 0.15234h415.4v0.15625h-415.4zm454.69 0h1.9648v0.15625h-1.9648zm-454.84 0.15625h415.85v0.14453h-415.85zm453.33 0h3.4766v0.14453h-3.4766zm-453.63 0.14453h416.46v0.15625h-416.46zm452.12 0h4.9844v0.15625h-4.9844zm-452.42 0.15625h416.91v0.14453h-416.91zm450.91 0h6.4961v0.14453h-6.4961zm-451.21 0.14453h417.51v0.15625h-417.51zm449.7 0h8.0078v0.15625h-8.0078zm-449.86 0.15625h417.97v0.15234h-417.97zm448.34 0h9.5195v0.15234h-9.5195zm-448.64 0.15234h418.57v0.14844h-418.57zm447.13 0h11.031v0.14844h-11.031zm-447.43 0.14844h419.02v0.15234h-419.02zm445.92 0h12.543v0.15234h-12.543zm-446.23 0.15234h419.64v0.14844h-419.64zm444.71 0h14.055v0.14844h-14.055zm-444.86 0.14844h420.09v0.15234h-420.09zm443.36 0h15.562v0.15234h-15.562zm-443.66 0.15234h420.69v0.15234h-420.69zm442.14 0h17.074v0.15234h-17.074zm-442.45 0.15234h421.15v0.14844h-421.15zm440.94 0h18.586v0.14844h-18.586zm-1.3594 0.14844h19.945v0.15625h-19.945zm-439.73 0h421.59v0.15625h-421.59zm-0.30469 0.15625h422.2v0.14453h-422.2zm438.52 0h21.453v0.14453h-21.453zm-438.83 0.14453h422.66v0.15625h-422.66zm437.32 0h22.965v0.15625h-22.965zm-437.62 0.15625h423.26v0.15234h-423.26zm-0.14844 0.15234h423.71v0.14844h-423.71zm-0.30859 0.14844h424.32v0.15234h-424.32zm-0.30078 0.15234h424.77v0.14844h-424.77zm-0.30078 0.14844h425.38v0.15234h-425.38zm-0.15234 0.15234h425.83v0.15234h-425.83zm-0.30078 0.15234h426.43v0.14844h-426.43zm-0.30078 0.14844h426.89v0.15234h-426.89zm-0.30078 0.15234h427.49v0.14844h-427.49zm-0.15234 0.14844h427.94v0.15234h-427.94zm-0.30469 0.15234h428.4v0.15625h-428.4zm-0.30078 0.15625h429v0.14844h-429zm-0.15234 0.14844h429.45v0.15234h-429.45zm-0.30078 0.15234h430.06v0.14844h-430.06zm-0.30078 0.14844h430.51v0.15234h-430.51zm-0.30078 0.15234h431.11v0.15234h-431.11zm-0.15234 0.15234h431.57v0.14844h-431.57zm-0.30078 0.14844h432.17v0.15234h-432.17zm-0.30078 0.15234h432.62v0.14844h-432.62zm-0.30859 0.14844h433.24v0.15234h-433.24zm-0.14844 0.15234h433.69v0.15625h-433.69zm-0.30078 0.15625h434.29v0.14453h-434.29zm-0.30469 0.14453h434.75v0.15625h-434.75zm-0.14844 0.15625h435.2v0.14844h-435.2zm-0.30078 0.14844h435.8v0.15234h-435.8zm-0.30859 0.15234h436.26v0.15234h-436.26zm-0.30078 0.15234h436.86v0.14844h-436.86zm-0.14844 0.14844h437.31v0.15234h-437.31zm-0.30469 0.15234h437.92v0.14844h-437.92zm-0.30078 0.14844h438.37v0.15234h-438.37zm-0.30078 0.15234h438.97v0.15625h-438.97zm-0.15625 0.15625h439.43v0.14453h-439.43zm-0.30078 0.14453h440.03v0.15625h-440.03zm-0.30078 0.15625h440.48v0.14453h-440.48zm-0.30078 0.14453h441.09v0.15625h-441.09zm-0.15234 0.15625h441.54v0.15234h-441.54zm-0.30078 0.15234h442.15v0.14844h-442.15zm-0.30078 0.14844h442.6v0.15234h-442.6zm-0.15625 0.15234h443.05v0.14844h-443.05zm-0.30078 0.14844h443.66v0.15234h-443.66zm-0.30078 0.15234h444.11v0.15234h-444.11zm-0.30078 0.15234h444.71v0.14844h-444.71zm-0.15234 0.14844h445.17v0.15234h-445.17zm-0.30078 0.15234h445.77v0.14844h-445.77zm-0.30078 0.14844h446.22v0.15625h-446.22zm-0.30859 0.15625h446.84v0.15234h-446.84zm-0.14844 0.15234h447.29v0.14844h-447.29zm-0.30078 0.14844h447.89v0.15234h-447.89zm-0.30469 0.15234h448.35v0.14844h-448.35zm448.65-7.2539h24.477v7.4023h-24.477zm-448.95 7.4023h473.43v0.15234h-473.43zm-0.14844 0.15234h473.57v0.15234h-473.57zm-0.30859 0.15234h473.88v0.14844h-473.88zm-0.30078 0.14844h474.18v0.15234h-474.18zm-0.14844 0.15234h474.33v0.14844h-474.33zm-0.30469 0.14844h474.64v0.15234h-474.64zm-0.30078 0.15234h474.94v0.15625h-474.94zm-0.30078 0.15625h475.24v0.14844h-475.24zm-0.15625 0.14844h475.39v0.15234h-475.39zm-0.30078 0.15234h475.7v0.14844h-475.7zm-0.30078 0.14844h476v0.15234h-476zm-0.30078 0.15234h476.3v0.15234h-476.3zm-0.15234 0.15234h476.45v0.14844h-476.45zm-0.30078 0.14844h476.75v0.15234h-476.75zm-0.30078 0.15234h477.05v0.14844h-477.05zm-0.30078 0.14844h477.35v0.15234h-477.35zm-0.15234 0.15234h477.5v0.15625h-477.5zm-0.30469 0.15625h477.81v0.14453h-477.81zm-0.30078 0.14453h478.11v0.15625h-478.11zm-0.15234 0.15625h478.26v0.14453h-478.26zm-0.30078 0.14453h478.56v0.15625h-478.56zm-0.30078 0.15625h478.86v0.15234h-478.86zm-0.30859 0.15234h479.17v0.14844h-479.17zm-0.14453 0.14844h479.32v0.15234h-479.32zm-0.30078 0.15234h479.62v0.14844h-479.62zm-0.30859 0.14844h479.93v0.15234h-479.93zm-0.30078 0.15234h480.23v0.15625h-480.23zm-0.14844 0.15625h480.38v0.14453h-480.38zm-0.30469 0.14453h480.68v0.15625h-480.68zm-0.30469 0.15625h480.98v0.14453h-480.98zm-0.14453 0.14453h481.13v0.15625h-481.13zm-0.30859 0.15625h481.44v0.15234h-481.44zm-0.30078 0.15234h481.74v0.14844h-481.74zm-0.30078 0.14844h482.04v0.15234h-482.04zm-0.15234 0.15234h482.19v0.14844h-482.19zm-0.30078 0.14844h482.49v0.15234h-482.49zm-0.30078 0.15234h482.79v0.15234h-482.79zm-0.30469 0.15234h483.1v0.14844h-483.1zm-0.15234 0.14844h483.25v0.15234h-483.25zm-0.30078 0.15234h483.55v0.14844h-483.55zm-0.30078 0.14844h483.85v0.15625h-483.85zm-0.30078 0.15625h484.15v0.15234h-484.15zm-0.15234 0.15234h484.3v0.14844h-484.3zm-0.30078 0.14844h484.61v0.15234h-484.61zm-0.30078 0.15234h484.91v0.14844h-484.91zm-0.15625 0.14844h485.06v0.15234h-485.06zm-0.30078 0.15234h485.36v0.15234h-485.36zm-0.30078 0.15234h485.66v0.14844h-485.66zm-0.30469 0.14844h485.97v0.15234h-485.97zm-0.14844 0.15234h486.12v0.14844h-486.12zm-0.30078 0.14844h486.42v0.15234h-486.42zm-0.30859 0.15234h486.73v0.15625h-486.73zm-0.30078 0.15625h487.03v0.14453h-487.03zm-0.14844 0.14453h487.18v0.15625h-487.18zm-0.30469 0.15625h487.48v0.14844h-487.48zm-0.30078 0.14844h487.78v0.15234h-487.78zm-0.30078 0.15234h488.08v0.15234h-488.08zm-0.15625 0.15234h488.24v0.14844h-488.24zm-0.30078 0.14844h488.54v0.15234h-488.54zm-0.30078 0.15234h488.84v0.14844h-488.84zm-0.15234 0.14844h488.99v0.15234h-488.99zm-0.30078 0.15234h489.29v0.15625h-489.29zm-0.30078 0.15625h489.59v0.14453h-489.59zm-0.30078 0.14453h489.89v0.15625h-489.89zm-0.15625 0.15625h490.05v0.14453h-490.05zm-0.30078 0.14453h490.35v0.15625h-490.35zm-0.30078 0.15625h490.65v0.15234h-490.65zm-0.30078 0.15234h490.95v0.14844h-490.95zm-0.15234 0.14844h491.11v0.15234h-491.11zm-0.30078 0.15234h491.41v0.14844h-491.41zm-0.30078 0.14844h491.71v0.15234h-491.71zm-0.15234 0.15234h491.86v0.15234h-491.86zm-0.30469 0.15234h492.16v0.14844h-492.16zm-0.30078 0.14844h492.46v0.15625h-492.46zm-0.30469 0.15625h492.77v0.14453h-492.77zm-0.14844 0.14453h492.92v0.15625h-492.92zm-0.30078 0.15625h493.22v0.15234h-493.22zm-0.30859 0.15234h493.53v0.14844h-493.53zm-0.30078 0.14844h493.83v0.15234h-493.83zm-0.14453 0.15234h493.97v0.14844h-493.97zm-0.30859 0.14844h494.28v0.15234h-494.28zm-0.30078 0.15234h494.58v0.15234h-494.58zm-0.30078 0.15234h494.88v0.14844h-494.88zm-0.15234 0.14844h495.04v0.15234h-495.04zm-0.30469 0.15234h495.34v0.14844h-495.34zm-0.30078 0.14844h495.64v0.15234h-495.64zm-0.15234 0.15234h495.79v0.15625h-495.79zm-0.30078 0.15625h496.09v0.14844h-496.09zm-0.30078 0.14844h496.39v0.15234h-496.39zm-0.30078 0.15234h496.7v0.14844h-496.7zm-0.15234 0.14844h496.85v0.15234h-496.85zm-0.30078 0.15234h497.15v0.15234h-497.15zm-0.30469 0.15234h497.45v0.14844h-497.45zm-0.30078 0.14844h497.75v0.15234h-497.75zm-0.15234 0.15234h497.91v0.14844h-497.91zm-0.30078 0.14844h498.21v0.15234h-498.21zm-0.30078 0.15234h498.51v0.15625h-498.51zm-0.30859 0.15625h498.82v0.14453h-498.82zm-0.14453 0.14453h498.96v0.15625h-498.96zm-0.30078 0.15625h499.26v0.14844h-499.26zm-0.30859 0.14844h499.57v0.15234h-499.57zm-0.14844 0.15234h499.72v0.15234h-499.72zm-0.30078 0.15234h500.02v0.14844h-500.02zm-0.30469 0.14844h500.32v0.15234h-500.32zm-0.30078 0.15234h500.62v0.14844h-500.62zm-0.14844 0.14844h500.77v0.15234h-500.77zm-0.30859 0.15234h501.08v0.15625h-501.08zm-0.30078 0.15625h501.38v0.14453h-501.38zm-0.30078 0.14453h501.68v0.15625h-501.68zm-0.15234 0.15625h501.84v0.14453h-501.84zm-0.30078 0.14453h502.14v0.15625h-502.14zm-0.30078 0.15625h502.44v0.15234h-502.44zm-0.30078 0.15234h502.74v0.14844h-502.74zm-0.15625 0.14844h502.89v0.15234h-502.89zm-0.30078 0.15234h503.2v0.14844h-503.2zm-0.30078 0.14844h503.5v0.15234h-503.5zm-0.15234 0.15234h503.65v0.15234h-503.65zm-0.30078 0.15234h503.95v0.14844h-503.95zm-0.30078 0.14844h504.25v0.15234h-504.25zm-0.30078 0.15234h504.55v0.14844h-504.55zm-0.15625 0.14844h504.71v0.15625h-504.71zm-0.30078 0.15625h505.01v0.15234h-505.01zm-0.30078 0.15234h505.31v0.14844h-505.31zm-0.30469 0.14844h505.61v0.15234h-505.61zm-0.14844 0.15234h505.76v0.14844h-505.76zm-0.30078 0.14844h506.06v0.15234h-506.06zm-0.30859 0.15234h506.37v0.15234h-506.37zm-0.14844 0.15234h506.52v0.14844h-506.52zm-0.30078 0.14844h506.82v0.15234h-506.82zm-0.30469 0.15234h507.12v0.14844h-507.12zm-0.30078 0.14844h507.43v0.15234h-507.43zm-0.14844 0.15234h507.57v0.15625h-507.57zm-0.30859 0.15625h507.88v0.14844h-507.88zm-0.30078 0.14844h508.18v0.15234h-508.18zm-0.30078 0.15234h508.48v0.14844h-508.48zm-0.15234 0.14844h508.64v0.15234h-508.64zm-0.30078 0.15234h508.94v0.15234h-508.94zm-0.30078 0.15234h509.24v0.14844h-509.24zm-0.30078 0.14844h509.54v0.15234h-509.54zm-0.15625 0.15234h509.7v0.14844h-509.7zm-0.30078 0.14844h510v0.15234h-510zm-0.30078 0.15234h510.3v0.15625h-510.3zm-0.15234 0.15625h510.45v0.14453h-510.45zm-0.30078 0.14453h510.75v0.15625h-510.75zm-0.30078 0.15625h511.05v0.14453h-511.05zm-0.30078 0.14453h511.35v0.15625h-511.35zm-0.15234 0.15625h511.5v0.15234h-511.5zm-0.30078 0.15234h511.8v0.14844h-511.8zm-0.30469 0.14844h512.11v0.15234h-512.11zm-0.30469 0.15234h512.41v0.14844h-512.41zm-0.14844 0.14844h512.56v0.15234h-512.56zm-0.30078 0.15234h512.86v0.15234h-512.86zm-0.30859 0.15234h513.17v0.14844h-513.17zm-0.30078 0.14844h513.47v0.15625h-513.47zm-0.14453 0.15625h513.62v0.14453h-513.62zm-0.30859 0.14453h513.93v0.15625h-513.93zm-0.30078 0.15625h514.23v0.15234h-514.23zm-0.14844 0.15234h514.38v0.14844h-514.38zm-0.30469 0.14844h514.68v0.15234h-514.68zm-0.30078 0.15234h514.98v0.14844h-514.98zm-0.30469 0.14844h515.29v0.15234h-515.29zm-0.15234 0.15234h515.44v0.15234h-515.44zm-0.30078 0.15234h515.74v0.14844h-515.74zm-0.30078 0.14844h516.04v0.15234h-516.04zm-0.30078 0.15234h516.19v0.14844h-516.19zm-0.15234 0.14844h516.34v0.15625h-516.34zm-0.30078 0.15625h516.64v0.15234h-516.64zm-0.30078 0.15234h516.94v0.14844h-516.94zm-0.30469 0.14844h517.25v0.15234h-517.25zm-0.15234 0.15234h517.4v0.14844h-517.4zm-0.30078 0.14844h517.7v0.15234h-517.7zm-0.30078 0.15234h517.85v0.15234h-517.85zm-0.15234 0.15234h518v0.14844h-518zm-0.30078 0.14844h518.3v0.15234h-518.3zm-0.30078 0.15234h518.61v0.14844h-518.61zm-0.30859 0.14844h518.76v0.15234h-518.76zm-0.14844 0.15234h518.91v0.15625h-518.91zm-0.30078 0.15625h519.21v0.14453h-519.21zm-0.30469 0.14453h519.37v0.15625h-519.37zm-0.30078 0.15625h519.67v0.14844h-519.67zm-0.14844 0.14844h519.82v0.15234h-519.82zm-0.30859 0.15234h520.12v0.15234h-520.12zm-0.30078 0.15234h520.27v0.14844h-520.27zm-0.14844 0.14844h520.42v0.15234h-520.42zm-0.30469 0.15234h520.73v0.14844h-520.73zm-0.30078 0.14844h520.88v0.15234h-520.88zm-0.30078 0.15234h521.18v0.15625h-521.18zm-0.15625 0.15625h521.33v0.14453h-521.33zm-0.30078 0.14453h521.48v0.15625h-521.48zm-0.30078 0.15625h521.79v0.14453h-521.79zm-0.30078 0.14453h522.09v0.15625h-522.09zm-0.15234 0.15625h522.09v0.15234h-522.09zm-0.30078 0.15234h522.39v0.14844h-522.39zm-0.30078 0.14844h522.54v0.15234h-522.54zm-0.30078 0.15234h522.84v0.14844h-522.84zm-0.15625 0.14844h522.84v0.15234h-522.84zm-0.30078 0.15234h523.14v0.15234h-523.14zm-0.30078 0.15234h523.29v0.14844h-523.29zm-0.15234 0.14844h523.44v0.15625h-523.44zm-0.30078 0.15625h523.59v0.14453h-523.59zm-0.30078 0.14453h523.89v0.15625h-523.89zm-0.30859 0.15625h524.05v0.15234h-524.05zm-0.14453 0.15234h524.2v0.14844h-524.2zm-0.30469 0.14844h524.35v0.15234h-524.35zm-0.30469 0.15234h524.66v0.14844h-524.66zm-0.30078 0.14844h524.8v0.15234h-524.8zm-0.14844 0.15234h524.95v0.15234h-524.95zm-0.30859 0.15234h525.11v0.14844h-525.11zm-0.30078 0.14844h525.26v0.15234h-525.26zm-0.30078 0.15234h525.56v0.14844h-525.56zm-0.15234 0.14844h525.56v0.15234h-525.56zm-0.30078 0.15234h525.71v0.15625h-525.71zm-0.30078 0.15625h526.02v0.14844h-526.02zm-0.15234 0.14844h526.02v0.15234h-526.02zm-0.30078 0.15234h526.16v0.14844h-526.16zm-0.30469 0.14844h526.46v0.15234h-526.46zm-0.30078 0.15234h526.62v0.15234h-526.62zm-0.15234 0.15234h526.62v0.14844h-526.62zm-0.30078 0.14844h526.92v0.15234h-526.92zm-0.30078 0.15234h527.07v0.14844h-527.07zm-0.30078 0.14844h527.22v0.15234h-527.22zm-0.15234 0.15234h527.22v0.15625h-527.22zm-0.30078 0.15625h527.52v0.14453h-527.52zm-0.30078 0.14453h527.67v0.15625h-527.67zm-0.30859 0.15625h527.83v0.14844h-527.83zm-0.14844 0.14844h527.83v0.15234h-527.83zm-0.30078 0.15234h527.98v0.15234h-527.98zm-0.30469 0.15234h528.13v0.14844h-528.13zm-0.14844 0.14844h528.28v0.15234h-528.28zm-0.30078 0.15234h528.43v0.14844h-528.43zm-0.30859 0.14844h528.59v0.15234h-528.59zm-0.30078 0.15234h528.74v0.15625h-528.74zm-0.14844 0.15625h528.73v0.14453h-528.73zm-0.30469 0.14453h528.88v0.15625h-528.88zm-0.30078 0.15625h529.04v0.14453h-529.04zm-0.30078 0.14453h529.34v0.15625h-529.34zm-0.15625 0.15625h529.34v0.15234h-529.34zm-0.30078 0.15234h529.34v0.14844h-529.34zm-0.30078 0.14844h529.49v0.15234h-529.49zm-0.15234 0.15234h529.49v0.14844h-529.49zm-0.30078 0.14844h529.64v0.15234h-529.64zm-0.30078 0.15234h529.79v0.15234h-529.79zm-0.30078 0.15234h529.94v0.14844h-529.94zm-0.15625 0.14844h529.94v0.15234h-529.94zm-0.30078 0.15234h530.1v0.14844h-530.1zm-0.30078 0.14844h530.24v0.15625h-530.24zm-0.30078 0.15625h530.39v0.15234h-530.39zm-0.15234 0.15234h530.39v0.14844h-530.39zm-0.30078 0.14844h530.54v0.15234h-530.54zm-0.30078 0.15234h530.7v0.14844h-530.7zm-0.30859 0.14844h530.85v0.15234h-530.85zm-0.14844 0.15234h530.7v0.15234h-530.7zm-0.30078 0.15234h530.84v0.14844h-530.84zm-0.30469 0.14844h531v0.15234h-531zm-0.14844 0.15234h530.85v0.14844h-530.85zm-0.30078 0.14844h531v0.15234h-531zm-0.30859 0.15234h531.15v0.15625h-531.15zm-0.30078 0.15625h531.15v0.14844h-531.15zm-0.14844 0.14844h531.15v0.15234h-531.15zm-0.30469 0.15234h531.3v0.14844h-531.3zm-0.30078 0.14844h531.45v0.15234h-531.45zm-0.30078 0.15234h531.45v0.15234h-531.45zm-0.15625 0.15234h531.46v0.14844h-531.46zm-0.30078 0.14844h531.61v0.15234h-531.61zm-0.30078 0.15234h531.61v0.14844h-531.61zm-0.30078 0.14844h531.75v0.15234h-531.75zm-0.15234 0.15234h531.61v0.15625h-531.61zm-0.30078 0.15625h531.75v0.14453h-531.75zm-0.30078 0.14453h531.75v0.15625h-531.75zm-0.15234 0.15625h531.76v0.14453h-531.76zm-0.30469 0.14453h531.75v0.15625h-531.75zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h532.06v0.15234h-532.06zm-0.14453 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15625h-531.91zm-0.30859 0.15625h532.06v0.14453h-532.06zm-0.14844 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.14844h-531.91zm-0.30469 0.14844h532.06v0.15234h-532.06zm-0.14453 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15625h-532.06zm-0.30469 0.15625h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15625h-531.91zm-0.30469 0.15625h532.06v0.14453h-532.06zm-0.14844 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14844h-531.91zm-0.30859 0.14844h532.06v0.15234h-532.06zm-0.30078 0.15234h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-0.30469 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.15234 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15625 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.30078 0.15234h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.15625 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30469 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h532.06v0.15234h-532.06zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14453 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.15625h-531.91zm-0.30469 0.15625h531.91v0.14844h-531.91zm-0.30469 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30469 0.15234h532.05v0.15625h-532.05zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.15234 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.05v0.15625h-532.05zm-0.15234 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15625h-531.91zm-0.30469 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.14453h-531.91zm-0.30859 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h532.06v0.15234h-532.06zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.15625 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.15234h-532.05zm-0.30469 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14844h-531.91zm-0.30469 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.15625h-532.06zm-0.15234 0.15625h531.91v0.14453h-531.91zm-0.30469 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.05v0.15625h-532.05zm-0.15234 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.30469 0.14844h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30859 0.15625h532.06v0.15234h-532.06zm-0.14453 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30469 0.15234h532.06v0.14844h-532.06zm-0.15234 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30859 0.15625h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30469 0.15234h532.06v0.14844h-532.06zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.14453h-531.91zm-0.30469 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.15625 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15625 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30469 0.14844h532.06v0.15234h-532.06zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h532.06v0.14844h-532.06zm-0.14453 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.05v0.15625h-532.05zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.15234 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30469 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h532.06v0.15625h-532.06zm-0.14453 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30859 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15625h-531.91zm-0.30469 0.15625h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-0.30469 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.15625 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.15234 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.30859 0.14453h532.06v0.15625h-532.06zm-0.14453 0.15625h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.14844h-531.91zm-0.30469 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14453 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15625h-532.06zm-0.30078 0.15625h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15625 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.15625 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.30469 0.15234h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15625h-531.91zm-0.30469 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.14453h-531.91zm-0.30859 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.30078 0.15234h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.15234 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30469 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h532.06v0.15234h-532.06zm-0.30078 0.15234h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.14844h-531.91zm-0.30469 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.15625h-532.06zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.15234 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30469 0.14453h532.05v0.15625h-532.05zm-0.15234 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30859 0.14453h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30469 0.15625h532.06v0.15234h-532.06zm-0.30469 0.15234h532.06v0.14844h-532.06zm-0.14453 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15625 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.15234h-532.05zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15625 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30859 0.15625h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.15625h-532.06zm-0.30078 0.15625h532.06v0.14453h-532.06zm-0.15234 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.15625 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.30078 0.14844h532.05v0.15625h-532.05zm-0.15234 0.15625h531.91v0.14453h-531.91zm-0.30469 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h532.06v0.15234h-532.06zm-0.14453 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15625h-531.91zm-0.30469 0.15625h531.91v0.15234h-531.91zm-0.30469 0.15234h532.06v0.14844h-532.06zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.30859 0.14844h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30469 0.15234h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30859 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15625 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.30859 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15625h-531.91zm-0.30469 0.15625h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.15234h-532.06zm-0.14453 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.15625h-531.91zm-0.30469 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.15234 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30469 0.15234h532.05v0.15625h-532.05zm-0.15234 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30859 0.14453h532.06v0.15625h-532.06zm-0.14453 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h532.06v0.15234h-532.06zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.30078 0.14844h532.05v0.15234h-532.05zm-21.613 0h1.2109v0.15234h-1.2109zm21.457 0.15234h531.91v0.15234h-531.91zm-22.965 0h2.7188v0.15234h-2.7188zm-1.5117 0.15234h4.2305v0.14844h-4.2305zm24.176 0h531.91v0.14844h-531.91zm-25.688 0.14844h5.7422v0.15234h-5.7422zm25.387 0h532.05v0.15234h-532.05zm-26.898 0.15234h7.2539v0.14844h-7.2539zm26.746 0h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-27.957 0h8.7656v0.15234h-8.7656zm-1.3555 0.15234h10.121v0.15625h-10.121zm29.012 0h531.91v0.15625h-531.91zm-30.523 0.15625h11.633v0.14453h-11.633zm30.223 0h532.05v0.14453h-532.05zm-31.734 0.14453h13.145v0.15625h-13.145zm31.578 0h531.91v0.15625h-531.91zm-33.09 0.15625h14.656v0.14844h-14.656zm32.789 0h531.91v0.14844h-531.91zm-34.301 0.14844h16.168v0.15234h-16.168zm34 0h531.91v0.15234h-531.91zm-35.512 0.15234h17.68v0.15234h-17.68zm35.207 0h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.14844h-531.91zm-36.566 0h19.188v0.14844h-19.188zm-1.5117 0.14844h20.699v0.15234h-20.699zm37.777 0h531.91v0.15234h-531.91zm-39.289 0.15234h22.211v0.14844h-22.211zm38.98 0h532.06v0.14844h-532.06zm-40.492 0.14844h23.723v0.15234h-23.723zm40.191 0h532.06v0.15234h-532.06zm-0.14844 0.15234h531.91v0.15625h-531.91zm-0.30469 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.14453h-531.91zm-0.30859 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30469 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.30078 0.14453h532.05v0.15625h-532.05zm-0.15234 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30469 0.15234h531.91v0.15234h-531.91zm-0.30469 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.15625h-532.06zm-0.14453 0.15625h531.91v0.14844h-531.91zm-0.30859 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-0.30469 0.14844h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h532.05v0.14453h-532.05zm-0.15234 0.14453h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14844h-531.91zm-0.30078 0.14844h532.05v0.15234h-532.05zm-0.30078 0.15234h532.05v0.15234h-532.05zm-0.15625 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.05v0.14844h-532.05zm-0.15234 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.14453h-531.91zm-0.30859 0.14453h532.06v0.15625h-532.06zm-0.14844 0.15625h531.91v0.14453h-531.91zm-0.30078 0.14453h531.91v0.15625h-531.91zm-0.30469 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.14844 0.14844h531.91v0.15234h-531.91zm-0.30859 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h532.06v0.15234h-532.06zm-0.30078 0.15234h532.06v0.15234h-532.06zm-0.15234 0.15234h531.91v0.14844h-531.91zm-0.30078 0.14844h531.91v0.15234h-531.91zm-0.30078 0.15234h532.06v0.14844h-532.06zm-0.15625 0.14844h531.91v0.15625h-531.91zm-0.30078 0.15625h531.91v0.15234h-531.91zm-0.30078 0.15234h531.91v0.14844h-531.91zm-24.934-9.2227h24.633v9.3711h-24.633zm0 9.3711h556.69v0.15234h-556.69zm0 0.15234h556.39v0.14844h-556.39zm0 0.14844h556.09v0.15234h-556.09zm0 0.15234h555.79v0.15234h-555.79zm0 0.15234h555.63v0.14844h-555.63zm0 0.14844h555.33v0.15234h-555.33zm0 0.15234h555.03v0.14844h-555.03zm0 0.14844h554.88v0.15234h-554.88zm0 0.15234h554.57v0.15625h-554.57zm0 0.15625h554.27v0.14844h-554.27zm0 0.14844h553.97v0.15234h-553.97zm0 0.15234h553.82v0.14844h-553.82zm0 0.14844h553.52v0.15234h-553.52zm0 0.15234h553.22v0.15234h-553.22zm0 0.15234h552.91v0.14844h-552.91zm0 0.14844h552.76v0.15234h-552.76zm0 0.15234h552.46v0.14844h-552.46zm0 0.14844h552.16v0.15234h-552.16zm0 0.15234h551.86v0.15625h-551.86zm0 0.15625h551.71v0.14453h-551.71zm0 0.14453h551.4v0.15625h-551.4zm0 0.15625h551.1v0.14453h-551.1zm0 0.14453h550.95v0.15625h-550.95zm0 0.15625h550.64v0.15234h-550.64zm0 0.15234h550.34v0.14844h-550.34zm0 0.14844h550.04v0.15234h-550.04zm0 0.15234h549.89v0.14844h-549.89zm0 0.14844h549.59v0.15234h-549.59zm0 0.15234h549.29v0.15234h-549.29zm0 0.15234h548.98v0.14844h-548.98zm0 0.14844h548.83v0.15625h-548.83zm0 0.15625h548.53v0.14453h-548.53zm0 0.14453h548.23v0.15625h-548.23zm0 0.15625h548.07v0.15234h-548.07zm0 0.15234h547.77v0.14844h-547.77zm0 0.14844h547.47v0.15234h-547.47zm0 0.15234h547.17v0.14844h-547.17zm0 0.14844h547.02v0.15234h-547.02zm0 0.15234h546.72v0.15234h-546.72zm0 0.15234h546.42v0.14844h-546.42zm0 0.14844h546.11v0.15234h-546.11zm0 0.15234h545.96v0.14844h-545.96zm0 0.14844h545.66v0.15625h-545.66zm0 0.15625h545.36v0.15234h-545.36zm0 0.15234h545.05v0.14844h-545.05zm0 0.14844h544.91v0.15234h-544.91zm0 0.15234h544.6v0.14844h-544.6zm0 0.14844h544.3v0.15234h-544.3zm0 0.15234h544.15v0.15234h-544.15zm0 0.15234h543.84v0.14844h-543.84zm0 0.14844h543.54v0.15234h-543.54zm0 0.15234h543.24v0.14844h-543.24zm0 0.14844h543.09v0.15234h-543.09zm0 0.15234h542.79v0.15625h-542.79zm0 0.15625h542.48v0.14453h-542.48zm0 0.14453h542.18v0.15625h-542.18zm0 0.15625h542.03v0.14844h-542.03zm0 0.14844h541.73v0.15234h-541.73zm0 0.15234h541.43v0.15234h-541.43zm0 0.15234h541.13v0.14844h-541.13zm0 0.14844h540.98v0.15234h-540.98zm0 0.15234h540.68v0.14844h-540.68zm0 0.14844h540.37v0.15234h-540.37zm0 0.15234h540.22v0.15625h-540.22zm0 0.15625h539.92v0.14453h-539.92zm0 0.14453h539.62v0.15625h-539.62zm0 0.15625h539.31v0.14453h-539.31zm0 0.14453h539.16v0.15625h-539.16zm0 0.15625h538.86v0.15234h-538.86zm0 0.15234h538.55v0.14844h-538.55zm0 0.14844h538.25v0.15234h-538.25zm0 0.15234h538.11v0.14844h-538.11zm0 0.14844h537.8v0.15234h-537.8zm0 0.15234h537.5v0.15234h-537.5zm0 0.15234h537.35v0.14844h-537.35zm0 0.14844h537.04v0.15625h-537.04zm0 0.15625h536.74v0.14453h-536.74zm0 0.14453h536.44v0.15625h-536.44zm0 0.15625h536.29v0.15234h-536.29zm0 0.15234h535.99v0.14844h-535.99zm0 0.14844h535.69v0.15234h-535.69zm0 0.15234h535.39v0.14844h-535.39zm0 0.14844h535.23v0.15234h-535.23zm0 0.15234h534.93v0.15234h-534.93zm0 0.15234h534.63v0.14844h-534.63zm0 0.14844h534.33v0.15234h-534.33zm0 0.15234h534.18v0.14844h-534.18zm0 0.14844h533.88v0.15234h-533.88zm0 0.15234h533.57v0.15625h-533.57zm0 0.15625h533.42v0.14844h-533.42zm0 0.14844h533.12v0.15234h-533.12zm0 0.15234h532.82v0.14844h-532.82zm0 0.14844h532.51v0.15234h-532.51zm0 0.15234h532.36v0.15234h-532.36zm0 0.15234h532.06v0.14844h-532.06zm0 0.14844h531.75v0.15234h-531.75zm0 0.15234h531.45v0.14844h-531.45zm0 0.14844h531.3v0.15234h-531.3zm0 0.15234h531v0.15625h-531zm0 0.15625h530.7v0.14453h-530.7zm0 0.14453h530.4v0.15625h-530.4zm0 0.15625h530.24v0.14844h-530.24zm0 0.14844h529.94v0.15234h-529.94zm0 0.15234h529.64v0.15234h-529.64zm0 0.15234h529.49v0.14844h-529.49zm0 0.14844h529.19v0.15234h-529.19zm0 0.15234h528.89v0.14844h-528.89zm0 0.14844h528.59v0.15234h-528.59zm0 0.15234h528.43v0.15625h-528.43zm0 0.15625h528.13v0.14453h-528.13zm0 0.14453h527.83v0.15625h-527.83zm0 0.15625h527.53v0.14453h-527.53zm0 0.14453h527.38v0.15625h-527.38zm0 0.15625h527.07v0.15234h-527.07zm0 0.15234h526.77v0.14844h-526.77zm0 0.14844h526.46v0.15234h-526.46zm0 0.15234h526.32v0.14844h-526.32zm0 0.14844h526.02v0.15234h-526.02zm0 0.15234h525.71v0.15234h-525.71zm0 0.15234h525.56v0.14844h-525.56zm0 0.14844h525.26v0.15234h-525.26zm0 0.15234h524.96v0.14844h-524.96zm0 0.14844h524.65v0.15625h-524.65zm0 0.15625h524.51v0.15234h-524.51zm0 0.15234h524.2v0.14844h-524.2zm0 0.14844h523.9v0.15234h-523.9zm0 0.15234h523.6v0.14844h-523.6zm0 0.14844h523.45v0.15234h-523.45zm0 0.15234h523.14v0.15234h-523.14zm0 0.15234h522.84v0.14844h-522.84zm0 0.14844h522.69v0.15234h-522.69zm0 0.15234h522.39v0.14844h-522.39zm0 0.14844h522.09v0.15234h-522.09zm0 0.15234h521.79v0.15625h-521.79zm0 0.15625h521.63v0.14844h-521.63zm0 0.14844h521.33v0.15234h-521.33zm0 0.15234h521.03v0.14844h-521.03zm0 0.14844h520.73v0.15234h-520.73zm0 0.15234h520.57v0.15234h-520.57zm0 0.15234h520.27v0.14844h-520.27zm0 0.14844h519.97v0.15234h-519.97zm0 0.15234h519.67v0.14844h-519.67zm0 0.14844h519.52v0.15234h-519.52zm0 0.15234h519.22v0.15625h-519.22zm0 0.15625h518.91v0.14453h-518.91zm0 0.14453h518.76v0.15625h-518.76zm0 0.15625h518.46v0.14453h-518.46zm0 0.14453h518.16v0.15625h-518.16zm0 0.15625h517.86v0.15234h-517.86zm0 0.15234h517.71v0.14844h-517.71zm0 0.14844h517.4v0.15234h-517.4zm0 0.15234h517.1v0.14844h-517.1zm0 0.14844h516.8v0.15234h-516.8zm0 0.15234h516.64v0.15234h-516.64zm0 0.15234h516.34v0.14844h-516.34zm0 0.14844h516.04v0.15625h-516.04zm0 0.15625h515.74v0.14453h-515.74zm0 0.14453h515.59v0.15625h-515.59zm0 0.15625h515.29v0.15234h-515.29zm0 0.15234h514.98v0.14844h-514.98zm0 0.14844h514.83v0.15234h-514.83zm0 0.15234h514.53v0.14844h-514.53zm0 0.14844h514.23v0.15234h-514.23zm0 0.15234h513.93v0.15234h-513.93zm0 0.15234h513.77v0.14844h-513.77zm0 0.14844h513.47v0.15234h-513.47zm0 0.15234h513.17v0.14844h-513.17zm0 0.14844h512.87v0.15625h-512.87zm0 0.15625h512.72v0.15234h-512.72zm0 0.15234h512.42v0.14844h-512.42zm0 0.14844h512.11v0.15234h-512.11zm0 0.15234h511.81v0.14844h-511.81zm0 0.14844h511.66v0.15234h-511.66zm0 0.15234h511.36v0.15234h-511.36zm0 0.15234h511.05v0.14844h-511.05zm0 0.14844h510.91v0.15234h-510.91zm0 0.15234h510.6v0.14844h-510.6zm0 0.14844h510.3v0.15234h-510.3zm0.15625 0.15234h509.84v0.15625h-509.84zm0 0.15625h509.69v0.14453h-509.69zm0 0.14453h509.39v0.15625h-509.39zm0 0.15625h509.09v0.14844h-509.09zm0 0.14844h508.79v0.15234h-508.79zm0 0.15234h508.63v0.15234h-508.63zm0 0.15234h508.33v0.14844h-508.33zm0 0.14844h508.03v0.15234h-508.03zm0.14453 0.15234h507.73v0.14844h-507.73zm0 0.14844h507.43v0.15234h-507.43zm0 0.15234h507.13v0.15625h-507.13zm0.15625 0.15625h506.67v0.14453h-506.67zm0 0.14453h506.52v0.15625h-506.52zm0 0.15625h506.22v0.14453h-506.22zm0.14844 0.14453h505.77v0.15625h-505.77zm0 0.15625h505.46v0.15234h-505.46zm0 0.15234h505.31v0.14844h-505.31zm0.15234 0.14844h504.86v0.15234h-504.86zm0 0.15234h504.55v0.14844h-504.55zm0 0.14844h504.25v0.15234h-504.25zm0 0.15234h504.11v0.15234h-504.11zm0.15234 0.15234h503.64v0.14844h-503.64zm0 0.14844h503.34v0.15625h-503.34zm0.14844 0.15625h503.05v0.14453h-503.05zm0 0.14453h502.74v0.15625h-502.74zm0.15234 0.15625h502.29v0.15234h-502.29zm0 0.15234h501.99v0.14844h-501.99zm0.14844 0.14844h501.68v0.15234h-501.68zm0 0.15234h501.38v0.14844h-501.38zm0.15234 0.14844h500.93v0.15234h-500.93zm0 0.15234h500.63v0.15234h-500.63zm0.15625 0.15234h500.32v0.14844h-500.32zm0 0.14844h500.02v0.15234h-500.02zm0.14453 0.15234h499.57v0.14844h-499.57zm0 0.14844h499.27v0.15234h-499.27zm0.15625 0.15234h498.96v0.15625h-498.96zm0 0.15625h498.66v0.14844h-498.66zm0.14453 0.14844h498.21v0.15234h-498.21zm0.15625 0.15234h497.91v0.14844h-497.91zm0 0.14844h497.61v0.15234h-497.61zm0.15234 0.15234h497.15v0.15234h-497.15zm0.14844 0.15234h496.7v0.14844h-496.7zm0 0.14844h496.55v0.15234h-496.55zm0.15234 0.15234h496.09v0.14844h-496.09zm0.14844 0.14844h495.64v0.15234h-495.64zm0.15234 0.15234h495.19v0.15625h-495.19zm0 0.15625h495.04v0.14453h-495.04zm0.15234 0.14453h494.58v0.15625h-494.58zm0.14844 0.15625h494.13v0.14844h-494.13zm0 0.14844h493.98v0.15234h-493.98zm0.15234 0.15234h493.52v0.15234h-493.52zm0.14844 0.15234h493.07v0.14844h-493.07zm0.15625 0.14844h492.62v0.15234h-492.62zm0.15234 0.15234h492.31v0.14844h-492.31zm0.14844 0.14844h491.86v0.15234h-491.86zm0.15234 0.15234h491.41v0.15625h-491.41zm0.14844 0.15625h490.96v0.14453h-490.96zm0.15234 0.14453h490.65v0.15625h-490.65zm0.15234 0.15625h490.2v0.14453h-490.2zm0.14844 0.14453h489.75v0.15625h-489.75zm0.15234 0.15625h489.3v0.15234h-489.3zm0.14844 0.15234h489v0.14844h-489zm0.15234 0.14844h488.54v0.15234h-488.54zm0.15625 0.15234h488.08v0.14844h-488.08zm0.14453 0.14844h487.79v0.15234h-487.79zm0.15625 0.15234h487.33v0.15234h-487.33zm0.30078 0.15234h486.73v0.14844h-486.73zm0.15234 0.14844h486.27v0.15234h-486.27zm0.14844 0.15234h485.97v0.14844h-485.97zm0.15234 0.14844h485.52v0.15625h-485.52zm0.14844 0.15625h485.06v0.15234h-485.06zm0.30469 0.15234h484.46v0.14844h-484.46zm0.14844 0.14844h484.16v0.15234h-484.16zm0.15625 0.15234h483.7v0.14844h-483.7zm0.14453 0.14844h483.25v0.15234h-483.25zm0.30859 0.15234h482.64v0.15234h-482.64zm0.14844 0.15234h482.34v0.14844h-482.34zm0.30078 0.14844h481.74v0.15234h-481.74zm0.15234 0.15234h481.29v0.14844h-481.29zm0.30078 0.14844h480.83v0.15234h-480.83zm0.15234 0.15234h480.38v0.15625h-480.38zm0.30078 0.15625h479.78v0.14844h-479.78zm0.15625 0.14844h479.32v0.15234h-479.32zm0.30078 0.15234h478.86v0.14844h-478.86zm0.30078 0.14844h478.26v0.15234h-478.26zm0.30078 0.15234h477.66v0.15234h-477.66zm0.15234 0.15234h477.21v0.14844h-477.21zm0.30078 0.14844h476.75v0.15234h-476.75zm0.30078 0.15234h476.15v0.14844h-476.15zm0.15625 0.14844h475.7v0.15234h-475.7zm0.30078 0.15234h475.09v0.15625h-475.09zm0.30078 0.15625h474.64v0.14453h-474.64zm0.30078 0.14453h474.04v0.15625h-474.04zm0.15234 0.15625h473.58v0.14453h-473.58zm0.30078 0.14453h473.13v0.15625h-473.13zm0.30078 0.15625h472.53v0.15234h-472.53zm0.30859 0.15234h471.91v0.14844h-471.91zm0.14844 0.14844h471.46v0.15234h-471.46zm0.30078 0.15234h471.01v0.14844h-471.01zm0.30469 0.14844h470.4v0.15234h-470.4zm0.30078 0.15234h469.8v0.15234h-469.8zm0.14844 0.15234h469.35v0.14844h-469.35zm0.30859 0.14844h468.89v0.15625h-468.89zm0.30078 0.15625h468.29v0.14453h-468.29zm0.14844 0.14453h467.84v0.15625h-467.84zm0.30469 0.15625h467.38v0.15234h-467.38zm0.30078 0.15234h466.78v0.14844h-466.78zm0.30078 0.14844h466.18v0.15234h-466.18zm0.15625 0.15234h465.72v0.14844h-465.72zm0.30078 0.14844h465.26v0.15234h-465.26zm0.30078 0.15234h464.66v0.15234h-464.66zm0.30078 0.15234h464.06v0.14844h-464.06zm0.15234 0.14844h463.61v0.15234h-463.61zm0.30078 0.15234h463.15v0.14844h-463.15zm0.30078 0.14844h462.55v0.15625h-462.55zm0.30078 0.15625h461.95v0.15234h-461.95zm0.15234 0.15234h461.49v0.14844h-461.49zm0.30469 0.14844h461.04v0.15234h-461.04zm0.30078 0.15234h460.43v0.14844h-460.43zm0.15234 0.14844h459.98v0.15234h-459.98zm0.30078 0.15234h459.53v0.15234h-459.53zm0.30078 0.15234h458.93v0.14844h-458.93zm0.30859 0.14844h458.31v0.15234h-458.31zm0.14453 0.15234h457.86v0.14844h-457.86zm0.30078 0.14844h457.42v0.15234h-457.42zm0.30859 0.15234h456.8v0.15625h-456.8zm0.30078 0.15625h456.2v0.14453h-456.2zm0.14844 0.14453h455.75v0.15625h-455.75zm0.30469 0.15625h455.29v0.14844h-455.29zm0.30469 0.14844h454.69v0.15234h-454.69zm0.30078 0.15234h454.08v0.15234h-454.08zm0.15234 0.15234h453.63v0.14844h-453.63zm0.30078 0.14844h453.18v0.15234h-453.18zm0.30078 0.15234h452.57v0.14844h-452.57zm0.15234 0.14844h452.12v0.15234h-452.12zm0.30078 0.15234h451.67v0.15625h-451.67zm0.30078 0.15625h451.07v0.14453h-451.07zm0.30469 0.14453h450.46v0.15625h-450.46zm0.15234 0.15625h450v0.14453h-450zm0.30078 0.14453h449.55v0.15625h-449.55zm0.30078 0.15625h448.95v0.15234h-448.95zm0.30078 0.15234h448.35v0.14844h-448.35zm0.15234 0.14844h447.89v0.15234h-447.89zm0.30078 0.15234h447.44v0.14844h-447.44zm0.30078 0.14844h446.84v0.15234h-446.84zm0.15625 0.15234h446.38v0.15234h-446.38zm0.30078 0.15234h445.77v0.14844h-445.77zm0.30078 0.14844h445.32v0.15625h-445.32zm0.30469 0.15625h444.71v0.14453h-444.71zm0.14844 0.14453h444.27v0.15625h-444.27zm0.30078 0.15625h443.82v0.15234h-443.82zm0.30859 0.15234h443.2v0.14844h-443.2zm0.30078 0.14844h442.6v0.15234h-442.6zm0.14844 0.15234h442.15v0.14844h-442.15zm0.30469 0.14844h441.69v0.15234h-441.69zm0.30078 0.15234h441.09v0.15234h-441.09zm0.30078 0.15234h440.49v0.14844h-440.49zm0.15625 0.14844h440.03v0.15234h-440.03zm0.30078 0.15234h439.57v0.14844h-439.57zm0.30078 0.14844h438.97v0.15234h-438.97zm0.15234 0.15234h438.52v0.15625h-438.52zm0.30078 0.15625h438.07v0.14844h-438.07zm0.30078 0.14844h437.46v0.15234h-437.46zm0.30078 0.15234h436.86v0.14844h-436.86zm0.15625 0.14844h436.41v0.15234h-436.41zm0.30078 0.15234h435.95v0.15234h-435.95zm0.30078 0.15234h435.35v0.14844h-435.35zm0.30078 0.14844h434.75v0.15234h-434.75zm0.15234 0.15234h434.29v0.14844h-434.29zm0.30078 0.14844h433.84v0.15234h-433.84zm0.30078 0.15234h433.24v0.15625h-433.24zm0.30859 0.15625h432.62v0.14453h-432.62zm0.14844 0.14453h432.17v0.15625h-432.17zm0.30078 0.15625h431.72v0.14453h-431.72zm0.30469 0.14453h431.11v0.15625h-431.11zm0.14844 0.15625h430.66v0.15234h-430.66zm0.30078 0.15234h430.21v0.14844h-430.21zm0.30859 0.14844h429.6v0.15234h-429.6zm0.30078 0.15234h429v0.14844h-429zm0.14453 0.14844h428.55v0.15234h-428.55zm0.30859 0.15234h428.09v0.15625h-428.09zm0.30078 0.15625h427.49v0.14453h-427.49zm0.30078 0.14453h426.89v0.15625h-426.89zm0.15234 0.15625h426.43v0.14453h-426.43zm0.30469 0.14453h425.98v0.15625h-425.98zm0.30078 0.15625h425.37v0.15234h-425.37zm0.30078 0.15234h424.77v0.14844h-424.77zm0.15234 0.14844h424.32v0.15234h-424.32zm0.30078 0.15234h423.86v0.14844h-423.86zm0.30078 0.14844h423.26v0.15234h-423.26zm0.15234 0.15234h422.81v0.15234h-422.81zm0.30078 0.15234h422.36v0.14844h-422.36zm0.30469 0.14844h421.75v0.15234h-421.75zm0.30078 0.15234h421.14v0.14844h-421.14zm0.15234 0.14844h420.69v0.15625h-420.69zm0.30078 0.15625h420.24v0.15234h-420.24zm0.30078 0.15234h419.64v0.14844h-419.64zm0.30859 0.14844h419.02v0.15234h-419.02zm0.14453 0.15234h418.57v0.14844h-418.57zm0.30078 0.14844h418.13v0.15234h-418.13zm0.30859 0.15234h417.51v0.15234h-417.51zm0.14844 0.15234h417.06v0.14844h-417.06zm0.30078 0.14844h416.46v0.15234h-416.46zm0.30469 0.15234h416v0.14844h-416zm0.30078 0.14844h415.4v0.15234h-415.4zm0.14844 0.15234h414.95v0.15625h-414.95zm0.30859 0.15625h414.49v0.14844h-414.49zm0.30078 0.14844h413.89v0.15234h-413.89zm0.30078 0.15234h413.29v0.14844h-413.29zm0.15234 0.14844h412.83v0.15234h-412.83zm0.30078 0.15234h412.38v0.15234h-412.38zm0.30078 0.15234h411.78v0.14844h-411.78zm0.30078 0.14844h411.18v0.15234h-411.18zm0.15625 0.15234h410.72v0.14844h-410.72zm0.30078 0.14844h410.26v0.15234h-410.26zm0.30078 0.15234h409.66v0.15625h-409.66zm0.15234 0.15625h409.21v0.14453h-409.21zm0.30078 0.14453h408.75v0.15625h-408.75zm0.30078 0.15625h408.15v0.14453h-408.15zm0.30078 0.14453h407.55v0.15625h-407.55zm0.15625 0.15625h407.09v0.15234h-407.09zm0.30078 0.15234h406.64v0.14844h-406.64zm0.30078 0.14844h406.04v0.15234h-406.04zm0.30469 0.15234h405.43v0.14844h-405.43zm0.14844 0.14844h404.98v0.15234h-404.98zm0.30078 0.15234h404.53v0.15234h-404.53zm0.30859 0.15234h403.91v0.14844h-403.91zm0.30078 0.14844h403.31v0.15625h-403.31zm0.14844 0.15625h402.86v0.14453h-402.86zm0.30469 0.14453h402.4v0.15625h-402.4zm0.30078 0.15625h401.8v0.15234h-401.8zm0.14844 0.15234h401.35v0.14844h-401.35zm0.30859 0.14844h400.89v0.15234h-400.89zm0.30078 0.15234h400.29v0.14844h-400.29zm0.30078 0.14844h399.68v0.15234h-399.68zm0.15234 0.15234h399.23v0.15234h-399.23zm0.30078 0.15234h398.78v0.14844h-398.78zm0.30078 0.14844h398.18v0.15234h-398.18zm0.30078 0.15234h397.57v0.14844h-397.57zm0.15625 0.14844h397.12v0.15625h-397.12zm0.30078 0.15625h396.66v0.15234h-396.66zm0.30078 0.15234h396.06v0.14844h-396.06zm0.30078 0.14844h395.46v0.15234h-395.46zm0.15234 0.15234h395v0.14844h-395zm0.30078 0.14844h394.55v0.15234h-394.55zm0.30078 0.15234h393.95v0.15234h-393.95zm0.15234 0.15234h393.49v0.14844h-393.49zm0.30078 0.14844h393.04v0.15234h-393.04zm0.30469 0.15234h392.43v0.14844h-392.43zm0.30469 0.14844h391.82v0.15234h-391.82zm0.14844 0.15234h391.38v0.15625h-391.38zm0.30078 0.15625h390.93v0.14453h-390.93zm0.30859 0.14453h390.31v0.15625h-390.31zm0.30078 0.15625h389.71v0.14844h-389.71zm0.14453 0.14844h389.26v0.15234h-389.26zm0.30859 0.15234h388.8v0.15234h-388.8zm0.30078 0.15234h388.2v0.14844h-388.2zm0.14844 0.14844h387.75v0.15234h-387.75zm0.30469 0.15234h387.29v0.14844h-387.29zm0.30078 0.14844h386.69v0.15234h-386.69zm0.30469 0.15234h386.09v0.15625h-386.09zm0.15234 0.15625h385.63v0.14453h-385.63zm0.30078 0.14453h385.18v0.15625h-385.18zm0.30078 0.15625h384.57v0.14453h-384.57zm0.30078 0.14453h383.97v0.15625h-383.97zm0.15234 0.15625h383.52v0.15234h-383.52zm0.30078 0.15234h383.07v0.14844h-383.07zm0.30078 0.14844h382.46v0.15234h-382.46zm0.30469 0.15234h381.86v0.14844h-381.86zm0.15234 0.14844h381.4v0.15234h-381.4zm0.30078 0.15234h380.95v0.15234h-380.95zm0.30078 0.15234h380.35v0.14844h-380.35zm0.15234 0.14844h379.89v0.15625h-379.89zm0.30078 0.15625h379.44v0.14453h-379.44zm0.30078 0.14453h378.84v0.15625h-378.84zm0.30859 0.15625h378.22v0.15234h-378.22zm0.14844 0.15234h377.77v0.14844h-377.77zm0.30078 0.14844h377.32v0.15234h-377.32zm0.30469 0.15234h376.71v0.14844h-376.71zm0.30078 0.14844h376.11v0.15234h-376.11zm0.14844 0.15234h375.66v0.15234h-375.66zm0.30859 0.15234h375.2v0.14844h-375.2zm0.30078 0.14844h374.6v0.15234h-374.6zm0.30078 0.15234h374v0.14844h-374zm0.15234 0.14844h373.54v0.15234h-373.54zm0.30078 0.15234h373.09v0.15625h-373.09zm0.30078 0.15625h372.49v0.14844h-372.49zm0.15625 0.14844h372.03v0.15234h-372.03zm0.30078 0.15234h371.57v0.14844h-371.57zm0.30078 0.14844h370.97v0.15234h-370.97zm0.30078 0.15234h370.37v0.15234h-370.37zm0.15234 0.15234h369.92v0.14844h-369.92zm0.30078 0.14844h369.46v0.15234h-369.46zm0.30078 0.15234h368.86v0.14844h-368.86zm0.30078 0.14844h368.26v0.15234h-368.26zm0.15625 0.15234h367.8v0.15625h-367.8zm0.30078 0.15625h367.35v0.14453h-367.35zm0.30078 0.14453h366.75v0.15625h-366.75zm0.15234 0.15625h366.29v0.14453h-366.29zm0.30078 0.14453h365.69v0.15625h-365.69zm0.30078 0.15625h365.24v0.15234h-365.24zm0.30859 0.15234h364.62v0.14844h-364.62zm0.14453 0.14844h364.18v0.15234h-364.18zm0.30469 0.15234h363.72v0.14844h-363.72zm0.30469 0.14844h363.11v0.15234h-363.11zm0.30078 0.15234h362.51v0.15625h-362.51zm0.14844 0.15625h362.06v0.14453h-362.06zm0.30859 0.14453h361.6v0.15625h-361.6zm0.30078 0.15625h361v0.14453h-361zm0.30078 0.14453h360.39v0.15625h-360.39zm0.15234 0.15625h359.94v0.15234h-359.94zm0.30078 0.15234h359.49v0.14844h-359.49zm0.30078 0.14844h358.89v0.15234h-358.89zm0.15234 0.15234h358.43v0.14844h-358.43zm0.30078 0.14844h357.98v0.15234h-357.98zm0.30469 0.15234h357.38v0.15234h-357.38zm0.30078 0.15234h356.77v0.14844h-356.77zm0.15234 0.14844h356.32v0.15234h-356.32zm0.30078 0.15234h355.86v0.14844h-355.86zm0.30078 0.14844h355.26v0.15625h-355.26zm0.30078 0.15625h354.66v0.15234h-354.66zm0.15234 0.15234h354.2v0.14844h-354.2zm0.30078 0.14844h353.75v0.15234h-353.75zm0.30078 0.15234h353.15v0.14844h-353.15zm0.30859 0.14844h352.54v0.15234h-352.54zm0.14844 0.15234h352.09v0.15234h-352.09zm0.30078 0.15234h351.64v0.14844h-351.64zm0.30469 0.14844h351.03v0.15234h-351.03zm0.14844 0.15234h350.57v0.14844h-350.57zm0.30078 0.14844h350.13v0.15234h-350.13zm0.30859 0.15234h349.51v0.15625h-349.51zm0.30078 0.15625h348.91v0.14453h-348.91zm0.14844 0.14453h348.46v0.15625h-348.46zm0.30469 0.15625h348v0.14844h-348zm0.30078 0.14844h347.4v0.15234h-347.4zm0.30078 0.15234h346.8v0.15234h-346.8zm0.15625 0.15234h346.34v0.14844h-346.34zm0.30078 0.14844h345.89v0.15234h-345.89zm0.30078 0.15234h345.29v0.14844h-345.29zm0.30078 0.14844h344.68v0.15234h-344.68zm0.15234 0.15234h344.23v0.15625h-344.23zm0.30078 0.15625h343.78v0.14453h-343.78zm0.30078 0.14453h343.18v0.15625h-343.18zm0.15625 0.15625h342.72v0.14453h-342.72zm0.30078 0.14453h342.26v0.15625h-342.26zm0.30078 0.15625h341.66v0.15234h-341.66zm0.30078 0.15234h341.06v0.14844h-341.06zm0.15234 0.14844h340.6v0.15234h-340.6zm0.30078 0.15234h340.15v0.14844h-340.15zm0.30078 0.14844h339.55v0.15234h-339.55zm0.30859 0.15234h338.93v0.15234h-338.93zm0.14844 0.15234h338.48v0.14844h-338.48zm0.30078 0.14844h338.04v0.15625h-338.04zm0.30469 0.15625h337.43v0.14453h-337.43zm0.14844 0.14453h336.98v0.15625h-336.98zm0.30078 0.15625h336.38v0.15234h-336.38zm0.30859 0.15234h335.91v0.14844h-335.91zm0.30078 0.14844h335.31v0.15234h-335.31zm0.14844 0.15234h334.86v0.14844h-334.86zm0.30469 0.14844h334.4v0.15234h-334.4zm0.30078 0.15234h333.8v0.15234h-333.8zm0.30078 0.15234h333.2v0.14844h-333.2zm0.15625 0.14844h332.74v0.15234h-332.74zm0.30078 0.15234h332.29v0.14844h-332.29zm0.30078 0.14844h331.68v0.15234h-331.68zm0.30078 0.15234h331.08v0.15625h-331.08zm0.15234 0.15625h330.63v0.14844h-330.63zm0.30078 0.14844h330.18v0.15234h-330.18zm0.30078 0.15234h329.57v0.14844h-329.57zm0.15234 0.14844h329.12v0.15234h-329.12zm0.30469 0.15234h328.66v0.15234h-328.66zm0.30078 0.15234h328.06v0.14844h-328.06zm0.30078 0.14844h327.46v0.15234h-327.46zm0.15234 0.15234h327v0.14844h-327zm0.30078 0.14844h326.55v0.15234h-326.55zm0.30078 0.15234h325.95v0.15625h-325.95zm0.30859 0.15625h325.33v0.14453h-325.33zm0.14453 0.14453h324.89v0.15625h-324.89zm0.30078 0.15625h324.44v0.14844h-324.44zm0.30859 0.14844h323.82v0.15234h-323.82zm0.30078 0.15234h323.22v0.15234h-323.22zm0.14844 0.15234h322.77v0.14844h-322.77zm0.30469 0.14844h322.32v0.15234h-322.32zm0.30469 0.15234h321.71v0.14844h-321.71zm0.14453 0.14844h321.26v0.15234h-321.26zm0.30859 0.15234h320.8v0.15625h-320.8zm0.30078 0.15625h320.2v0.14453h-320.2zm0.30078 0.14453h319.6v0.15625h-319.6zm0.15234 0.15625h319.14v0.14453h-319.14zm0.30078 0.14453h318.69v0.15625h-318.69zm0.30078 0.15625h318.09v0.15234h-318.09zm0.30469 0.15234h317.48v0.14844h-317.48zm0.15234 0.14844h317.03v0.15234h-317.03zm0.30078 0.15234h316.57v0.14844h-316.57zm0.30078 0.14844h315.97v0.15234h-315.97zm0.30078 0.15234h315.37v0.15234h-315.37zm0.15234 0.15234h314.91v0.14844h-314.91zm0.30078 0.14844h314.46v0.15625h-314.46zm0.30078 0.15625h313.86v0.14453h-313.86zm0.15625 0.14453h313.4v0.15625h-313.4zm0.30078 0.15625h312.95v0.15234h-312.95zm0.30078 0.15234h312.35v0.14844h-312.35zm0.30469 0.14844h311.74v0.15234h-311.74zm0.14844 0.15234h311.29v0.14844h-311.29zm0.30078 0.14844h310.84v0.15234h-310.84zm0.30859 0.15234h310.22v0.15234h-310.22zm0.30078 0.15234h309.62v0.14844h-309.62zm0.14844 0.14844h309.17v0.15234h-309.17zm0.30469 0.15234h308.71v0.14844h-308.71zm0.30078 0.14844h308.11v0.15234h-308.11zm0.14844 0.15234h307.66v0.15625h-307.66zm0.30859 0.15625h307.05v0.14844h-307.05zm0.30078 0.14844h306.6v0.15234h-306.6zm0.30078 0.15234h306v0.14844h-306zm0.15234 0.14844h305.54v0.15234h-305.54zm0.30078 0.15234h305.09v0.15234h-305.09zm0.30078 0.15234h304.49v0.14844h-304.49zm0.30078 0.14844h303.89v0.15234h-303.89zm0.15625 0.15234h303.43v0.14844h-303.43zm0.30078 0.14844h302.97v0.15234h-302.97zm0.30078 0.15234h302.37v0.15625h-302.37zm0.30078 0.15625h301.77v0.14453h-301.77zm0.15234 0.14453h301.31v0.15625h-301.31zm0.30078 0.15625h300.86v0.14453h-300.86zm0.30078 0.14453h300.26v0.15625h-300.26zm0.15625 0.15625h299.8v0.15234h-299.8zm0.30078 0.15234h299.35v0.14844h-299.35zm0.30078 0.14844h298.75v0.15234h-298.75zm0.30469 0.15234h298.14v0.14844h-298.14zm0.14844 0.14844h297.69v0.15234h-297.69zm0.30078 0.15234h297.24v0.15625h-297.24zm0.30859 0.15625h296.62v0.14453h-296.62zm0.30078 0.14453h296.02v0.15625h-296.02zm0.14453 0.15625h295.57v0.14453h-295.57zm0.30859 0.14453h295.11v0.15625h-295.11zm0.30078 0.15625h294.51v0.15234h-294.51zm0.30078 0.15234h293.91v0.14844h-293.91zm0.15234 0.14844h293.46v0.15234h-293.46zm0.30469 0.15234h293v0.14844h-293zm0.30078 0.14844h292.39v0.15234h-292.39zm0.15234 0.15234h291.94v0.15234h-291.94zm0.30078 0.15234h291.49v0.14844h-291.49zm0.30078 0.14844h290.89v0.15234h-290.89zm0.30078 0.15234h290.29v0.14844h-290.29zm0.15234 0.14844h289.83v0.15625h-289.83zm0.30078 0.15625h289.38v0.15234h-289.38zm0.30469 0.15234h288.77v0.14844h-288.77zm0.30078 0.14844h288.17v0.15234h-288.17zm0.15234 0.15234h287.71v0.14844h-287.71zm0.30078 0.14844h287.26v0.15234h-287.26zm0.30078 0.15234h286.66v0.15234h-286.66zm0.15234 0.15234h286.2v0.14844h-286.2zm0.30078 0.14844h285.6v0.15234h-285.6zm0.30078 0.15234h285.15v0.14844h-285.15zm0.30859 0.14844h284.54v0.15234h-284.54zm0.14844 0.15234h284.09v0.15625h-284.09zm0.30078 0.15625h283.64v0.14453h-283.64zm0.30469 0.14453h283.03v0.15625h-283.03zm0.30078 0.15625h282.43v0.14844h-282.43zm0.14844 0.14844h281.97v0.15234h-281.97zm0.30859 0.15234h281.51v0.15234h-281.51zm0.30078 0.15234h280.91v0.14844h-280.91zm0.30078 0.14844h280.31v0.15234h-280.31zm0.15234 0.15234h279.86v0.14844h-279.86zm0.30078 0.14844h279.4v0.15234h-279.4zm0.30078 0.15234h278.8v0.15625h-278.8zm0.15625 0.15625h278.34v0.14453h-278.34zm0.30078 0.14453h277.89v0.15625h-277.89zm0.30078 0.15625h277.29v0.14453h-277.29zm0.30078 0.14453h276.68v0.15625h-276.68zm0.15234 0.15625h276.23v0.15234h-276.23zm0.30078 0.15234h275.78v0.14844h-275.78zm0.30078 0.14844h275.18v0.15234h-275.18zm0.30078 0.15234h274.57v0.14844h-274.57zm0.15625 0.14844h274.11v0.15234h-274.11zm0.30078 0.15234h273.66v0.15234h-273.66zm0.30078 0.15234h273.06v0.14844h-273.06zm0.30469 0.14844h272.45v0.15625h-272.45zm0.14844 0.15625h272v0.14453h-272zm0.30078 0.14453h271.55v0.15625h-271.55zm0.30859 0.15625h270.93v0.15234h-270.93zm0.14844 0.15234h270.48v0.14844h-270.48zm0.30078 0.14844h270.04v0.15234h-270.04zm0.30469 0.15234h269.43v0.14844h-269.43zm0.30078 0.14844h268.82v0.15234h-268.82zm0.14844 0.15234h268.38v0.15234h-268.38zm0.30859 0.15234h267.91v0.14844h-267.91zm0.30078 0.14844h267.31v0.15234h-267.31zm0.30078 0.15234h266.71v0.14844h-266.71zm0.15234 0.14844h266.25v0.15234h-266.25zm0.30078 0.15234h265.8v0.15625h-265.8zm0.30078 0.15625h265.2v0.14844h-265.2zm0.30078 0.14844h264.6v0.15234h-264.6zm0.15625 0.15234h264.14v0.14844h-264.14zm0.30078 0.14844h263.68v0.15234h-263.68zm0.30078 0.15234h263.08v0.15234h-263.08zm0.15234 0.15234h262.63v0.14844h-262.63zm0.30078 0.14844h262.18v0.15234h-262.18zm0.30078 0.15234h261.57v0.14844h-261.57zm0.30078 0.14844h260.97v0.15234h-260.97zm0.15234 0.15234h260.51v0.15625h-260.51zm0.30469 0.15625h260.06v0.14453h-260.06zm0.30078 0.14453h259.46v0.15625h-259.46zm0.30469 0.15625h258.85v0.14844h-258.85zm0.14844 0.14844h258.4v0.15234h-258.4zm0.30078 0.15234h257.95v0.15234h-257.95zm0.30859 0.15234h257.33v0.14844h-257.33zm0.14453 0.14844h256.89v0.15234h-256.89zm0.30078 0.15234h256.29v0.14844h-256.29zm0.30859 0.14844h255.82v0.15234h-255.82zm0.30078 0.15234h255.22v0.15625h-255.22zm0.14844 0.15625h254.77v0.14453h-254.77zm0.30469 0.14453h254.32v0.15625h-254.32zm0.30078 0.15625h253.71v0.14453h-253.71zm0.30469 0.14453h253.11v0.15625h-253.11zm0.15234 0.15625h252.65v0.15234h-252.65zm0.30078 0.15234h252.2v0.14844h-252.2zm0.30078 0.14844h251.6v0.15234h-251.6zm0.30078 0.15234h251v0.14844h-251zm0.15234 0.14844h250.54v0.15234h-250.54zm0.30078 0.15234h250.09v0.15234h-250.09zm0.30078 0.15234h249.49v0.14844h-249.49zm0.15625 0.14844h249.03v0.15234h-249.03zm0.30078 0.15234h248.57v0.14844h-248.57zm0.30078 0.14844h247.97v0.15625h-247.97zm0.30078 0.15625h247.37v0.15234h-247.37zm0.15234 0.15234h246.91v0.14844h-246.91zm0.30078 0.14844h246.46v0.15234h-246.46zm0.30078 0.15234h245.86v0.14844h-245.86zm0.30859 0.14844h245.25v0.15234h-245.25zm0.14844 0.15234h244.8v0.15234h-244.8zm0.30078 0.15234h244.35v0.14844h-244.35zm0.30469 0.14844h243.74v0.15234h-243.74zm0.30078 0.15234h243.14v0.14844h-243.14zm0.14844 0.14844h242.69v0.15234h-242.69zm0.30859 0.15234h242.22v0.15625h-242.22zm0.30078 0.15625h241.62v0.14844h-241.62zm0.14844 0.14844h241.17v0.15234h-241.17zm0.30469 0.15234h240.71v0.14844h-240.71zm0.30078 0.14844h240.11v0.15234h-240.11zm0.30078 0.15234h239.51v0.15234h-239.51zm0.15625 0.15234h239.05v0.14844h-239.05zm0.30078 0.14844h238.6v0.15234h-238.6zm0.30078 0.15234h238v0.14844h-238zm0.30078 0.14844h237.39v0.15234h-237.39zm0.15234 0.15234h236.94v0.15625h-236.94zm0.30078 0.15625h236.49v0.14453h-236.49zm0.30078 0.14453h235.89v0.15625h-235.89zm0.30078 0.15625h235.29v0.14453h-235.29zm0.15625 0.14453h234.82v0.15625h-234.82zm0.30078 0.15625h234.37v0.15234h-234.37zm0.30078 0.15234h233.77v0.14844h-233.77zm0.15234 0.14844h233.31v0.15234h-233.31zm0.30078 0.15234h232.86v0.14844h-232.86zm0.30078 0.14844h232.26v0.15234h-232.26zm0.30859 0.15234h231.64v0.15234h-231.64zm0.14844 0.15234h231.2v0.14844h-231.2zm0.30078 0.14844h230.75v0.15625h-230.75zm0.30469 0.15625h230.14v0.14453h-230.14zm0.30078 0.14453h229.54v0.15625h-229.54zm0.14844 0.15625h229.09v0.15234h-229.09zm0.30859 0.15234h228.62v0.14844h-228.62zm0.30078 0.14844h228.02v0.15234h-228.02zm0.14453 0.15234h227.57v0.14844h-227.57zm0.30859 0.14844h226.96v0.15234h-226.96zm0.30078 0.15234h226.51v0.15234h-226.51zm0.30078 0.15234h225.91v0.14844h-225.91zm0.15234 0.14844h225.46v0.15234h-225.46zm0.30078 0.15234h225v0.14844h-225zm0.30469 0.14844h224.4v0.15625h-224.4zm0.30078 0.15625h223.79v0.15234h-223.79zm0.15234 0.15234h223.34v0.14844h-223.34zm0.30078 0.14844h222.89v0.15234h-222.89zm0.30078 0.15234h222.29v0.14844h-222.29zm0.30078 0.14844h221.68v0.15234h-221.68zm0.15234 0.15234h221.22v0.15234h-221.22zm0.30078 0.15234h220.78v0.14844h-220.78zm0.30469 0.14844h220.17v0.15234h-220.17zm0.15234 0.15234h219.71v0.14844h-219.71zm0.30078 0.14844h219.26v0.15234h-219.26zm0.30078 0.15234h218.66v0.15625h-218.66zm0.30859 0.15625h218.05v0.14453h-218.05zm0.14453 0.14453h217.6v0.15625h-217.6zm0.30078 0.15625h217.15v0.14844h-217.15zm0.30859 0.14844h216.54v0.15234h-216.54zm0.30078 0.15234h215.93v0.15234h-215.93zm0.14844 0.15234h215.48v0.14844h-215.48zm0.30469 0.14844h215.03v0.15234h-215.03zm0.30078 0.15234h214.43v0.14844h-214.43zm0.30078 0.14844h213.82v0.15234h-213.82zm0.15625 0.15234h213.36v0.15625h-213.36zm0.30078 0.15625h212.91v0.14453h-212.91zm0.30078 0.14453h212.31v0.15625h-212.31zm0.15234 0.15625h211.86v0.14453h-211.86zm0.30078 0.14453h211.4v0.15625h-211.4zm0.30078 0.15625h210.8v0.15234h-210.8zm0.30078 0.15234h210.2v0.14844h-210.2zm0.15625 0.14844h209.74v0.15234h-209.74zm0.30078 0.15234h209.29v0.14844h-209.29zm0.30078 0.14844h208.68v0.15234h-208.68zm0.30078 0.15234h208.08v0.15234h-208.08zm0.15234 0.15234h207.62v0.14844h-207.62zm0.30078 0.14844h207.18v0.15625h-207.18zm0.30078 0.15625h206.57v0.14453h-206.57zm0.15625 0.14453h206.11v0.15625h-206.11zm0.30078 0.15625h205.51v0.15234h-205.51zm0.30078 0.15234h205.06v0.14844h-205.06zm0.30469 0.14844h204.45v0.15234h-204.45zm0.14844 0.15234h204v0.14844h-204zm0.30078 0.14844h203.55v0.15234h-203.55zm0.30859 0.15234h202.93v0.15234h-202.93zm0.30078 0.15234h202.33v0.14844h-202.33zm0.14844 0.14844h201.88v0.15234h-201.88zm0.30469 0.15234h201.43v0.14844h-201.43zm0.30078 0.14844h200.82v0.15234h-200.82zm0.30078 0.15234h200.22v0.15625h-200.22zm0.15625 0.15625h199.77v0.14844h-199.77zm0.30078 0.14844h199.31v0.15234h-199.31zm0.30078 0.15234h198.71v0.14844h-198.71zm0.15234 0.14844h198.25v0.15234h-198.25zm0.30078 0.15234h197.8v0.15234h-197.8zm0.30078 0.15234h197.2v0.14844h-197.2zm0.30078 0.14844h196.6v0.15234h-196.6zm0.15234 0.15234h196.14v0.14844h-196.14zm0.30469 0.14844h195.69v0.15234h-195.69zm0.30078 0.15234h195.08v0.15625h-195.08zm0.30078 0.15625h194.48v0.14453h-194.48zm0.15234 0.14453h194.02v0.15625h-194.02zm0.30078 0.15625h193.57v0.14844h-193.57zm0.30078 0.14844h192.97v0.15234h-192.97zm0.30859 0.15234h192.36v0.15234h-192.36zm0.14453 0.15234h191.91v0.14844h-191.91zm0.30469 0.14844h191.46v0.15234h-191.46zm0.30469 0.15234h190.85v0.14844h-190.85zm0.14844 0.14844h190.4v0.15234h-190.4zm0.30078 0.15234h189.95v0.15625h-189.95zm0.30859 0.15625h189.34v0.14453h-189.34zm0.30078 0.14453h188.73v0.15625h-188.73zm0.14453 0.15625h188.29v0.14453h-188.29zm0.30859 0.14453h187.82v0.15625h-187.82zm0.30078 0.15625h187.22v0.15234h-187.22zm0.30078 0.15234h186.62v0.14844h-186.62zm0.15234 0.14844h186.17v0.15234h-186.17zm0.30078 0.15234h185.71v0.14844h-185.71zm0.30078 0.14844h185.11v0.15234h-185.11zm0.30469 0.15234h184.5v0.15234h-184.5zm0.15234 0.15234h184.05v0.14844h-184.05zm0.30078 0.14844h183.6v0.15234h-183.6zm0.30078 0.15234h183v0.14844h-183zm0.15234 0.14844h182.54v0.15625h-182.54zm0.30078 0.15625h182.09v0.15234h-182.09zm0.30078 0.15234h181.49v0.14844h-181.49zm0.30078 0.14844h180.89v0.15234h-180.89zm0.15625 0.15234h180.42v0.14844h-180.42zm0.30078 0.14844h179.97v0.15234h-179.97zm0.30078 0.15234h179.37v0.15234h-179.37zm0.30469 0.15234h178.76v0.14844h-178.76zm0.14844 0.14844h178.31v0.15234h-178.31zm0.30078 0.15234h177.86v0.14844h-177.86zm0.30859 0.14844h177.25v0.15234h-177.25zm0.14844 0.15234h176.8v0.15625h-176.8zm0.30078 0.15625h176.2v0.14844h-176.2zm0.30469 0.14844h175.74v0.15234h-175.74zm0.30078 0.15234h175.14v0.14844h-175.14zm0.14844 0.14844h174.69v0.15234h-174.69zm0.30859 0.15234h174.22v0.15234h-174.22zm0.30078 0.15234h173.62v0.14844h-173.62zm0.30078 0.14844h173.02v0.15234h-173.02zm0.15234 0.15234h172.57v0.14844h-172.57zm0.30078 0.14844h172.11v0.15234h-172.11zm0.30078 0.15234h171.51v0.15625h-171.51zm0.30078 0.15625h170.91v0.14453h-170.91zm0.15625 0.14453h170.45v0.15625h-170.45zm0.30078 0.15625h170v0.14453h-170zm0.30078 0.14453h169.39v0.15625h-169.39zm0.15234 0.15625h168.94v0.15234h-168.94zm0.30078 0.15234h168.49v0.14844h-168.49zm0.30078 0.14844h167.89v0.15234h-167.89zm0.30078 0.15234h167.29v0.14844h-167.29zm0.15625 0.14844h166.82v0.15234h-166.82zm0.30078 0.15234h166.37v0.15234h-166.37zm0.30078 0.15234h165.77v0.14844h-165.77zm0.30469 0.14844h165.16v0.15625h-165.16zm0.14844 0.15625h164.71v0.14453h-164.71zm0.30078 0.14453h164.26v0.15625h-164.26zm0.30859 0.15625h163.64v0.15234h-163.64zm0.30078 0.15234h163.04v0.14844h-163.04zm0.14844 0.14844h162.59v0.15234h-162.59zm0.30469 0.15234h162.14v0.14844h-162.14zm0.30078 0.14844h161.54v0.15234h-161.54zm0.14844 0.15234h161.09v0.15234h-161.09zm0.30859 0.15234h160.62v0.14844h-160.62zm0.30078 0.14844h160.02v0.15234h-160.02zm0.30078 0.15234h159.42v0.14844h-159.42zm0.15234 0.14844h158.96v0.15625h-158.96zm0.30078 0.15625h158.51v0.15234h-158.51zm0.30078 0.15234h157.91v0.14844h-157.91zm0.30078 0.14844h157.31v0.15234h-157.31zm0.15234 0.15234h156.86v0.14844h-156.86zm0.30078 0.14844h156.4v0.15234h-156.4zm0.30469 0.15234h155.8v0.15234h-155.8zm0.30078 0.15234h155.19v0.14844h-155.19zm0.15234 0.14844h154.73v0.15234h-154.73zm0.30078 0.15234h154.29v0.14844h-154.29zm0.30078 0.14844h153.68v0.15234h-153.68zm0.15234 0.15234h153.22v0.15625h-153.22zm0.30078 0.15625h152.78v0.14453h-152.78zm0.30078 0.14453h152.18v0.15625h-152.18zm0.30859 0.15625h151.56v0.14844h-151.56zm0.14844 0.14844h151.11v0.15234h-151.11zm0.30078 0.15234h150.66v0.15234h-150.66zm0.30469 0.15234h150.05v0.14844h-150.05zm0.30469 0.14844h149.45v0.15234h-149.45zm0.14453 0.15234h149v0.14844h-149zm0.30859 0.14844h148.54v0.15234h-148.54zm0.30078 0.15234h147.93v0.15625h-147.93zm0.14844 0.15625h147.48v0.14453h-147.48zm0.30469 0.14453h146.88v0.15625h-146.88zm0.30078 0.15625h146.43v0.14453h-146.43zm0.30078 0.14453h145.82v0.15625h-145.82zm0.15625 0.15625h145.37v0.15234h-145.37zm0.30078 0.15234h144.91v0.14844h-144.91zm0.30078 0.14844h144.31v0.15234h-144.31zm0.30078 0.15234h143.71v0.14844h-143.71zm0.15234 0.14844h143.25v0.15234h-143.25zm0.30078 0.15234h142.8v0.15234h-142.8zm0.30078 0.15234h142.2v0.14844h-142.2zm0.30078 0.14844h141.6v0.15625h-141.6zm0.15625 0.15625h141.13v0.14453h-141.13zm0.30078 0.14453h140.68v0.15625h-140.68zm0.30078 0.15625h140.08v0.15234h-140.08zm0.15234 0.15234h139.62v0.14844h-139.62zm0.30078 0.14844h139.18v0.15234h-139.18zm0.30078 0.15234h138.57v0.14844h-138.57zm0.30859 0.14844h137.96v0.15234h-137.96zm0.14844 0.15234h137.51v0.15234h-137.51zm0.30078 0.15234h137.06v0.14844h-137.06zm0.30469 0.14844h136.45v0.15234h-136.45zm0.30078 0.15234h135.85v0.14844h-135.85zm0.14844 0.14844h135.4v0.15234h-135.4zm0.30859 0.15234h134.93v0.15625h-134.93zm0.30078 0.15625h134.33v0.14844h-134.33zm0.30078 0.14844h133.73v0.15234h-133.73zm0.15234 0.15234h133.28v0.14844h-133.28zm0.30078 0.14844h132.82v0.15234h-132.82zm0.30078 0.15234h132.22v0.15234h-132.22zm0.15625 0.15234h131.77v0.14844h-131.77zm0.30078 0.14844h131.31v0.15234h-131.31zm0.30078 0.15234h130.71v0.14844h-130.71zm0.30078 0.14844h130.11v0.15234h-130.11zm0.15234 0.15234h129.65v0.15625h-129.65zm0.30078 0.15625h129.2v0.14453h-129.2zm0.30078 0.14453h128.6v0.15625h-128.6zm0.30078 0.15625h128v0.14453h-128zm0.15234 0.14453h127.54v0.15625h-127.54zm0.30469 0.15625h127.09v0.15234h-127.09zm0.30078 0.15234h126.48v0.14844h-126.48zm0.15234 0.14844h126.02v0.15234h-126.02zm0.30078 0.15234h125.42v0.14844h-125.42zm0.30078 0.14844h124.97v0.15234h-124.97zm0.30859 0.15234h124.36v0.15625h-124.36zm0.14453 0.15625h123.91v0.14453h-123.91zm0.30078 0.14453h123.46v0.15625h-123.46zm0.30859 0.15625h122.85v0.14453h-122.85zm0.30078 0.14453h122.25v0.15625h-122.25zm0.14844 0.15625h121.8v0.15234h-121.8zm0.30469 0.15234h121.34v0.14844h-121.34zm0.30469 0.14844h120.73v0.15234h-120.73zm0.30078 0.15234h120.13v0.14844h-120.13zm0.15234 0.14844h119.68v0.15234h-119.68zm0.30078 0.15234h119.22v0.15234h-119.22zm0.30078 0.15234h118.62v0.14844h-118.62zm0.15234 0.14844h118.17v0.15234h-118.17zm0.30078 0.15234h117.57v0.14844h-117.57zm0.30078 0.14844h117.11v0.15625h-117.11zm0.30078 0.15625h116.51v0.15234h-116.51zm0.15625 0.15234h116.05v0.14844h-116.05zm0.30078 0.14844h115.6v0.15234h-115.6zm0.30078 0.15234h115v0.14844h-115zm0.30078 0.14844h114.39v0.15234h-114.39zm0.15234 0.15234h113.94v0.15234h-113.94zm0.30078 0.15234h113.49v0.14844h-113.49zm0.30078 0.14844h112.89v0.15234h-112.89zm0.30859 0.15234h112.27v0.14844h-112.27zm0.14844 0.14844h111.82v0.15234h-111.82zm0.30078 0.15234h111.37v0.15625h-111.37zm0.30469 0.15625h110.76v0.14844h-110.76zm0.14844 0.14844h110.31v0.15234h-110.31zm0.30078 0.15234h109.86v0.14844h-109.86zm0.30859 0.14844h109.25v0.15234h-109.25zm0.30078 0.15234h108.64v0.15234h-108.64zm0.14844 0.15234h108.2v0.14844h-108.2zm0.30469 0.14844h107.74v0.15234h-107.74zm0.30078 0.15234h107.14v0.14844h-107.14zm0.30078 0.14844h106.54v0.15234h-106.54zm0.15625 0.15234h106.08v0.15625h-106.08zm0.30078 0.15625h105.62v0.14453h-105.62zm0.30078 0.14453h105.02v0.15625h-105.02zm0.30078 0.15625h104.42v0.14453h-104.42zm0.15234 0.14453h103.96v0.15625h-103.96zm0.30078 0.15625h103.51v0.15234h-103.51zm0.30078 0.15234h102.91v0.14844h-102.91zm0.15625 0.14844h102.45v0.15234h-102.45zm0.30078 0.15234h102v0.14844h-102zm0.30078 0.14844h101.39v0.15234h-101.39zm0.30078 0.15234h100.79v0.15234h-100.79zm0.15234 0.15234h100.34v0.14844h-100.34zm0.30078 0.14844h99.887v0.15625h-99.887zm0.30078 0.15625h99.285v0.14453h-99.285zm0.30859 0.14453h98.668v0.15625h-98.668zm0.14844 0.15625h98.219v0.15234h-98.219zm0.30078 0.15234h97.77v0.14844h-97.77zm0.30469 0.14844h97.16v0.15234h-97.16zm0.14844 0.15234h96.711v0.14844h-96.711zm0.30078 0.14844h96.109v0.15234h-96.109zm0.30859 0.15234h95.645v0.15234h-95.645zm0.30078 0.15234h95.043v0.14844h-95.043zm0.14453 0.14844h94.598v0.15234h-94.598zm0.30859 0.15234h94.137v0.14844h-94.137zm0.30078 0.14844h93.535v0.15625h-93.535zm0.30078 0.15625h92.934v0.15234h-92.934zm0.15234 0.15234h92.48v0.14844h-92.48zm0.30469 0.14844h92.023v0.15234h-92.023zm0.30078 0.15234h91.418v0.14844h-91.418zm0.30078 0.14844h90.816v0.15234h-90.816zm0.15234 0.15234h90.363v0.15234h-90.363zm0.30078 0.15234h89.91v0.14844h-89.91zm0.30078 0.14844h89.309v0.15234h-89.309zm0.15234 0.15234h88.855v0.14844h-88.855zm0.30078 0.14844h88.402v0.15234h-88.402zm0.30078 0.15234h87.801v0.15625h-87.801zm0.30469 0.15625h87.195v0.14453h-87.195zm0.15234 0.14453h86.734v0.15625h-86.734zm0.30078 0.15625h86.285v0.14844h-86.285zm0.30078 0.14844h85.684v0.15234h-85.684zm0.30859 0.15234h85.07v0.15234h-85.07zm0.14453 0.15234h84.621v0.14844h-84.621zm0.30078 0.14844h84.176v0.15234h-84.176zm0.30859 0.15234h83.559v0.14844h-83.559zm0.30078 0.14844h82.957v0.15234h-82.957zm0.14844 0.15234h82.508v0.15625h-82.508zm0.30469 0.15625h82.051v0.14453h-82.051zm0.30078 0.14453h81.449v0.15625h-81.449zm0.14844 0.15625h81v0.14453h-81zm0.30859 0.14453h80.535v0.15625h-80.535zm0.30078 0.15625h79.934v0.15234h-79.934zm0.30078 0.15234h79.332v0.14844h-79.332zm0.15234 0.14844h78.879v0.15234h-78.879zm0.30078 0.15234h78.426v0.14844h-78.426zm0.30078 0.14844h77.824v0.15234h-77.824zm0.30078 0.15234h77.223v0.15234h-77.223zm0.15625 0.15234h76.766v0.14844h-76.766zm0.30078 0.14844h76.309v0.15625h-76.309zm0.30078 0.15625h75.707v0.14453h-75.707zm0.30078 0.14453h75.105v0.15625h-75.105zm0.15234 0.15625h74.648v0.15234h-74.648zm0.30078 0.15234h74.199v0.14844h-74.199zm0.30078 0.14844h73.598v0.15234h-73.598zm0.15625 0.15234h73.133v0.14844h-73.133zm0.30078 0.14844h72.684v0.15234h-72.684zm0.30078 0.15234h72.082v0.15234h-72.082zm0.30469 0.15234h71.473v0.14844h-71.473zm0.14844 0.14844h71.023v0.15234h-71.023zm0.30078 0.15234h70.574v0.14844h-70.574zm0.30859 0.14844h69.957v0.15234h-69.957zm0.30078 0.15234h69.355v0.15625h-69.355zm0.14844 0.15625h68.906v0.14844h-68.906zm0.30469 0.14844h68.449v0.15234h-68.449zm0.30078 0.15234h67.848v0.14844h-67.848zm0.14844 0.14844h67.398v0.15234h-67.398zm0.30859 0.15234h66.789v0.15234h-66.789zm0.30078 0.15234h66.332v0.14844h-66.332zm0.30078 0.14844h65.73v0.15234h-65.73zm0.15234 0.15234h65.277v0.14844h-65.277zm0.30078 0.14844h64.824v0.15234h-64.824zm0.30078 0.15234h64.223v0.15625h-64.223zm0.30078 0.15625h63.621v0.14453h-63.621zm0.15234 0.14453h63.168v0.15625h-63.168zm0.30469 0.15625h62.707v0.14844h-62.707zm0.30078 0.14844h62.105v0.15234h-62.105zm0.30078 0.15234h61.504v0.15234h-61.504zm0.15234 0.15234h61.047v0.14844h-61.047zm0.30078 0.14844h60.598v0.15234h-60.598zm0.30078 0.15234h59.996v0.14844h-59.996zm0.15234 0.14844h59.535v0.15234h-59.535zm0.30078 0.15234h58.934v0.15625h-58.934zm0.30469 0.15625h58.328v0.14453h-58.328zm0.30469 0.14453h57.723v0.15625h-57.723zm0.14844 0.15625h57.273v0.14453h-57.273zm0.30078 0.14453h56.668v0.15625h-56.668zm0.30859 0.15625h56.055v0.15234h-56.055zm0.30078 0.15234h55.453v0.14844h-55.453zm0.14453 0.14844h55.008v0.15234h-55.008zm0.30859 0.15234h54.246v0.14844h-54.246zm0.30078 0.14844h53.645v0.15234h-53.645zm0.30078 0.15234h53.043v0.15234h-53.043zm0.15234 0.15234h52.582v0.14844h-52.582zm0.30078 0.14844h51.832v0.15234h-51.832zm0.30469 0.15234h51.223v0.14844h-51.223zm0.30078 0.14844h50.621v0.15625h-50.621zm0.30078 0.15625h50.02v0.15234h-50.02zm0.30469 0.15234h49.258v0.14844h-49.258zm0.30078 0.14844h48.656v0.15234h-48.656zm0.30078 0.15234h47.902v0.14844h-47.902zm0.30078 0.14844h47.148v0.15234h-47.148zm0.30078 0.15234h46.398v0.15234h-46.398zm0.45703 0.15234h45.633v0.14844h-45.633zm0.30078 0.14844h44.883v0.15234h-44.883zm0.45312 0.15234h43.977v0.14844h-43.977zm0.30078 0.14844h43.223v0.15234h-43.223zm0.45703 0.15234h42.309v0.15625h-42.309zm0.30078 0.15625h41.555v0.14453h-41.555zm0.45312 0.14453h40.652v0.15625h-40.652zm0.30078 0.15625h39.742v0.14844h-39.742zm0.45703 0.14844h38.832v0.15234h-38.832zm0.45312 0.15234h37.93v0.15234h-37.93zm0.60156 0.15234h36.723v0.14844h-36.723zm0.45312 0.14844h35.812v0.15234h-35.812zm0.45703 0.15234h34.754v0.14844h-34.754zm0.45312 0.14844h33.699v0.15234h-33.699zm0.45312 0.15234h32.492v0.15625h-32.492zm0.75781 0.15625h31.125v0.14453h-31.125zm0.60156 0.14453h29.922v0.15625h-29.922zm0.60156 0.15625h28.711v0.14453h-28.711zm0.60937 0.14453h27.199v0.15625h-27.199zm0.75391 0.15625h25.688v0.15234h-25.688zm0.75781 0.15234h24.023v0.14844h-24.023zm0.90234 0.14844h22.363v0.15234h-22.363zm0.91016 0.15234h20.398v0.14844h-20.398zm0.90625 0.14844h18.281v0.15234h-18.281zm1.3594 0.15234h15.711v0.15234h-15.711zm1.3555 0.15234h13v0.14844h-13zm1.6641 0.14844h9.0664v0.15625h-9.0664z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m762.36 403.64-24.379 2.4492v7.5273l-197.7-114.15c-14.828-8.5664-40.734-7.4922-57.859 2.3945l-410.35 236.94v-12.043l-24.375 2.4492v32.75c-0.75 6.0469 2.4883 11.926 9.9023 16.207l212.07 122.45c14.836 8.5586 40.738 7.4844 57.859-2.4062l420.66-242.89c9.0977-5.2539 13.836-11.93 14.109-18.324l0.058594-33.352"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ew",
    x1: 2.4046e-11,
    x2: 0.99998,
    gradientTransform: "matrix(714.77 0 0 714.84 47.588 500.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9dacd0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9dacd0",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9dadd0",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9dadd0",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9eadd0",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9eaed1",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9fafd1",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9fafd1",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9fafd1",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0b0d2",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0b0d2",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0b0d2",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1b1d2",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1b1d2",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2b2d2",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2b3d2",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3b3d3",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3b3d3",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3b4d3",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4b4d3",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4b4d3",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4b5d4",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a5b6d4",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a5b6d4",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6b6d4",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6b7d4",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7b7d5",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7b8d5",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7b8d5",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a8b8d5",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a8b8d5",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a8b8d5",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a9b9d6",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a9b9d6",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aabad6",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aabad6",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aabad7",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#abbbd7",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#abbbd7",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#abbbd7",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#acbcd8",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#acbcd8",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adbdd9",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adbdd9",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aebed9",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#afbfda",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#afbfda",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b0c0da",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b0c0da",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b1c1db",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b1c1db",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b1c2db",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b2c3dc",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b2c3dc",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3c4dc",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3c4dc",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4c5dd",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4c5dd",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b5c6dd",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6c6de",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6c6de",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7c7de",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7c7de",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7c8de",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7c8de",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b8c9df",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b8c9df",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9cadf",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9cadf",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.586 260.22h714.75v413.78h-714.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m98 290h614v355h-614z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m711.4 427.93-238.27-137.57-374.59 216.29 238.26 137.57 374.59-216.29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m711.4 427.93-238.27-137.57-374.59 216.29 238.26 137.57 374.59-216.29"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.891 299.68 72.793 442.69 653.37-107.46-72.793-442.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc",
    x1: 0.085947,
    x2: 0.89498,
    gradientTransform: "matrix(807.6 -132.83 132.81 807.68 8.8755 532.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dffac1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dffac1",
    offset: 0.0039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#def9c1",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcf9c2",
    offset: 0.011719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbf9c2",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daf9c3",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8f8c4",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d7f8c4",
    offset: 0.027344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6f8c4",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5f8c4",
    offset: 0.035156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3f8c5",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3f8c5",
    offset: 0.042969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2f8c5",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1f7c6",
    offset: 0.050781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0f7c6",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cef7c7",
    offset: 0.058594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cdf7c7",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccf6c8",
    offset: 0.066406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#caf6c9",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9f5c9",
    offset: 0.074219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7f5c9",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6f5ca",
    offset: 0.082031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5f5ca",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5f4cb",
    offset: 0.089844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4f4cb",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c2f4cc",
    offset: 0.097656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c1f4cc",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0f3cd",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bef3ce",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bdf2ce",
    offset: 0.11328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bcf2cf",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bbf2cf",
    offset: 0.12109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9f1cf",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9f1cf",
    offset: 0.12891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b8f1d0",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7f1d0",
    offset: 0.13672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6f0d1",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4f0d1",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b2efd2",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b1efd2",
    offset: 0.15234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b0efd2",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#afefd3",
    offset: 0.16016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adeed3",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adeed4",
    offset: 0.16797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aceed4",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#abeed5",
    offset: 0.17578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aaeed5",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a8edd6",
    offset: 0.18359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7edd6",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6edd7",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4ecd7",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3ecd8",
    offset: 0.19922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2ecd9",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1ecd9",
    offset: 0.20703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9febd9",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9febd9",
    offset: 0.21484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9eebda",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9debda",
    offset: 0.22266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9cebdb",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9aebdb",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98ebdc",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97eadc",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96eadd",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95e9dd",
    offset: 0.24609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94e9de",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93e9de",
    offset: 0.25391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92e9df",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91e8df",
    offset: 0.26172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90e8df",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fe8e0",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8de8e0",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ce7e1",
    offset: 0.27734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae7e1",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89e7e1",
    offset: 0.28516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88e7e1",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87e6e2",
    offset: 0.29297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86e6e2",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85e6e3",
    offset: 0.30078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84e6e3",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83e5e4",
    offset: 0.30859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82e4e4",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81e4e5",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7fe4e6",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ee4e6",
    offset: 0.32422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ce3e7",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7be3e7",
    offset: 0.33203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ae3e8",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ae3e8",
    offset: 0.33984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e2e8",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77e2e9",
    offset: 0.34766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76e2e9",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75e1ea",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73e1ea",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72e1ea",
    offset: 0.36328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71e0eb",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70e0eb",
    offset: 0.37109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6fe0eb",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee0ec",
    offset: 0.37891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cdfec",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cdfed",
    offset: 0.38672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6bdfed",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6adfee",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68dfee",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67dfef",
    offset: 0.40234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65dfef",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64def0",
    offset: 0.41016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63def0",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62def0",
    offset: 0.41797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61def0",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60ddf1",
    offset: 0.42578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fddf1",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eddf2",
    offset: 0.43359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dddf3",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cdcf3",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5adcf4",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59dcf4",
    offset: 0.44922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58dcf5",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57dbf5",
    offset: 0.45703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56dbf6",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56daf6",
    offset: 0.46484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55daf6",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55d9f6",
    offset: 0.47266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55d9f6",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d7f6",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d6f6",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d5f6",
    offset: 0.48828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d4f6",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d4f6",
    offset: 0.49609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d3f6",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d3f6",
    offset: 0.50391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d2f7",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d1f7",
    offset: 0.51172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52d1f7",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52d0f7",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cef7",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cef7",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ccf7",
    offset: 0.53516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cbf7",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cbf7",
    offset: 0.54297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52caf7",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51caf7",
    offset: 0.55078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c9f7",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c8f7",
    offset: 0.55859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c7f7",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c6f7",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c5f7",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c4f7",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c4f7",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c3f7",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc2f8",
    offset: 0.58984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc1f8",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc0f8",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fbff8",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebdf8",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebdf8",
    offset: 0.61328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebcf8",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebbf8",
    offset: 0.62109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebaf8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4dbaf8",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db9f8",
    offset: 0.63672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db8f8",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4cb7f8",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4cb6f8",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4cb6f8",
    offset: 0.65234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb5f8",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb4f8",
    offset: 0.66016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb4f8",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb3f8",
    offset: 0.66797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb2f8",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ab1f8",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ab0f8",
    offset: 0.68359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aaff8",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aaef8",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49adf8",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49adf8",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49acf8",
    offset: 0.70703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49abf8",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49aaf8",
    offset: 0.71484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48aaf8",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a9f8",
    offset: 0.72266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a8f8",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a7f8",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a6f8",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a5f8",
    offset: 0.73828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a4f8",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a4f8",
    offset: 0.74609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a3f8",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a3f9",
    offset: 0.75391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a2f9",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a1f9",
    offset: 0.76172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a1f9",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a0f9",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469ff9",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469ef9",
    offset: 0.77734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469ef9",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469df9",
    offset: 0.78516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469df9",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469cf9",
    offset: 0.79297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469cf9",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459bf9",
    offset: 0.80078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459af9",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4599f9",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4598f9",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4597f9",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4496f9",
    offset: 0.82422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4495f9",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4495f9",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4494f9",
    offset: 0.83984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4493f9",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4393fa",
    offset: 0.84766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4392fa",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4391fa",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4391fa",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4290fa",
    offset: 0.86328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4290fa",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428ffa",
    offset: 0.87109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428efa",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428dfa",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418cfa",
    offset: 0.88672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418bfa",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418afa",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4189fa",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4189fa",
    offset: 0.90234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4188fa",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4088fa",
    offset: 0.91016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4087fa",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4087fa",
    offset: 0.91797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4086fa",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4086fa",
    offset: 0.92578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4085fa",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4084fa",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3f83fb",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e82fb",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e82fb",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e81fb",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e80fb",
    offset: 0.96484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7ffb",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7efb",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7dfb",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7cfb",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7cfb",
    offset: 0.98828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3c7bfb",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3c7bfb",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m165.25 455.35h111.56v64.293h-111.56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220.91 519.64c-1.3633 0-2.7383-0.24219-3.8828-0.73438-0.21484-0.085937-0.41406-0.1875-0.60938-0.29297-0.011719-0.007813-0.019531-0.007813-0.03125-0.011719-0.011719-0.011719-0.027344-0.019531-0.046875-0.03125-0.015625-0.011719-0.039063-0.023438-0.058594-0.027344l-49.098-28.355c-0.011719-0.003906-0.019532-0.011718-0.03125-0.015625-0.41406-0.23828-0.73047-0.51562-1.0078-0.79297-0.007812 0-0.011719 0.007813-0.019531 0.011719-1.4453-1.4531-1.0977-3.3516 1.0273-4.5859l48.781-28.348c1.2617-0.73828 2.9375-1.1094 4.6211-1.1094 1.6836 0 3.3711 0.37109 4.6562 1.1133l49.102 28.348c2.1484 1.2461 2.5 3.1523 1.043 4.6055-0.003907-0.003907-0.003907-0.011719-0.011719-0.015625-0.27734 0.27734-0.59375 0.54688-1.0039 0.77734l-48.777 28.355c-1.2773 0.73828-2.9648 1.1094-4.6523 1.1094"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.12 489.38h109.23v30.262h-109.23z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220.91 519.64c-1.3672 0-2.7422-0.24219-3.8867-0.73438 1.1445 0.49219 2.5195 0.73438 3.8828 0.73438 1.6875 0 3.375-0.37109 4.6523-1.1094l48.777-28.355c0.41016-0.23047 0.72656-0.5 1.0039-0.77734 0.007812 0.003906 0.007812 0.011718 0.011719 0.015625-0.26953 0.27344-0.61328 0.53125-1.0156 0.76953l-48.777 28.348c-1.2773 0.73828-2.9609 1.1094-4.6484 1.1094m-4.4961-1.0273c-0.011719-0.007813-0.019531-0.007813-0.03125-0.011719 0.011719 0.003906 0.019531 0.003906 0.03125 0.011719m-0.078125-0.042969c-0.015625-0.011719-0.039063-0.023438-0.058594-0.027344l-49.098-28.355 49.098 28.355c0.019531 0.003906 0.042969 0.015625 0.058594 0.027344m-49.188-28.398c-0.40625-0.23828-0.75-0.50391-1.0273-0.78125 0.007812-0.003906 0.011719-0.011719 0.019531-0.011719 0.27734 0.27734 0.59375 0.55469 1.0078 0.79297"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "di"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m220.91 519.64c-1.3672 0-2.7422-0.24219-3.8867-0.73438 1.1445 0.49219 2.5195 0.73438 3.8828 0.73438 1.6875 0 3.375-0.37109 4.6523-1.1094l48.777-28.355c0.41016-0.23047 0.72656-0.5 1.0039-0.77734 0.007812 0.003906 0.007812 0.011718 0.011719 0.015625-0.26953 0.27344-0.61328 0.53125-1.0156 0.76953l-48.777 28.348c-1.2773 0.73828-2.9609 1.1094-4.6484 1.1094m-4.4961-1.0273c-0.011719-0.007813-0.019531-0.007813-0.03125-0.011719 0.011719 0.003906 0.019531 0.003906 0.03125 0.011719m-0.078125-0.042969c-0.015625-0.011719-0.039063-0.023438-0.058594-0.027344l-49.098-28.355 49.098 28.355c0.019531 0.003906 0.042969 0.015625 0.058594 0.027344m-49.188-28.398c-0.40625-0.23828-0.75-0.50391-1.0273-0.78125 0.007812-0.003906 0.011719-0.011719 0.019531-0.011719 0.27734 0.27734 0.59375 0.55469 1.0078 0.79297"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gt",
    cx: 0,
    cy: 0,
    r: 405.55,
    gradientTransform: "matrix(.99995 0 0 1 226.46 453.71)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54dbde",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55dbde",
    offset: 0.0039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55dbde",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56dcde",
    offset: 0.011719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57dcdf",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57dcdf",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58dcdf",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59dcdf",
    offset: 0.027344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5adcdf",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5adcdf",
    offset: 0.035156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5bdddf",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cdddf",
    offset: 0.042969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cdddf",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ddddf",
    offset: 0.050781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5edddf",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5edddf",
    offset: 0.058594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fdddf",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fdedf",
    offset: 0.066406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60dedf",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61dee0",
    offset: 0.074219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61dee0",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62dee0",
    offset: 0.082031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63dee0",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63dee0",
    offset: 0.089844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64dfe0",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65dfe0",
    offset: 0.097656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66dfe1",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67dfe1",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67dfe1",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68dfe1",
    offset: 0.11328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69dfe1",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69dfe1",
    offset: 0.12109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6adfe1",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6bdfe1",
    offset: 0.12891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6bdfe2",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cdfe2",
    offset: 0.13672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cdfe2",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de0e2",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee0e2",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee0e2",
    offset: 0.15234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6fe0e2",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70e0e2",
    offset: 0.16016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70e0e3",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71e0e3",
    offset: 0.16797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72e1e3",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72e1e3",
    offset: 0.17578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73e1e3",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74e1e3",
    offset: 0.18359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75e1e3",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75e1e4",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76e1e4",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77e2e4",
    offset: 0.19922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77e2e4",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78e2e4",
    offset: 0.20703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e2e4",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e2e4",
    offset: 0.21484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ae2e4",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ae2e4",
    offset: 0.22266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7be3e5",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ce3e6",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ce3e6",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7de3e6",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ee3e6",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ee3e6",
    offset: 0.24609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7fe3e6",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80e4e6",
    offset: 0.25391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81e4e6",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81e4e6",
    offset: 0.26172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82e4e7",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83e4e7",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83e4e7",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84e5e7",
    offset: 0.27734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85e5e7",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85e6e7",
    offset: 0.28516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86e6e8",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87e6e8",
    offset: 0.29297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88e6e8",
    offset: 0.30078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89e6e8",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae6e8",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8be7e8",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8be7e9",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ce7e9",
    offset: 0.32422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8de7e9",
    offset: 0.33203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ee8e9",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fe8e9",
    offset: 0.33984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90e8e9",
    offset: 0.34766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91e8ea",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91e8ea",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92e8ea",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93e9ea",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94e9ea",
    offset: 0.37109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95e9ea",
    offset: 0.37891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96e9eb",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97e9eb",
    offset: 0.38672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97eaeb",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98eaeb",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99eaeb",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9aeaeb",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9beaeb",
    offset: 0.41016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ceaeb",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9cebeb",
    offset: 0.41797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9debeb",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9eebeb",
    offset: 0.42578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9febeb",
    offset: 0.43359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0ebec",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1ebec",
    offset: 0.44922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1ebec",
    offset: 0.46484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0ebec",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9febeb",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9eebeb",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9debeb",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9cebeb",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ceaeb",
    offset: 0.50391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9beaeb",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9aeaeb",
    offset: 0.51172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9aeaeb",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99eaeb",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98eaeb",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98eaeb",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97eaeb",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96e9eb",
    offset: 0.53516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96e9eb",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95e9ea",
    offset: 0.54297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95e9ea",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94e9ea",
    offset: 0.55078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94e9ea",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93e9ea",
    offset: 0.55859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92e9ea",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92e8ea",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92e8ea",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91e8ea",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90e8e9",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90e8e9",
    offset: 0.58203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fe8e9",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fe8e9",
    offset: 0.58984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ee8e9",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ee7e9",
    offset: 0.59766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8de7e9",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ce7e9",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8be7e9",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8be7e8",
    offset: 0.61328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae7e8",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae7e8",
    offset: 0.62109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89e7e8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88e6e8",
    offset: 0.62891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88e6e8",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87e6e8",
    offset: 0.63672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86e6e7",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86e6e7",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85e5e7",
    offset: 0.65234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84e5e7",
    offset: 0.66016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83e4e7",
    offset: 0.66797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82e4e7",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81e4e7",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81e4e7",
    offset: 0.68359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80e4e6",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7fe4e6",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7fe3e6",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ee3e6",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7de3e6",
    offset: 0.70703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ce3e6",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7be3e5",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ae3e5",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e2e4",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e2e4",
    offset: 0.73828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78e2e4",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77e2e4",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76e2e4",
    offset: 0.75391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76e1e4",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75e1e4",
    offset: 0.76172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75e1e3",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74e1e3",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73e1e3",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73e1e3",
    offset: 0.77734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72e1e3",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71e1e3",
    offset: 0.78516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71e0e3",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70e0e3",
    offset: 0.79297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70e0e2",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6fe0e2",
    offset: 0.80078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6fe0e2",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee0e2",
    offset: 0.80859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de0e2",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de0e2",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cdfe2",
    offset: 0.82422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cdfe2",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6bdfe1",
    offset: 0.83203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6adfe1",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69dfe1",
    offset: 0.83984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69dfe1",
    offset: 0.84766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68dfe1",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67dfe1",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67dfe1",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66dfe1",
    offset: 0.86328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65dfe1",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65dfe0",
    offset: 0.87109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64dee0",
    offset: 0.87891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63dee0",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63dee0",
    offset: 0.88672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62dee0",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62dee0",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61dee0",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60dee0",
    offset: 0.90234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60dedf",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fdedf",
    offset: 0.91016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fdddf",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5edddf",
    offset: 0.91797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ddddf",
    offset: 0.92578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cdddf",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cdddf",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5bdddf",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5bdcdf",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5adcdf",
    offset: 0.94922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5adcdf",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59dcdf",
    offset: 0.95703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58dcdf",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57dcdf",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56dcdf",
    offset: 0.97266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56dcde",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55dbde",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55dbde",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54dbde",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53dbde",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m404.21 330h71.793v119h-71.793z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m468.42 359.21-48.613-28.07c-1.7539-1.0078-3.3516-1.0508-4.5625-0.29297l-10.91 6.3047 6.8125 3.9297v60.965c0 5.0156 3.0469 10.848 6.8125 13.02l43.969 25.391v8.2617l10.559-6.1016c1.6719-0.69531 2.7539-2.7188 2.7539-5.6992v-64.684c0-5.0195-3.0547-10.852-6.8203-13.023z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ei"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m468.42 359.21-48.613-28.07c-1.7539-1.0078-3.3516-1.0508-4.5625-0.29297l-10.91 6.3047 6.8125 3.9297v60.965c0 5.0156 3.0469 10.848 6.8125 13.02l43.969 25.391v8.2617l10.559-6.1016c1.6719-0.69531 2.7539-2.7188 2.7539-5.6992v-64.684c0-5.0195-3.0547-10.852-6.8203-13.023"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ha"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m497.33 334.36-90.441-17.477-24.637 127.57 90.434 17.473z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ia",
    x1: -0.064363,
    x2: 0.95804,
    gradientTransform: "matrix(-24.101 124.77 -124.76 -24.104 450.14 333.58)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffefe",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffdfd",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffcfc",
    offset: 0.11328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbfb",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbfb",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffafa",
    offset: 0.12891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffafa",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff9f9",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff9f9",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff8f8",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7f8",
    offset: 0.15234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7f8",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7f7",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6f6",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff5f5",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff4f4",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff3f3",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff3f3",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff2f2",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff1f1",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff0f0",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffefef",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fee",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedee",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedee",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeced",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffebec",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeaeb",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe9ea",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe9ea",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8e9",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe7e8",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe6e7",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe5e6",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4e5",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe3e4",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe2e3",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe2e3",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1e2",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe0e1",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdfe0",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdedf",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdedf",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdddf",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdcde",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdbdd",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdadc",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd9db",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd8db",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd8da",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd7d9",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd6d8",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd5d7",
    offset: 0.42578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd4d7",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd4d6",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd3d5",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd2d4",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd2d4",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd1d3",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd0d2",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcfd1",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffced0",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffced0",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcdd0",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcccf",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcbce",
    offset: 0.50391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcbce",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcacd",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc9cc",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc8cb",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc8cb",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc7ca",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc6c9",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc5c8",
    offset: 0.55078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc5c7",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc4c7",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc3c6",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc3c5",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc2c5",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc2c5",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc1c4",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc0c3",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbfc2",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbec2",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbdc2",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbdc1",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbcc0",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbbbf",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbabe",
    offset: 0.63672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb9be",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb9bd",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb8bc",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb8bc",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb7bb",
    offset: 0.66016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb7ba",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb6ba",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb5b9",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb4b8",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb4b7",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb3b7",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb3b6",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb2b5",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb1b5",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb0b4",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffafb3",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaeb2",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaeb2",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffadb1",
    offset: 0.74609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffacb0",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffacb0",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffabaf",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaaae",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaaad",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa9ad",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa8ac",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa7ab",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa6aa",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa5aa",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa4a9",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa3a9",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa3a8",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa2a7",
    offset: 0.83203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa1a7",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa1a6",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa0a5",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9fa4",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9fa3",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ea3",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9da2",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ca1",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ba0",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9a9f",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff999f",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff999f",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff989e",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff989d",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff979c",
    offset: 0.92578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff969c",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff969b",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff959a",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9499",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9499",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9398",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9297",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9196",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9096",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9095",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8f95",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8e94",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m402 336h62.652v114h-62.652z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.96 337.41 48.613 28.07c3.7617 2.1758 6.8125 8.0039 6.8125 13.02v64.684c0 5.0195-3.0508 7.3281-6.8125 5.1523l-48.613-28.07c-3.7656-2.1719-6.8125-8.0039-6.8125-13.02v-64.684c0-2.6328 0.83984-4.5234 2.1836-5.4062 1.2188-0.79688 2.8398-0.77344 4.6289 0.25391z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.96 337.41 48.613 28.07c3.7617 2.1758 6.8125 8.0039 6.8125 13.02v64.684c0 5.0195-3.0508 7.3281-6.8125 5.1523l-48.613-28.07c-3.7656-2.1719-6.8125-8.0039-6.8125-13.02v-64.684c0-2.6328 0.83984-4.5234 2.1836-5.4062 1.2188-0.79688 2.8398-0.77344 4.6289 0.25391"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m519.26 377.72-94.551-71.289-77.422 102.71 94.551 71.285z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dz",
    x1: 0.04171,
    x2: 0.59894,
    gradientTransform: "matrix(-138.94 184.32 -184.3 -138.95 477.44 334.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b6a",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b6a",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b6b",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8a6b",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8a6c",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8a6c",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff896d",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff896d",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff886e",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff886f",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8870",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8770",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8771",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8672",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8673",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8573",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8574",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8574",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8575",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8476",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8377",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8377",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8378",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8379",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8279",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff827a",
    offset: 0.18359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff817a",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff817b",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff817b",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff807c",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff807d",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7f7e",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7f7f",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7e7f",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7e80",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7d81",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7d81",
    offset: 0.26172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7d82",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7d82",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7c83",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7c83",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7b84",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7b85",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7a86",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7a87",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7a87",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7987",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7988",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7989",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff798a",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff788a",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff788b",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff778c",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff778c",
    offset: 0.38672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff778d",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff768d",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff768e",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff768e",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff768f",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff758f",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7590",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7491",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7491",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7492",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7392",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7392",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7293",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7294",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7194",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7195",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7196",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7097",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7097",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6f98",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6f99",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6f99",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6e9a",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6e9a",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6e9b",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6d9c",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6c9d",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6c9d",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6c9e",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6c9e",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6c9f",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6b9f",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6b9f",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6ba0",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6ba1",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6aa1",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6aa2",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff69a3",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff69a3",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff69a4",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff69a4",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff68a5",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff67a6",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff66a6",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff65a6",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff65a6",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff64a6",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff63a6",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff62a6",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff61a6",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff60a6",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff60a6",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5fa7",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5ea7",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5da7",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5ca7",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5ca7",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5ba7",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5aa7",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff59a7",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff58a7",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff57a7",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff56a7",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff56a7",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff55a7",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff54a7",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff53a7",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff53a7",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff52a7",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff52a7",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff51a7",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff50a8",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4fa8",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ea8",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4da8",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4da8",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ca8",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ba8",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4aa8",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff49a8",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff48a8",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff48a8",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff47a8",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff46a8",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff45a8",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff44a8",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff44a8",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff44a8",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff43a8",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "et"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m502.43 0.33594h2.418v0.14844h-2.418zm-0.45703 0.14844h3.3242v0.15234h-3.3242zm-0.30078 0.15234h4.0781v0.14844h-4.0781zm-0.30078 0.14844h4.6797v0.15234h-4.6797zm-0.30078 0.15234h5.2891v0.15234h-5.2891zm-0.15234 0.15234h5.5898v0.14844h-5.5898zm-0.30078 0.14844h6.1914v0.15234h-6.1914zm-0.30078 0.15234h6.7969v0.14844h-6.7969zm-0.15625 0.14844h7.2578v0.15234h-7.2578zm-0.30078 0.15234h7.7031v0.15625h-7.7031zm-0.30078 0.15625h8.3125v0.14453h-8.3125zm-0.30469 0.14453h8.918v0.15625h-8.918zm-0.14844 0.15625h9.3672v0.14844h-9.3672zm-0.30078 0.14844h9.8203v0.15234h-9.8203zm-0.30859 0.15234h10.43v0.15234h-10.43zm-0.30078 0.15234h11.031v0.14844h-11.031zm-0.14844 0.14844h11.336v0.15234h-11.336zm-0.30469 0.15234h11.941v0.14844h-11.941zm-0.30078 0.14844h12.543v0.15234h-12.543zm-0.14844 0.15234h12.992v0.15625h-12.992zm-0.30859 0.15625h13.453v0.14453h-13.453zm-0.30078 0.14453h14.055v0.15625h-14.055zm-0.30078 0.15625h14.656v0.14453h-14.656zm-0.15234 0.14453h15.109v0.15625h-15.109zm-0.30078 0.15625h15.566v0.15234h-15.566zm-0.30078 0.15234h16.168v0.14844h-16.168zm-0.30078 0.14844h16.77v0.15234h-16.77zm-0.15234 0.15234h17.074v0.14844h-17.074zm-0.30469 0.14844h17.68v0.15234h-17.68zm-0.30078 0.15234h18.281v0.15234h-18.281zm-0.30078 0.15234h18.891v0.14844h-18.891zm-0.15234 0.14844h19.191v0.15234h-19.191zm-0.30078 0.15234h19.793v0.14844h-19.793zm-0.30078 0.14844h20.398v0.15625h-20.398zm-0.15234 0.15625h20.852v0.15234h-20.852zm-0.30078 0.15234h21.301v0.14844h-21.301zm-0.30469 0.14844h21.914v0.15234h-21.914zm-0.30469 0.15234h22.52v0.14844h-22.52zm-0.14844 0.14844h22.969v0.15234h-22.969zm-0.30078 0.15234h23.422v0.15234h-23.422zm-0.30859 0.15234h24.031v0.14844h-24.031zm-0.30078 0.14844h24.633v0.15234h-24.633zm-0.14453 0.15234h24.934v0.14844h-24.934zm-0.30859 0.14844h25.543v0.15234h-25.543zm-0.30078 0.15234h26.145v0.15625h-26.145zm0.15234 0.15625h26.293v0.14844h-26.293zm0.14844 0.14844h26.297v0.15234h-26.297zm0.30859 0.15234h26.289v0.14844h-26.289zm0.30078 0.14844h26.289v0.15234h-26.289zm0.30078 0.15234h26.289v0.15234h-26.289zm0.15234 0.15234h26.293v0.14844h-26.293zm0.30078 0.14844h26.293v0.15234h-26.293zm0.30078 0.15234h26.293v0.14844h-26.293zm0.30078 0.14844h26.297v0.15234h-26.297zm0.15625 0.15234h26.289v0.15625h-26.289zm0.30078 0.15625h26.289v0.14453h-26.289zm0.30078 0.14453h26.297v0.15625h-26.297zm0.15234 0.15625h26.289v0.14453h-26.289zm0.30078 0.14453h26.289v0.15625h-26.289zm0.30078 0.15625h26.297v0.15234h-26.297zm0.30078 0.15234h26.297v0.14844h-26.297zm0.15234 0.14844h26.293v0.15234h-26.293zm0.30469 0.15234h26.293v0.14844h-26.293zm0.30078 0.14844h26.297v0.15234h-26.297zm0.30469 0.15234h26.293v0.15234h-26.293zm0.14844 0.15234h26.297v0.14844h-26.297zm0.30078 0.14844h26.297v0.15625h-26.297zm0.30859 0.15625h26.289v0.14453h-26.289zm0.30078 0.14453h26.289v0.15625h-26.289zm0.14453 0.15625h26.297v0.15234h-26.297zm0.30859 0.15234h26.289v0.14844h-26.289zm0.30078 0.14844h26.293v0.15234h-26.293zm0 0.15234h26.445v0.14844h-26.445zm0 0.14844h26.746v0.15234h-26.746zm0 0.15234h27.047v0.15234h-27.047zm0 0.15234h27.348v0.14844h-27.348zm0 0.14844h27.5v0.15234h-27.5zm0 0.15234h27.801v0.14844h-27.801zm0 0.14844h28.102v0.15625h-28.102zm0 0.15625h28.41v0.15234h-28.41zm0 0.15234h28.559v0.14844h-28.559zm0 0.14844h28.859v0.15234h-28.859zm0 0.15234h29.164v0.14844h-29.164zm0 0.14844h29.312v0.15234h-29.312zm0 0.15234h29.613v0.15234h-29.613zm0 0.15234h29.922v0.14844h-29.922zm0 0.14844h30.223v0.15234h-30.223zm0 0.15234h30.371v0.14844h-30.371zm0 0.14844h30.676v0.15234h-30.676zm0 0.15234h30.977v0.15625h-30.977zm0 0.15625h31.277v0.14453h-31.277zm0 0.14453h31.434v0.15625h-31.434zm0 0.15625h31.734v0.14844h-31.734zm0 0.14844h32.035v0.15234h-32.035zm0 0.15234h32.336v0.15234h-32.336zm0 0.15234h32.488v0.14844h-32.488zm0 0.14844h32.789v0.15234h-32.789zm0 0.15234h33.09v0.14844h-33.09zm0 0.14844h33.246v0.15234h-33.246zm0 0.15234h33.547v0.15625h-33.547zm0 0.15625h33.848v0.14453h-33.848zm0 0.14453h34.148v0.15625h-34.148zm0 0.15625h34.301v0.14453h-34.301zm0 0.14453h34.602v0.15625h-34.602zm0 0.15625h34.902v0.15234h-34.902zm0 0.15234h35.211v0.14844h-35.211zm0 0.14844h35.359v0.15234h-35.359zm0 0.15234h35.66v0.14844h-35.66zm0 0.14844h35.965v0.15234h-35.965zm0 0.15234h36.266v0.15234h-36.266zm0 0.15234h36.414v0.14844h-36.414zm0 0.14844h36.723v0.15625h-36.723zm0 0.15625h37.023v0.14453h-37.023zm0 0.14453h37.168v0.15625h-37.168zm0 0.15625h37.477v0.15234h-37.477zm0 0.15234h37.777v0.14844h-37.777zm0 0.14844h38.078v0.15234h-38.078zm0 0.15234h38.23v0.14844h-38.23zm0 0.14844h38.535v0.15234h-38.535zm0 0.15234h38.836v0.15234h-38.836zm0 0.15234h39.137v0.14844h-39.137zm0 0.14844h39.289v0.15234h-39.289zm0 0.15234h39.59v0.14844h-39.59zm0 0.14844h39.891v0.15234h-39.891zm0 0.15234h40.191v0.15625h-40.191zm0 0.15625h40.344v0.14844h-40.344zm0 0.14844h40.648v0.15234h-40.648zm0 0.15234h40.949v0.14844h-40.949zm0 0.14844h41.102v0.15234h-41.102zm0 0.15234h41.402v0.15234h-41.402zm0 0.15234h41.703v0.14844h-41.703zm0 0.14844h42.012v0.15234h-42.012zm0 0.15234h42.156v0.14844h-42.156zm0 0.14844h42.457v0.15234h-42.457zm0 0.15234h42.766v0.15625h-42.766zm0 0.15625h43.066v0.14453h-43.066zm0 0.14453h43.215v0.15625h-43.215zm0 0.15625h43.52v0.14453h-43.52zm0 0.14453h43.82v0.15625h-43.82zm0 0.15625h43.969v0.15234h-43.969zm0 0.15234h44.277v0.14844h-44.277zm0 0.14844h44.578v0.15234h-44.578zm0 0.15234h44.879v0.14844h-44.879zm0 0.14844h45.031v0.15234h-45.031zm0 0.15234h45.332v0.15625h-45.332zm0 0.15625h45.633v0.14453h-45.633zm0 0.14453h45.934v0.15625h-45.934zm0 0.15625h46.09v0.14453h-46.09zm0 0.14453h46.391v0.15625h-46.391zm0 0.15625h46.691v0.15234h-46.691zm0 0.15234h46.992v0.14844h-46.992zm0 0.14844h47.145v0.15234h-47.145zm0 0.15234h47.445v0.14844h-47.445zm0 0.14844h47.746v0.15234h-47.746zm0 0.15234h47.902v0.15234h-47.902zm0 0.15234h48.203v0.14844h-48.203zm0 0.14844h48.504v0.15234h-48.504zm0 0.15234h48.809v0.14844h-48.809zm0 0.14844h48.957v0.15625h-48.957zm0 0.15625h49.258v0.15234h-49.258zm0 0.15234h49.566v0.14844h-49.566zm0 0.14844h49.867v0.15234h-49.867zm0 0.15234h50.016v0.14844h-50.016zm0 0.14844h50.32v0.15234h-50.32zm0 0.15234h50.621v0.15234h-50.621zm0 0.15234h50.922v0.14844h-50.922zm0 0.14844h51.078v0.15234h-51.078zm0 0.15234h51.379v0.14844h-51.379zm0 0.14844h51.68v0.15234h-51.68zm0 0.15234h51.832v0.15625h-51.832zm0 0.15625h52.133v0.14844h-52.133zm0 0.14844h52.434v0.15234h-52.434zm0 0.15234h52.734v0.14844h-52.734zm0 0.14844h52.891v0.15234h-52.891zm0 0.15234h53.191v0.15234h-53.191zm0 0.15234h53.492v0.14844h-53.492zm0 0.14844h53.793v0.15234h-53.793zm0 0.15234h53.945v0.14844h-53.945zm0 0.14844h54.246v0.15234h-54.246zm0 0.15234h54.547v0.15625h-54.547zm0 0.15625h54.699v0.14453h-54.699zm0 0.14453h55.004v0.15625h-55.004zm0 0.15625h55.305v0.14453h-55.305zm0 0.14453h55.609v0.15625h-55.609zm0 0.15625h55.758v0.15234h-55.758zm0 0.15234h56.059v0.14844h-56.059zm0 0.14844h56.367v0.15234h-56.367zm0 0.15234h56.668v0.14844h-56.668zm0 0.14844h56.812v0.15234h-56.812zm0 0.15234h57.121v0.15234h-57.121zm0 0.15234h57.422v0.14844h-57.422zm0 0.14844h57.723v0.15625h-57.723zm0 0.15625h57.875v0.14453h-57.875zm0 0.14453h58.023v0.15625h-58.023zm0 0.15625h58.324v0.15234h-58.324zm0 0.15234h58.48v0.14844h-58.48zm0 0.14844h58.633v0.15234h-58.633zm0 0.15234h58.781v0.14844h-58.781zm0 0.14844h58.934v0.15234h-58.934zm0 0.15234h59.082v0.15234h-59.082zm0 0.15234h59.234v0.14844h-59.234zm0 0.14844h59.387v0.15234h-59.387zm0 0.15234h59.535v0.14844h-59.535zm0 0.14844h59.688v0.15625h-59.688zm0 0.15625h59.836v0.15234h-59.836zm0 0.15234h59.988v0.14844h-59.988zm0 0.14844h60.145v0.15234h-60.145zm0 0.15234h60.289v0.14844h-60.289zm0 0.14844h60.445v0.30469h-60.445zm0 0.30469h60.594v0.14844h-60.594zm0 0.14844h60.746v0.15234h-60.746zm0 0.15234h60.898v0.30078h-60.898zm0 0.30078h61.047v0.15625h-61.047zm0 0.15625h61.199v0.14453h-61.199zm0 0.14453h61.348v0.30469h-61.348zm0 0.30469h61.5v0.30469h-61.5zm0 0.30469h61.656v0.14844h-61.656zm0 0.14844h61.801v0.30078h-61.801zm0 0.30078h61.957v0.30859h-61.957zm0 0.30859h62.102v0.14453h-62.102zm0 0.14453h62.258v0.45703h-62.258zm0 0.45703h62.41v0.30078h-62.41zm0 0.30078h62.559v0.30078h-62.559zm0 0.30078h62.711v0.30469h-62.711zm0 0.30469h62.859v0.30469h-62.859zm0 0.30469h63.012v0.45312h-63.012zm0 0.45312h63.164v0.44922h-63.164zm0 0.44922h63.312v0.45312h-63.312zm0 0.45312h63.465v0.45313h-63.465zm0 0.45313h63.613v0.60547h-63.613zm0 0.60547h63.766v0.75391h-63.766zm0 0.75391h63.922v0.75391h-63.922zm0 0.75391h64.07v1.3672h-64.07zm0 1.3672h64.223v32.637h-64.223zm0.14844 32.637h64.074v0.75781h-64.074zm0.15234 0.75781h63.922v0.60547h-63.922zm0.15234 0.60547h63.77v0.75781h-63.77zm0.14844 0.75781h63.621v0.45312h-63.621zm0.15625 0.45312h63.465v0.44922h-63.465zm0.14453 0.44922h63.32v0.45313h-63.32zm0.15625 0.45313h63.164v0.30078h-63.164zm0.15234 0.30078h63.012v0.45703h-63.012zm0.14844 0.45703h62.863v0.30078h-62.863zm0.15234 0.30078h62.711v0.30859h-62.711zm0.14844 0.30859h62.562v0.30078h-62.562zm0.15234 0.30078h62.41v0.30078h-62.41zm0.15234 0.30078h62.258v0.30078h-62.258zm0.14844 0.30078h62.109v0.30078h-62.109zm0.15234 0.30078h61.957v0.30469h-61.957zm0.14844 0.30469h61.809v0.14844h-61.809zm0.15234 0.14844h61.656v0.30078h-61.656zm0.15625 0.30078h61.5v0.30859h-61.5zm0.14453 0.30859h61.355v0.14844h-61.355zm0.15625 0.14844h61.199v0.30078h-61.199zm0.14844 0.30078h61.051v0.15234h-61.051zm0.15234 0.15234h60.898v0.15234h-60.898zm0.15234 0.15234h60.746v0.14844h-60.746zm0.14844 0.14844h60.598v0.30078h-60.598zm0.15234 0.30078h60.445v0.15234h-60.445zm0.14844 0.15234h60.297v0.15625h-60.297zm0.15234 0.15625h60.145v0.30078h-60.145zm0.15625 0.30078h59.988v0.14844h-59.988zm0.14453 0.14844h59.844v0.15234h-59.844zm0.15625 0.15234h59.688v0.15234h-59.688zm0.30078 0.15234h59.387v0.14844h-59.387zm0.15234 0.14844h59.234v0.15234h-59.234zm0.14844 0.15234h59.086v0.14844h-59.086zm0.15234 0.14844h58.934v0.15234h-58.934zm0.14844 0.15234h58.785v0.15625h-58.785zm0.15234 0.15625h58.633v0.14453h-58.633zm0.15234 0.14453h58.48v0.15625h-58.48zm0.14844 0.15625h58.332v0.14453h-58.332zm0.30078 0.14453h58.031v0.15625h-58.031zm0.15625 0.15625h57.875v0.15234h-57.875zm0.30078 0.15234h57.574v0.14844h-57.574zm0.30078 0.14844h57.273v0.15234h-57.273zm0.15234 0.15234h57.121v0.14844h-57.121zm0.30078 0.14844h56.82v0.15234h-56.82zm0.30078 0.15234h56.52v0.15234h-56.52zm0.15234 0.15234h56.367v0.14844h-56.367zm0.30078 0.14844h56.066v0.15625h-56.066zm0.30078 0.15625h55.766v0.14453h-55.766zm0.30859 0.14453h55.457v0.15625h-55.457zm0.14844 0.15625h55.309v0.15234h-55.309zm0.30078 0.15234h55.008v0.14844h-55.008zm0.30469 0.14844h54.703v0.15234h-54.703zm0.30469 0.15234h54.398v0.14844h-54.398zm0.14453 0.14844h54.254v0.15234h-54.254zm0.30859 0.15234h53.945v0.15234h-53.945zm0.30078 0.15234h53.645v0.14844h-53.645zm0.30078 0.14844h53.344v0.15234h-53.344zm0.15234 0.15234h53.191v0.14844h-53.191zm0.30078 0.14844h52.891v0.15234h-52.891zm0.30078 0.15234h52.59v0.15625h-52.59zm0.15625 0.15625h52.434v0.14844h-52.434zm0.30078 0.14844h52.133v0.15234h-52.133zm0.30078 0.15234h51.832v0.14844h-51.832zm0.30078 0.14844h51.531v0.15234h-51.531zm0.15234 0.15234h51.379v0.15234h-51.379zm0.30078 0.15234h51.078v0.14844h-51.078zm0.30078 0.14844h50.777v0.15234h-50.777zm0.30078 0.15234h50.477v0.14844h-50.477zm0.15625 0.14844h50.32v0.15234h-50.32zm0.30078 0.15234h50.02v0.15625h-50.02zm0.30078 0.15625h49.719v0.14453h-49.719zm0.30469 0.14453h49.414v0.15625h-49.414zm0.14844 0.15625h49.266v0.14844h-49.266zm0.30078 0.14844h48.965v0.15234h-48.965zm0.30859 0.15234h48.656v0.15234h-48.656zm0.14844 0.15234h48.508v0.14844h-48.508zm0.30078 0.14844h48.207v0.15234h-48.207zm0.30469 0.15234h47.902v0.14844h-47.902zm0.30078 0.14844h47.602v0.15234h-47.602zm0.14844 0.15234h47.453v0.15625h-47.453zm0.30859 0.15625h47.145v0.14453h-47.145zm0.30078 0.14453h46.844v0.15625h-46.844zm0.30078 0.15625h46.543v0.14453h-46.543zm0.15234 0.14453h46.391v0.15625h-46.391zm0.30078 0.15625h46.09v0.15234h-46.09zm0.30078 0.15234h45.789v0.14844h-45.789zm0.30078 0.14844h45.488v0.15234h-45.488zm0.15625 0.15234h45.332v0.14844h-45.332zm0.30078 0.14844h45.031v0.15234h-45.031zm0.30078 0.15234h44.73v0.15234h-44.73zm0.15234 0.15234h44.578v0.14844h-44.578zm0.30078 0.14844h44.277v0.15234h-44.277zm0.30078 0.15234h43.977v0.14844h-43.977zm0.30078 0.14844h43.676v0.15625h-43.676zm0.15625 0.15625h43.52v0.15234h-43.52zm0.30078 0.15234h43.219v0.14844h-43.219zm0.30078 0.14844h42.918v0.15234h-42.918zm0.30469 0.15234h42.613v0.14844h-42.613zm0.14844 0.14844h42.465v0.15234h-42.465zm0.30078 0.15234h42.164v0.15234h-42.164zm0.30859 0.15234h41.855v0.14844h-41.855zm0.14453 0.14844h41.711v0.15234h-41.711zm0.30078 0.15234h41.41v0.14844h-41.41zm0.30859 0.14844h41.102v0.15234h-41.102zm0.30078 0.15234h40.801v0.15625h-40.801zm0.14844 0.15625h40.652v0.14844h-40.652zm0.30469 0.14844h40.348v0.15234h-40.348zm0.30469 0.15234h40.043v0.14844h-40.043zm0.30078 0.14844h39.742v0.15234h-39.742zm0.15234 0.15234h39.59v0.15234h-39.59zm0.30078 0.15234h39.289v0.14844h-39.289zm0.30078 0.14844h38.988v0.15234h-38.988zm0.30078 0.15234h38.688v0.14844h-38.688zm0.15234 0.14844h38.535v0.15234h-38.535zm0.30078 0.15234h38.234v0.15625h-38.234zm0.30469 0.15625h37.93v0.14453h-37.93zm0.15234 0.14453h37.777v0.15625h-37.777zm0.30078 0.15625h37.477v0.14453h-37.477zm0.30078 0.14453h37.176v0.15625h-37.176zm0.30078 0.15625h36.875v0.15234h-36.875zm0.15234 0.15234h36.723v0.14844h-36.723zm0.30078 0.14844h36.422v0.15234h-36.422zm0.30078 0.15234h36.121v0.14844h-36.121zm0.30859 0.14844h35.812v0.15234h-35.812zm0.14844 0.15234h35.664v0.15234h-35.664zm0.30078 0.15234h35.363v0.14844h-35.363zm0.30469 0.14844h35.059v0.15625h-35.059zm0.30078 0.15625h34.758v0.14453h-34.758zm0.14844 0.14453h34.609v0.15625h-34.609zm0.30859 0.15625h34.301v0.15234h-34.301zm0.30078 0.15234h34v0.14844h-34zm0.14844 0.14844h33.852v0.15234h-33.852zm0.30469 0.15234h33.547v0.14844h-33.547zm0.30078 0.14844h33.246v0.15234h-33.246zm0.30078 0.15234h32.945v0.15234h-32.945zm0.15625 0.15234h32.789v0.14844h-32.789zm0.30078 0.14844h32.488v0.15234h-32.488zm0.30078 0.15234h32.188v0.14844h-32.188zm0.30078 0.14844h31.887v0.15625h-31.887zm0.15234 0.15625h31.734v0.15234h-31.734zm0.30078 0.15234h31.434v0.14844h-31.434zm0.30078 0.14844h31.133v0.15234h-31.133zm0.30078 0.15234h30.832v0.14844h-30.832zm0.15625 0.14844h30.676v0.15234h-30.676zm0.30078 0.15234h30.375v0.15234h-30.375zm0.30078 0.15234h30.074v0.14844h-30.074zm0.15234 0.14844h29.922v0.15234h-29.922zm0.30078 0.15234h29.621v0.14844h-29.621zm0.30078 0.14844h29.32v0.15234h-29.32zm0.30859 0.15234h29.012v0.15625h-29.012zm0.14844 0.15625h28.863v0.14453h-28.863zm0.30078 0.14453h28.562v0.15625h-28.562zm0.30469 0.15625h28.258v0.14844h-28.258zm0.30078 0.14844h27.957v0.15234h-27.957zm0.14844 0.15234h27.809v0.15234h-27.809zm0.30859 0.15234h27.5v0.14844h-27.5zm0.30078 0.14844h27.199v0.15234h-27.199zm0.14453 0.15234h27.055v0.14844h-27.055zm0.30859 0.14844h26.746v0.15234h-26.746zm0.30078 0.15234h26.445v0.15625h-26.445zm0.30078 0.15625h26.145v0.14453h-26.145zm0.15234 0.14453h25.992v0.15625h-25.992zm0.30469 0.15625h25.688v0.14453h-25.688zm0.30078 0.14453h25.387v0.15625h-25.387zm0.30078 0.15625h25.086v0.15234h-25.086zm0.15234 0.15234h24.934v0.14844h-24.934zm0.30078 0.14844h24.633v0.15234h-24.633zm0.30078 0.15234h24.332v0.14844h-24.332zm0.30078 0.14844h24.031v0.15234h-24.031zm0.15234 0.15234h23.879v0.15234h-23.879zm0.30469 0.15234h23.574v0.14844h-23.574zm0.30078 0.14844h23.273v0.15625h-23.273zm0.15234 0.15625h23.121v0.14453h-23.121zm0.30078 0.14453h22.82v0.15625h-22.82zm0.30078 0.15625h22.52v0.15234h-22.52zm0.30859 0.15234h22.211v0.14844h-22.211zm0.14453 0.14844h22.066v0.15234h-22.066zm0.30078 0.15234h21.766v0.14844h-21.766zm0.30859 0.14844h21.457v0.15234h-21.457zm0.30078 0.15234h21.156v0.15234h-21.156zm0.14844 0.15234h21.008v0.14844h-21.008zm0.30469 0.14844h20.703v0.15234h-20.703zm0.30078 0.15234h20.402v0.14844h-20.402zm0.30469 0.14844h20.098v0.15234h-20.098zm0.15234 0.15234h19.945v0.15625h-19.945zm0.30078 0.15625h19.645v0.14844h-19.645zm0.30078 0.14844h19.344v0.15234h-19.344zm0.15234 0.15234h19.191v0.14844h-19.191zm0.30078 0.14844h18.891v0.15234h-18.891zm0.30078 0.15234h18.59v0.15234h-18.59zm0.30078 0.15234h18.137v0.14844h-18.137zm0.15625 0.14844h17.98v0.15234h-17.98zm0.30078 0.15234h17.68v0.14844h-17.68zm0.30078 0.14844h17.379v0.15234h-17.379zm0.30078 0.15234h17.078v0.15625h-17.078zm0.15234 0.15625h16.926v0.14453h-16.926zm0.30078 0.14453h16.625v0.15625h-16.625zm0.30078 0.15625h16.324v0.14844h-16.324zm0.15625 0.14844h16.02v0.15234h-16.02zm0.30078 0.15234h15.719v0.15234h-15.719zm0.30078 0.15234h15.418v0.14844h-15.418zm0.30469 0.14844h15.113v0.15234h-15.113zm0.14844 0.15234h14.809v0.14844h-14.809zm0.30078 0.14844h14.508v0.15234h-14.508zm0.30859 0.15234h14.199v0.15625h-14.199zm0.30078 0.15625h13.746v0.14453h-13.746zm0.14844 0.14453h13.598v0.15625h-13.598zm0.30469 0.15625h13.293v0.14453h-13.293zm0.30078 0.14453h12.844v0.15625h-12.844zm0.14844 0.15625h12.695v0.15234h-12.695zm0 0.15234h12.543v0.30078h-12.543zm0 0.30078h12.395v0.14844h-12.395zm0 0.14844h12.242v0.30469h-12.242zm0 0.30469h12.09v0.14844h-12.09zm0 0.14844h11.941v0.15234h-11.941zm0 0.15234h11.789v0.30469h-11.789zm0 0.30469h11.488v0.15234h-11.488zm0 0.15234h11.332v0.14844h-11.332zm0 0.14844h11.188v0.15234h-11.188zm0 0.15234h10.887v0.14844h-10.887zm0 0.14844h10.578v0.15234h-10.578zm0 0.15234h10.277v0.15234h-10.277zm0 0.15234h10.129v0.14844h-10.129zm0 0.14844h9.8242v0.15234h-9.8242zm0 0.15234h9.5195v0.14844h-9.5195zm0 0.14844h9.2188v0.15234h-9.2188zm0 0.15234h9.0664v0.15625h-9.0664zm0 0.15625h8.7656v0.14844h-8.7656zm0 0.14844h8.4648v0.15234h-8.4648zm0 0.15234h8.1641v0.14844h-8.1641zm0 0.14844h8.0117v0.15234h-8.0117zm0 0.15234h7.7109v0.15234h-7.7109zm0 0.15234h7.4062v0.14844h-7.4062zm0 0.14844h7.2539v0.15234h-7.2539zm0 0.15234h6.9531v0.14844h-6.9531zm0 0.14844h6.6523v0.15234h-6.6523zm0 0.15234h6.3516v0.15625h-6.3516zm0 0.15625h6.1992v0.14453h-6.1992zm0 0.14453h5.8984v0.15625h-5.8984zm0 0.15625h5.5977v0.14453h-5.5977zm0 0.14453h5.2891v0.15625h-5.2891zm0 0.15625h5.1406v0.15234h-5.1406zm0 0.15234h4.8398v0.14844h-4.8398zm0 0.14844h4.5352v0.15234h-4.5352zm0 0.15234h4.3867v0.14844h-4.3867zm0 0.14844h4.0859v0.15234h-4.0859zm0 0.15234h3.7773v0.15234h-3.7773zm0 0.15234h3.4766v0.14844h-3.4766zm0 0.14844h3.3281v0.15625h-3.3281zm0 0.15625h3.0234v0.14453h-3.0234zm0 0.14453h2.7227v0.15625h-2.7227zm0 0.15625h2.4219v0.15234h-2.4219zm0 0.15234h2.2656v0.14844h-2.2656zm0 0.14844h1.9648v0.15234h-1.9648zm0 0.15234h1.6641v0.14844h-1.6641zm0 0.14844h1.3633v0.15234h-1.3633zm0 0.15234h1.2109v0.15234h-1.2109zm0 0.15234h0.91016v0.14844h-0.91016zm0 0.14844h0.60938v0.15234h-0.60938zm0 0.15234h0.45312v0.14844h-0.45312zm0 0.14844h0.15234v0.15625h-0.15234z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "by"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m554.88 29.18-48.617-28.07c-1.75-1.0156-3.3516-1.0508-4.5625-0.29688l-10.906 6.3047 6.8047 3.9258v60.969c0 5.0195 3.0508 10.848 6.8164 13.02l43.973 25.391v8.2617l10.559-6.1016c1.6719-0.69141 2.7461-2.7188 2.7461-5.7031v-64.684c0-5.0195-3.0469-10.844-6.8125-13.016z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m583.73 4.5898-90.387-17.461-24.594 127.3 90.391 17.461z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    x1: -0.061208,
    x2: 0.95904,
    gradientTransform: "matrix(-24.101 124.77 -124.76 -24.104 536.77 3.4438)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffebb",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffebb",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffdbb",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffcba",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbba",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbba",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbba",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffaba",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffaba",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff9b9",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff8b9",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7b9",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6b8",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6b8",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff5b8",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff4b8",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff4b8",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff3b8",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff2b8",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff1b8",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff1b7",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff1b7",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff0b7",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff0b7",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffefb7",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeeb7",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedb6",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedb6",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedb6",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffecb6",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffecb6",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffebb6",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffebb5",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeab5",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeab5",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe9b5",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8b5",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8b5",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe7b4",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe7b4",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe6b4",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe6b4",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe5b3",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4b3",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe3b3",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe3b3",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe2b2",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1b2",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe0b1",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe0b1",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe0b1",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdfb1",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdeb1",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdeb0",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffddb0",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdcb0",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdbb0",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdbaf",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdaaf",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdaaf",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd9af",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd8af",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd7ae",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd7ae",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd6ae",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd6ae",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd5ae",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd4ad",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd4ad",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd4ad",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd3ad",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m488 6.332h63v113.34h-63z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "do"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m495.41 7.3711 48.617 28.07c3.7578 2.1719 6.8125 8.0039 6.8125 13.023v64.684c0 5.0117-3.0547 7.3203-6.8125 5.1484l-48.617-28.07c-3.7656-2.1758-6.8164-8.0078-6.8164-13.023v-64.68c0-2.6367 0.84375-4.5273 2.1914-5.4062 1.2148-0.80078 2.8398-0.77734 4.625 0.25391z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ge"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m495.41 7.3711 48.617 28.07c3.7578 2.1719 6.8125 8.0039 6.8125 13.023v64.684c0 5.0117-3.0547 7.3203-6.8125 5.1484l-48.617-28.07c-3.7656-2.1758-6.8164-8.0078-6.8164-13.023v-64.68c0-2.6367 0.84375-4.5273 2.1914-5.4062 1.2148-0.80078 2.8398-0.77734 4.625 0.25391"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "co"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m605.71 47.68-94.555-71.281-77.414 102.7 94.551 71.289z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id",
    x1: 0.041675,
    x2: 0.59612,
    gradientTransform: "matrix(-138.94 184.32 -184.3 -138.95 564.04 4.2395)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdb51",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffda51",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffda52",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd952",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd953",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd953",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd854",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd854",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd755",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd756",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd757",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd657",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd658",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd559",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd559",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd55a",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd55a",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd45b",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd45c",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd35c",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd35d",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd35d",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd25e",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd25e",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd25f",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd160",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd160",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd160",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd161",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd062",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd062",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd063",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd063",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcf64",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcf64",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffce65",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffce65",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffce66",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffce67",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcd67",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcd68",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcc69",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcc6a",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcb6a",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcb6b",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffca6b",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffca6c",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffca6c",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc96d",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc96e",
    offset: 0.36328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc96e",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc86e",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc86f",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc86f",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc770",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc771",
    offset: 0.40234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc771",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc672",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc673",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc573",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc574",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc574",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc575",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc476",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc476",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc477",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc378",
    offset: 0.48828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc378",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc379",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc279",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc27a",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc17b",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc17b",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc17c",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc07c",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc07d",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc07e",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc07e",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbf7e",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbf7f",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbe7f",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbe80",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbd81",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbd81",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbd81",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbd82",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbc83",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbc83",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbc84",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb84",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb85",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb86",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffba86",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffba87",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb988",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb989",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb889",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb88a",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb88a",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb88b",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb78b",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb78c",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb68c",
    offset: 0.76172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb68d",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb58d",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb58d",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb48d",
    offset: 0.77734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb38d",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb38d",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb28d",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb18d",
    offset: 0.80078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb08d",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb08d",
    offset: 0.80859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaf8d",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#feae8d",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdad8e",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdad8e",
    offset: 0.82422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdac8e",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdac8e",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdab8e",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdaa8e",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda98e",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda98e",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda88e",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda78e",
    offset: 0.87109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda78e",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda68e",
    offset: 0.87891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda68e",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda58e",
    offset: 0.88672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda48e",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda48e",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda38e",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda38e",
    offset: 0.90234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda28e",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda28e",
    offset: 0.91016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda18e",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda18e",
    offset: 0.91797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda08e",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fda08e",
    offset: 0.92578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd9f8e",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd9f8e",
    offset: 0.93359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9e8e",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9d8e",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9d8f",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9c8f",
    offset: 0.94922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9c8f",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9b8f",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc9a8f",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc998f",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc988f",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc988f",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc978f",
    offset: 0.98828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc978f",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc968f",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ig"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m516.03 186.17h71.973v118.83h-71.973z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m580.7 215.28-48.617-28.07c-1.75-1.0117-3.3516-1.0508-4.5625-0.29688l-10.906 6.3047 6.8047 3.9336v60.961c0 5.0195 3.0508 10.852 6.8164 13.023l43.973 25.391v8.2578l10.559-6.0977c1.6641-0.69531 2.7461-2.7188 2.7461-5.7031v-64.68c0-5.0195-3.0547-10.852-6.8125-13.023z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "io"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m580.7 215.28-48.617-28.07c-1.75-1.0117-3.3516-1.0508-4.5625-0.29688l-10.906 6.3047 6.8047 3.9336v60.961c0 5.0195 3.0508 10.852 6.8164 13.023l43.973 25.391v8.2578l10.559-6.0977c1.6641-0.69531 2.7461-2.7188 2.7461-5.7031v-64.68c0-5.0195-3.0547-10.852-6.8125-13.023"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m609.6 190.43-90.434-17.473-24.645 127.57 90.441 17.473z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ie",
    x1: -0.064246,
    x2: 0.95806,
    gradientTransform: "matrix(-24.101 124.77 -124.76 -24.104 562.5 189.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffdfd",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffcfc",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffcfc",
    offset: 0.11328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbfb",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbfb",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbfb",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff9f9",
    offset: 0.13672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff9f9",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff8f8",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7f7",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6f6",
    offset: 0.16797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff5f6",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff5f5",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff4f4",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff3f3",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff2f2",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff2f2",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff1f1",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff0f0",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffefef",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fee",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedee",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedee",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeced",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffebec",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeaeb",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe9ea",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe9ea",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8e9",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe7e8",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe6e7",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe5e6",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4e5",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe3e4",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe2e3",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe2e3",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1e2",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe0e1",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdfe0",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdedf",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdedf",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdddf",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdcde",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdbdd",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdadc",
    offset: 0.38672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdadc",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd9db",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd8db",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd8da",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd7d9",
    offset: 0.41016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd6d9",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd6d8",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd5d7",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd4d6",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd3d5",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd2d4",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd2d4",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd1d3",
    offset: 0.45703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd1d2",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd0d2",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcfd1",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffced0",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffced0",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcdd0",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcccf",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcbce",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcacd",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc9cc",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc8cb",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc8cb",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc7ca",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc6c9",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc5c8",
    offset: 0.55078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc5c7",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc4c7",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc3c6",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc3c5",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc2c5",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc1c4",
    offset: 0.58203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc1c4",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc0c3",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbfc2",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbec2",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbdc2",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbdc1",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbcc0",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbbbf",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbabe",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb9bd",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb8bc",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb8bc",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb7bb",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb6ba",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb5b9",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb4b8",
    offset: 0.68359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb4b8",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb4b7",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb3b7",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb3b6",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb2b5",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb1b5",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb0b4",
    offset: 0.72266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb0b4",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffafb3",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaeb2",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaeb2",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffadb1",
    offset: 0.74609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffacb0",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffacb0",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffabaf",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaaae",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaaad",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa9ad",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa8ac",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa7ab",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa6aa",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa5aa",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa4a9",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa3a9",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa3a8",
    offset: 0.82422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa2a8",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa2a7",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa1a6",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa0a5",
    offset: 0.84766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9fa5",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9fa4",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9fa3",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ea3",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9da2",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ca1",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ba0",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9a9f",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff999f",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff999f",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff989e",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff989d",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff979c",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff969b",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff959a",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9499",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9499",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9398",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9297",
    offset: 0.96484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9296",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9196",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9096",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9095",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8f95",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8e94",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m514 192.21h63v113.34h-63z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "go"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m521.24 193.48 48.605 28.062c3.7695 2.1719 6.8203 8.0078 6.8203 13.023v64.684c0 5.0156-3.0508 7.3242-6.8203 5.1523l-48.605-28.074c-3.7695-2.1758-6.8203-8-6.8203-13.02v-64.68c0-2.6406 0.84375-4.5234 2.1914-5.4102 1.2148-0.79688 2.8398-0.77344 4.6289 0.26172z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "er"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m521.24 193.48 48.605 28.062c3.7695 2.1719 6.8203 8.0078 6.8203 13.023v64.684c0 5.0156-3.0508 7.3242-6.8203 5.1523l-48.605-28.074c-3.7695-2.1758-6.8203-8-6.8203-13.02v-64.68c0-2.6406 0.84375-4.5234 2.1914-5.4102 1.2148-0.79688 2.8398-0.77344 4.6289 0.26172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m631.53 233.79-94.555-71.289-77.418 102.71 94.555 71.281z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fo",
    x1: 0.14957,
    x2: 0.7033,
    gradientTransform: "matrix(-138.94 184.32 -184.3 -138.95 604.77 170.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff817b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff817c",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff807d",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff807d",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff807d",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7f7e",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7f7f",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7e7f",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7e80",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7d81",
    offset: 0.066406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7d81",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7d82",
    offset: 0.074219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7d82",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7c83",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7c84",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7b84",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7b85",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7a86",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7a86",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7987",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7988",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7988",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7989",
    offset: 0.15234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7989",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff788a",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff788b",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff778b",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff778c",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff778d",
    offset: 0.19922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff778d",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff768d",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff768e",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff758f",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7590",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7590",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7490",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7491",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7492",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7392",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7393",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7294",
    offset: 0.27734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7294",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7295",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7196",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7196",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7097",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7098",
    offset: 0.32422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6f98",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6f99",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6f9a",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6e9a",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6e9b",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6d9c",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6d9d",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6c9d",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6c9e",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6c9f",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6b9f",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6ba0",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6ba0",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6aa1",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6aa2",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff69a3",
    offset: 0.44922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff69a3",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff69a4",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff68a4",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff68a5",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff67a5",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff66a6",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff65a6",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff64a6",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff63a6",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff63a6",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff62a6",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff62a6",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff61a6",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff60a6",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5fa6",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5fa7",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5ea7",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5da7",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5da7",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5ca7",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5ba7",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5aa7",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff59a7",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff59a7",
    offset: 0.61328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff58a7",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff58a7",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff57a7",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff56a7",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff55a7",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff54a7",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff53a7",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff53a7",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff52a7",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff51a7",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff50a8",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4fa8",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4fa8",
    offset: 0.69922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ea8",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ea8",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4da8",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ca8",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ca8",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ba8",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ba8",
    offset: 0.73828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4aa8",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4aa8",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff49a8",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff48a8",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff47a8",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff46a8",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff45a8",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff44a8",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff43a8",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff42a8",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff41a9",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff41a9",
    offset: 0.82422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff40a9",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff40a9",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3fa9",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3ea9",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3ea9",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3da9",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3da9",
    offset: 0.86328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3ca9",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3ca9",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3ba9",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3aa9",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff39a9",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff38a9",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff37a9",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff36a9",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff35a9",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff34a9",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff33a9",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3a",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff32aa",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff31aa",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff30aa",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff2faa",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff2faa",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff2eaa",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m520 223h45v56.867h-45z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m564.42 239.92-28.691-16.566-0.089843 30.93c-1.5156-2.8242-4.0547-5.5664-6.9297-7.2266-4.6641-2.6914-8.457-1.5234-8.4688 2.6133-0.011719 4.1328 3.7656 9.6758 8.4297 12.367 4.668 2.6992 8.457 1.5234 8.4688-2.6094l0.070312-25.375 25.672 14.816-0.066406 21.105c-1.5156-2.8242-4.0469-5.5625-6.9219-7.2266-4.6719-2.6914-8.4609-1.5234-8.4727 2.6133-0.011719 4.1406 3.7617 9.6758 8.4297 12.375 4.668 2.6914 8.4609 1.5234 8.4727-2.6172z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m564.42 239.92-28.691-16.566-0.089843 30.93c-1.5156-2.8242-4.0547-5.5664-6.9297-7.2266-4.6641-2.6914-8.457-1.5234-8.4688 2.6133-0.011719 4.1328 3.7656 9.6758 8.4297 12.367 4.668 2.6992 8.457 1.5234 8.4688-2.6094l0.070312-25.375 25.672 14.816-0.066406 21.105c-1.5156-2.8242-4.0469-5.5625-6.9219-7.2266-4.6719-2.6914-8.4609-1.5234-8.4727 2.6133-0.011719 4.1406 3.7617 9.6758 8.4297 12.375 4.668 2.6914 8.4609 1.5234 8.4727-2.6172l0.097657-35.199"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m491.73 250.39 49.422 52.102 51.754-49.098-49.422-52.109z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.19984,
    x2: 0.59565,
    gradientTransform: "matrix(130.05 -123.39 123.38 130.06 493.54 303.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff3f3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff2f3",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff2f2",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff1f2",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff1f2",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff0f1",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeff0",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeff0",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeef0",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeeef",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedef",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedee",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeced",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeced",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffebec",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeaeb",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeaeb",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe9ea",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8e9",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe7e8",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe7e8",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe7e8",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe6e7",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe5e6",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4e6",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4e6",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4e5",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4e5",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe3e4",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe2e4",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe2e4",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1e3",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1e3",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1e2",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1e2",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe0e1",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdfe1",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdfe1",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdfe0",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdedf",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdedf",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdddf",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdcde",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdcde",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdcdd",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m293 85h71.918v119.3h-71.918z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m357.26 114.67-48.617-28.07c-1.7539-1.0156-3.3516-1.0586-4.5625-0.30078l-10.906 6.3047 6.8047 3.9297v60.965c0 5.0156 3.0508 10.848 6.8164 13.023l43.969 25.387v8.2656l10.562-6.1016c1.668-0.69141 2.7422-2.7188 2.7422-5.7031v-64.684c0-5.0195-3.043-10.844-6.8086-13.016z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m357.26 114.67-48.617-28.07c-1.7539-1.0156-3.3516-1.0586-4.5625-0.30078l-10.906 6.3047 6.8047 3.9297v60.965c0 5.0156 3.0508 10.848 6.8164 13.023l43.969 25.387v8.2656l10.562-6.1016c1.668-0.69141 2.7422-2.7188 2.7422-5.7031v-64.684c0-5.0195-3.043-10.844-6.8086-13.016"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m386.16 89.812-90.445-17.477-24.641 127.57 90.441 17.473z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -0.0648,
    x2: 0.95764,
    gradientTransform: "matrix(-24.101 124.77 -124.76 -24.104 338.99 89.085)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd5ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd5ff",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd5ff",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd5ff",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd5fe",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd4fd",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd3fd",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd2fc",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd2fc",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd1fb",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd1fa",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd0f9",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd0f9",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcff8",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcef8",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcef8",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcef7",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcdf7",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffccf6",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffccf6",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcbf5",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcaf5",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcaf5",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc9f4",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc9f3",
    offset: 0.25391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc9f3",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc8f3",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc7f2",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc7f2",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc6f1",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc5f0",
    offset: 0.29297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc5f0",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc5f0",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc4ef",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc4ef",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc3ee",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc2ed",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc2ed",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc1ec",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc1eb",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc0eb",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbfeb",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbfea",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbee9",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbde9",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbce9",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbce8",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbce8",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbbe7",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbae6",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb9e5",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb8e5",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb8e5",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb8e4",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb7e4",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb7e3",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb6e2",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb6e1",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb5e1",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb4e0",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb4e0",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb3df",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb3df",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb2df",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb2de",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb1de",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb0dd",
    offset: 0.55078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb0dd",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb0dd",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffafdc",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaedc",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaddc",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaddb",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffadda",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffacda",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffacd9",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffacd9",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffabd9",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffabd8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaad8",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa9d7",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa9d6",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa9d5",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa8d5",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa7d5",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa7d4",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa6d4",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa5d3",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa5d3",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa4d2",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa3d1",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa2d1",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa1d0",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa1d0",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa1d0",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa0cf",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9fce",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9fce",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ecd",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ecd",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ecd",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9dcc",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9dcc",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ccb",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9bca",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9bca",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9ac9",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff99c8",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff99c8",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff98c7",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff98c7",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff97c6",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff97c6",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff96c5",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff95c5",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff94c4",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff93c4",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff93c4",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff93c3",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff92c3",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff92c2",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff91c1",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff91c1",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff90c0",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8fc0",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8fbf",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8ebf",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8ebe",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8ebd",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8dbd",
    offset: 0.98828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8dbd",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8cbd",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ep"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m290.88 92h63.125v113h-63.125z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ap"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.8 92.863 48.617 28.07c3.7578 2.1719 6.8125 8 6.8125 13.016v64.684c0 5.0195-3.0547 7.3281-6.8125 5.1523l-48.617-28.07c-3.7656-2.1719-6.8164-8.0039-6.8164-13.02v-64.684c0-2.6328 0.84375-4.5234 2.1914-5.4062 1.2148-0.79688 2.8398-0.77344 4.625 0.25781z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m297.8 92.863 48.617 28.07c3.7578 2.1719 6.8125 8 6.8125 13.016v64.684c0 5.0195-3.0547 7.3281-6.8125 5.1523l-48.617-28.07c-3.7656-2.1719-6.8164-8.0039-6.8164-13.02v-64.684c0-2.6328 0.84375-4.5234 2.1914-5.4062 1.2148-0.79688 2.8398-0.77344 4.625 0.25781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "if"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.09 133.17-94.555-71.281-77.414 102.7 94.551 71.285z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ga",
    x1: 0.041816,
    x2: 0.59856,
    gradientTransform: "matrix(-138.94 184.32 -184.3 -138.95 366.4 89.652)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b95",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b95",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b96",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8a96",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8a97",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8a97",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8998",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8998",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8999",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f89",
    offset: 0.058594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff889a",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff889a",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff889b",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff879b",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff879c",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff869d",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff869d",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff869e",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff869e",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff859f",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff85a0",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff84a1",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff84a1",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff84a1",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff84a2",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff83a3",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff82a4",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff82a5",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff81a5",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff81a6",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff81a7",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff80a7",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff80a8",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff80a8",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7fa9",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7eaa",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7eab",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7eab",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7dac",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7dad",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7cae",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7bae",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7baf",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7bb0",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7ab0",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7ab1",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7ab2",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff7ab2",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff79b3",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff79b4",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff78b5",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff78b5",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff78b6",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff78b6",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff77b7",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff77b8",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff76b8",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff76b9",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff75ba",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff75ba",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff74bb",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff74bc",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff74bc",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff74bd",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff73bd",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff72be",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff72bf",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff72bf",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff71c0",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff71c0",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff71c1",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff70c1",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff70c2",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff70c3",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff70c3",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6fc3",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6fc4",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6ec5",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6ec5",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6dc6",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6dc7",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6dc7",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6cc8",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6cc8",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6cc8",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6cc9",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6cca",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6bcb",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6bcb",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6acc",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6acd",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff6ace",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff69ce",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff69cf",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff68cf",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff68d0",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff67d1",
    offset: 0.76172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff67d1",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff66d1",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff65d1",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff64d1",
    offset: 0.77734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff63d1",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff63d1",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff62d1",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff61d1",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff60d1",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5fd2",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5ed2",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5dd2",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5cd2",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5bd2",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5bd2",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff5ad2",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff59d2",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff58d2",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff57d2",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff56d2",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff55d2",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff55d2",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff54d2",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff53d2",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff52d2",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff51d2",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff50d2",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff50d2",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4fd2",
    offset: 0.94922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4fd2",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ed2",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4dd2",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4cd2",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4bd2",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4bd2",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ad2",
    offset: 0.98828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4ad2",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff49d2",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373 190h64v113h-64z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m380.72 191.05 48.609 28.07c3.7656 2.1719 6.8203 8 6.8203 13.016v64.684c0 5.0195-3.0547 7.3281-6.8203 5.1523l-48.609-28.066c-3.7656-2.1758-6.8164-8.0078-6.8164-13.023v-64.68c0-2.6367 0.84375-4.5273 2.1914-5.4102 1.2148-0.79687 2.8359-0.77344 4.625 0.25781z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m380.72 191.05 48.609 28.07c3.7656 2.1719 6.8203 8 6.8203 13.016v64.684c0 5.0195-3.0547 7.3281-6.8203 5.1523l-48.609-28.066c-3.7656-2.1758-6.8164-8.0078-6.8164-13.023v-64.68c0-2.6367 0.84375-4.5273 2.1914-5.4102 1.2148-0.79687 2.8359-0.77344 4.625 0.25781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m489.9 227.9-95.328-67.227-74.422 105.55 95.324 67.227z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ej",
    x1: 0.084076,
    x2: 0.56105,
    gradientTransform: "matrix(-155.95 221.19 -221.16 -155.96 455.08 175.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edf8e1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ecf8e1",
    offset: 0.0039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebf8e1",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebf8e1",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaf8e2",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8f7e2",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8f7e2",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6f7e2",
    offset: 0.035156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6f7e2",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5f6e2",
    offset: 0.042969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4f6e2",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3f6e3",
    offset: 0.050781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2f6e3",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2f5e3",
    offset: 0.058594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2f5e3",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1f4e3",
    offset: 0.066406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0f4e3",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dff4e4",
    offset: 0.074219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dff4e4",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#def4e4",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ddf3e4",
    offset: 0.089844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcf3e4",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbf3e4",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daf2e5",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9f1e6",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8f1e6",
    offset: 0.11328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d7f1e6",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6f1e6",
    offset: 0.12109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5f0e6",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5f0e6",
    offset: 0.12891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4f0e7",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4f0e7",
    offset: 0.13672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3f0e7",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2efe7",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1efe7",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1efe7",
    offset: 0.15234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0eee8",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0eee8",
    offset: 0.16016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cfeee8",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ceeee8",
    offset: 0.16797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ceede8",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cdede8",
    offset: 0.17578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccede8",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbede8",
    offset: 0.18359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbece9",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#caece9",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9ece9",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8ece9",
    offset: 0.19922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7ebe9",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7ebe9",
    offset: 0.20703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6ebea",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6ebea",
    offset: 0.21484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5ebea",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4ebea",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3ebea",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c2eaea",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c1eaea",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0eaeb",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0eaeb",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bee9eb",
    offset: 0.25391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bde9eb",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bde9eb",
    offset: 0.26172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bce9eb",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bbe8eb",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bae8eb",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bae7eb",
    offset: 0.27734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9e7eb",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b8e7ec",
    offset: 0.28516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b8e7ec",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7e7ec",
    offset: 0.29297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7e7ec",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6e6ec",
    offset: 0.30078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6e6ec",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b5e6ec",
    offset: 0.30859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4e6ec",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3e5ed",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b2e4ed",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b1e4ed",
    offset: 0.32422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b0e4ed",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b0e4ed",
    offset: 0.33203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#afe3ed",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aee3ee",
    offset: 0.33984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ade3ee",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ade3ee",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ace2ee",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aae2ee",
    offset: 0.36328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aae1ef",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a9e1ef",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a8e1ef",
    offset: 0.37891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7e0ef",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6e0ef",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a5e0f0",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4dff0",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3dff0",
    offset: 0.40234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2dff0",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2dff0",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0dff1",
    offset: 0.41797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9fdff1",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9fdff1",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9edef1",
    offset: 0.43359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ddef1",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9cdef2",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9bddf2",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9bddf2",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99ddf3",
    offset: 0.45703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98ddf3",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98dcf3",
    offset: 0.46484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97dcf3",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96dcf3",
    offset: 0.47266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96dcf3",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95dbf3",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94dbf4",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94dbf4",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92daf4",
    offset: 0.49609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92daf4",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91daf4",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90d9f5",
    offset: 0.51172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fd9f5",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ed9f5",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8dd9f5",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8dd8f5",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8cd7f6",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8bd7f6",
    offset: 0.53516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ad7f6",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ad7f6",
    offset: 0.54297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89d6f6",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88d6f6",
    offset: 0.55078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87d6f6",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87d6f6",
    offset: 0.55859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86d6f7",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86d5f7",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85d5f7",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84d5f7",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84d5f7",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83d5f7",
    offset: 0.58203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83d4f8",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82d4f8",
    offset: 0.58984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81d4f8",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80d4f8",
    offset: 0.59766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80d3f8",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7fd3f8",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ed3f8",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7dd3f8",
    offset: 0.61328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7cd2f8",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7cd2f8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ad2f8",
    offset: 0.62891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79d2f8",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79d2f9",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78d1f9",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77d1f9",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77d1f9",
    offset: 0.65234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76d1f9",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75d0f9",
    offset: 0.66016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74d0f9",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74d0fa",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73cffa",
    offset: 0.67578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72cffa",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71cffa",
    offset: 0.68359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70cffa",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6fcffb",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ecefb",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ecefb",
    offset: 0.69922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6dcefb",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6dcefb",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ccdfb",
    offset: 0.71484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6bcdfb",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6acdfc",
    offset: 0.72266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6acdfc",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69ccfc",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68cbfc",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67cbfc",
    offset: 0.73828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67cbfc",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66cbfd",
    offset: 0.74609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65cafd",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65cafd",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63cafd",
    offset: 0.76172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63cafd",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62c9fe",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61c9fe",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61c9fe",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc9ff",
    offset: 0.78516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc8ff",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc8ff",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc8ff",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc7ff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc7ff",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc6ff",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc6ff",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc5ff",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc4ff",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc4ff",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc3ff",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc2ff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ec1ff",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ec0ff",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ec0ff",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebfff",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebfff",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebeff",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebdff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebcff",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebcff",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebbff",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebaff",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb9ff",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb8ff",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb8ff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "el"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m470 258h62.648v113h-62.648z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m476.9 258.88 48.617 28.07c3.7656 2.1758 6.8086 8 6.8086 13.023v64.676c0 5.0195-3.043 7.3281-6.8086 5.1562l-48.617-28.07c-3.7578-2.1719-6.8125-8.0078-6.8125-13.023v-64.684c0-2.6328 0.83984-4.5195 2.1836-5.4023 1.2188-0.80078 2.8477-0.77734 4.6289 0.25391z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m476.9 258.88 48.617 28.07c3.7656 2.1758 6.8086 8 6.8086 13.023v64.676c0 5.0195-3.043 7.3281-6.8086 5.1562l-48.617-28.07c-3.7578-2.1719-6.8125-8.0078-6.8125-13.023v-64.684c0-2.6328 0.83984-4.5195 2.1836-5.4023 1.2188-0.80078 2.8477-0.77734 4.6289 0.25391"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m575.59 277.67-94.68-43.438-54.074 117.89 94.676 43.438z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb",
    x1: 0.15761,
    x2: 0.92047,
    gradientTransform: "matrix(-70.886 154.54 -154.53 -70.893 539.21 231.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5f5ca",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4f4cb",
    offset: 0.0039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3f4cb",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c2f4cc",
    offset: 0.011719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c1f4cc",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0f3cd",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bff3ce",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bdf3ce",
    offset: 0.027344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bbf3cf",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#baf2cf",
    offset: 0.035156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9f1cf",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9f1cf",
    offset: 0.042969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b8f1d0",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7f1d0",
    offset: 0.050781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6f0d1",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4f0d1",
    offset: 0.058594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3f0d2",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b2f0d2",
    offset: 0.066406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b1efd2",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b0efd3",
    offset: 0.074219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#afefd3",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aeefd4",
    offset: 0.082031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#adeed4",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aceed4",
    offset: 0.089844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#abeed4",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a9eed5",
    offset: 0.097656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a8edd5",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7edd6",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6ecd6",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a5ecd7",
    offset: 0.11328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4ecd7",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3ecd8",
    offset: 0.12109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2ebd8",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0ebd9",
    offset: 0.12891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9febd9",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9eebda",
    offset: 0.13672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9debda",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9cebda",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9bebdb",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9aeadb",
    offset: 0.15234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99eadc",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98eadc",
    offset: 0.16016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97eadd",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95e9dd",
    offset: 0.16797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94e9de",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93e9de",
    offset: 0.17578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92e9de",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91e8df",
    offset: 0.18359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90e8df",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fe8e0",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ee8e0",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8de7e0",
    offset: 0.19922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ce7e0",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae7e1",
    offset: 0.20703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89e7e1",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88e6e2",
    offset: 0.21484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87e6e2",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86e6e3",
    offset: 0.22266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85e6e3",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84e5e4",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83e4e4",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82e4e5",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81e4e5",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7fe4e6",
    offset: 0.24609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ee4e6",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7de3e6",
    offset: 0.25391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ce3e7",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7be3e7",
    offset: 0.26172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ae3e8",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e3e8",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78e2e9",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77e2e9",
    offset: 0.27734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76e1ea",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75e1ea",
    offset: 0.28516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74e1eb",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72e1eb",
    offset: 0.29297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71e0eb",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70e0eb",
    offset: 0.30078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6fe0eb",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee0ec",
    offset: 0.30859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de0ec",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cdfed",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6bdfed",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6adfee",
    offset: 0.32422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69dfee",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68dfef",
    offset: 0.33203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67dfef",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66deef",
    offset: 0.33984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65deef",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63def0",
    offset: 0.34766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62def0",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61ddf1",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fddf1",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eddf2",
    offset: 0.36328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eddf3",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ddcf3",
    offset: 0.37109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cdcf4",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5bdcf4",
    offset: 0.37891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5adcf4",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59dbf4",
    offset: 0.38672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58dbf5",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57dbf5",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55daf6",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55daf6",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55d8f6",
    offset: 0.41016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d7f6",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d7f6",
    offset: 0.41797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d6f6",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d5f6",
    offset: 0.42578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d5f6",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d4f6",
    offset: 0.43359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d3f6",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d2f6",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d2f7",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d1f7",
    offset: 0.44922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52d1f7",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52d0f7",
    offset: 0.45703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cff7",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cef7",
    offset: 0.46484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cef7",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cdf7",
    offset: 0.47266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ccf7",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cbf7",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52caf7",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c9f7",
    offset: 0.48828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c8f7",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c8f7",
    offset: 0.49609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c7f7",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c6f7",
    offset: 0.50391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c5f7",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c5f7",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c4f7",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c3f7",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c2f7",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc1f8",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc1f8",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fbff8",
    offset: 0.54297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fbef8",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebef8",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebdf8",
    offset: 0.55859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebcf8",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebbf8",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebaf8",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4dbaf8",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db9f8",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db8f8",
    offset: 0.58203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db8f8",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db7f8",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4cb6f8",
    offset: 0.59766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb5f8",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb4f8",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb3f8",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb3f8",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb1f8",
    offset: 0.62109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ab0f8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ab0f8",
    offset: 0.62891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aaff8",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aaff8",
    offset: 0.63672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49aef8",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49adf8",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49acf8",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49acf8",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49abf8",
    offset: 0.66016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48aaf8",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a9f8",
    offset: 0.66797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a9f8",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a8f8",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a7f8",
    offset: 0.68359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a6f8",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a5f8",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a4f8",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a4f8",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a2f9",
    offset: 0.70703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a1f9",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a1f9",
    offset: 0.71484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a0f9",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a0f9",
    offset: 0.72266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469ff9",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469ef9",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469ef9",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469df9",
    offset: 0.73828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469df9",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469cf9",
    offset: 0.74609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469bf9",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459bf9",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459af9",
    offset: 0.76172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4599f9",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4498f9",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4497f9",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4497f9",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4495f9",
    offset: 0.78516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4494f9",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4494f9",
    offset: 0.79297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4493f9",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4393fa",
    offset: 0.80078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4392fa",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4392fa",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4391fa",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4390fa",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428ffa",
    offset: 0.82422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428ffa",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428efa",
    offset: 0.83203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428dfa",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#428dfa",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418cfa",
    offset: 0.84766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418bfa",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#418afa",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4189fa",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4189fa",
    offset: 0.86328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4188fa",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4088fa",
    offset: 0.87109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4087fa",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4087fa",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4086fa",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3f84fa",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3f84fa",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3f83fb",
    offset: 0.90234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e83fb",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e82fb",
    offset: 0.91016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e82fb",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e81fb",
    offset: 0.91797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e80fb",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3e80fb",
    offset: 0.92578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7ffb",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7ffb",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7efb",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7dfb",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7dfb",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d7bfb",
    offset: 0.95703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3c7afb",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3c7afb",
    offset: 0.96484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3c79fb",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3c79fb",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3c78fb",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b78fb",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b77fb",
    offset: 0.98828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b77fb",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b76fb",
    offset: 0.99609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3b76fb",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m243 269.29h62.984v113.34h-62.984z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ic"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.84 270.34 48.617 28.07c3.7656 2.1719 6.8086 8 6.8086 13.02v64.68c0 5.0195-3.043 7.3281-6.8086 5.1562l-48.617-28.07c-3.7578-2.1758-6.8125-8.0078-6.8125-13.023v-64.684c0-2.6328 0.84375-4.5234 2.1875-5.4062 1.2148-0.79688 2.8438-0.77344 4.625 0.25781z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m249.84 270.34 48.617 28.07c3.7656 2.1719 6.8086 8 6.8086 13.02v64.68c0 5.0195-3.043 7.3281-6.8086 5.1562l-48.617-28.07c-3.7578-2.1758-6.8125-8.0078-6.8125-13.023v-64.684c0-2.6328 0.84375-4.5234 2.1875-5.4062 1.2148-0.79688 2.8438-0.77344 4.625 0.25781"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m224.27 272.46 20.492 121.21 79.273-13.406-20.492-121.21z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gq",
    x1: 0.22601,
    x2: 0.76535,
    gradientTransform: "matrix(146.73 -24.813 24.81 146.75 201.39 338.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#abeed4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aaeed5",
    offset: 0.0039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aaedd5",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a9edd5",
    offset: 0.011719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a8edd5",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7edd6",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7edd6",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6edd7",
    offset: 0.027344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a5ecd7",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4ecd7",
    offset: 0.035156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3ecd7",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2ecd8",
    offset: 0.042969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2ecd9",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1ecd9",
    offset: 0.050781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0ebd9",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9febd9",
    offset: 0.058594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9febda",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9eebda",
    offset: 0.066406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9debda",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9cebda",
    offset: 0.074219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9cebdb",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9bebdb",
    offset: 0.082031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9aebdc",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99eadc",
    offset: 0.089844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98eadc",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98eadc",
    offset: 0.097656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97eadd",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96eadd",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95eadd",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94e9dd",
    offset: 0.11328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94e9de",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93e9de",
    offset: 0.12109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92e9df",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91e9df",
    offset: 0.12891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91e9df",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90e8df",
    offset: 0.13672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fe8df",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ee8e0",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ee8e0",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8de7e0",
    offset: 0.15234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ce7e0",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8be7e1",
    offset: 0.16016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae7e1",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae7e1",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88e6e2",
    offset: 0.17578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87e6e2",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87e6e3",
    offset: 0.18359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86e6e3",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85e6e3",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84e6e3",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83e5e4",
    offset: 0.19922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83e4e4",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82e4e4",
    offset: 0.20703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81e4e4",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80e4e5",
    offset: 0.21484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80e4e6",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7fe4e6",
    offset: 0.22266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ee3e6",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7de3e6",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ce3e7",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7be3e7",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7be3e8",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ae3e8",
    offset: 0.24609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e2e8",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e2e8",
    offset: 0.25391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78e2e9",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77e2e9",
    offset: 0.26172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76e2e9",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76e2e9",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75e1ea",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74e1ea",
    offset: 0.27734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73e1ea",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72e1ea",
    offset: 0.28516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71e1eb",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71e1eb",
    offset: 0.29297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70e0eb",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6fe0ec",
    offset: 0.30078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee0ec",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee0ec",
    offset: 0.30859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de0ec",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ce0ed",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cdfed",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6bdfed",
    offset: 0.32422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6adfed",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69dfee",
    offset: 0.33203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69dfee",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68dfee",
    offset: 0.33984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67dfee",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66dfef",
    offset: 0.34766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65dfef",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65def0",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64def0",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63def0",
    offset: 0.36328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62def0",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62def1",
    offset: 0.37109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61def1",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60ddf1",
    offset: 0.37891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fddf1",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fddf2",
    offset: 0.38672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eddf3",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dddf3",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dddf3",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cdcf3",
    offset: 0.40234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5bdcf4",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5adcf4",
    offset: 0.41016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5adcf4",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59dbf4",
    offset: 0.41797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58dbf5",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57dbf5",
    offset: 0.42578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56dbf5",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56dbf5",
    offset: 0.43359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55dbf6",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55daf6",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55d9f6",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55d9f6",
    offset: 0.44922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d8f6",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d8f6",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d7f6",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d6f6",
    offset: 0.47266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d5f6",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d5f6",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d4f6",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d4f6",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d3f6",
    offset: 0.49609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d2f7",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d2f7",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d1f7",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52d0f7",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cff7",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cef7",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cef7",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cdf7",
    offset: 0.53516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cdf7",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ccf7",
    offset: 0.54297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cbf7",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cbf7",
    offset: 0.55078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52caf7",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52caf7",
    offset: 0.55859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52c9f7",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c9f7",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c8f7",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c8f7",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c7f7",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c7f7",
    offset: 0.58203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c6f7",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c6f7",
    offset: 0.58984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c5f7",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c5f7",
    offset: 0.59766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c5f7",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c4f7",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c4f7",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c3f7",
    offset: 0.61328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c3f7",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc2f7",
    offset: 0.62109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc2f8",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc1f8",
    offset: 0.62891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc1f8",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc0f8",
    offset: 0.63672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc0f8",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fbff8",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fbef8",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebef8",
    offset: 0.65234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebdf8",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebdf8",
    offset: 0.66016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebcf8",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebcf8",
    offset: 0.66797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebbf8",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebbf8",
    offset: 0.67578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ebaf8",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4dbaf8",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4dbaf8",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db9f8",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db9f8",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4db8f8",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4cb7f8",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4cb6f8",
    offset: 0.72266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb5f8",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb5f8",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb4f8",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb4f8",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb3f8",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4bb2f8",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ab1f8",
    offset: 0.76172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ab0f8",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ab0f8",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aaff8",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aaff8",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4aaef8",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49adf8",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49acf8",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49abf8",
    offset: 0.80859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49abf8",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49aaf8",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a9f8",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a9f8",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a8f8",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a7f8",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48a6f8",
    offset: 0.84766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a5f8",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a5f8",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a4f8",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a4f8",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a3f8",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47a2f9",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a1f9",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a0f9",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#46a0f9",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469ff9",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469ef9",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469df9",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469cf9",
    offset: 0.93359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#469cf9",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459bf9",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459af9",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#459af9",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4599f9",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4598f9",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4497f9",
    offset: 0.97266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4496f9",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4496f9",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4495f9",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4495f9",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m403 59.227h63v112.77h-63z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ij"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410.27 60.254 48.613 28.07c3.7617 2.1719 6.8125 8 6.8125 13.016v64.684c0 5.0195-3.0508 7.3242-6.8125 5.1523l-48.613-28.07c-3.7656-2.1719-6.8125-8.0039-6.8125-13.023v-64.68c0-2.6328 0.83984-4.5234 2.1836-5.4102 1.2148-0.79688 2.8398-0.77344 4.6289 0.26172z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410.27 60.254 48.613 28.07c3.7617 2.1719 6.8125 8 6.8125 13.016v64.684c0 5.0195-3.0508 7.3242-6.8125 5.1523l-48.613-28.07c-3.7656-2.1719-6.8125-8.0039-6.8125-13.023v-64.68c0-2.6328 0.83984-4.5234 2.1836-5.4102 1.2148-0.79688 2.8398-0.77344 4.6289 0.26172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "de"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m522.25 108.64-91.84-80.293-83.516 95.551 91.84 80.293z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.23713,
    x2: 0.57024,
    gradientTransform: "matrix(-249.52 285.46 -285.43 -249.54 535.22 .5912)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7edd6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7edd6",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6edd6",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a5edd7",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4ecd7",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4ecd7",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3ecd7",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2ecd8",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1ecd9",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0ebd9",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9febd9",
    offset: 0.066406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9febda",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9eebda",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9debda",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9debdb",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9cebdb",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9bebdb",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9bebdc",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9aebdc",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99eadc",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98eadc",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97eadd",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96eadd",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95eadd",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95e9dd",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94e9de",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93e9de",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92e9df",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91e9df",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90e8df",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90e8df",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fe8df",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ee8df",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8de8e0",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ce7e0",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8be7e1",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8be7e1",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae7e1",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ae7e1",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89e7e1",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88e7e2",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87e6e2",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86e6e2",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85e6e2",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85e6e3",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84e6e3",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83e5e4",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82e5e4",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81e4e4",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81e4e5",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80e4e5",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7fe4e6",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ee4e6",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7de3e6",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ce3e7",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ce3e7",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7be3e7",
    offset: 0.36328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7be3e7",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ae3e7",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79e2e8",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78e2e8",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77e2e9",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77e2e9",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76e2e9",
    offset: 0.40234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76e2e9",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75e2e9",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74e1ea",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73e1ea",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72e1ea",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71e1eb",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71e1eb",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70e1eb",
    offset: 0.44922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70e0eb",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6fe0eb",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ee0ec",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de0ec",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6de0ec",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6cdfed",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6bdfed",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6adfed",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69dfee",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68dfee",
    offset: 0.51953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68dfee",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67dfee",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67dfee",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66dfef",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65deef",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64def0",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63def0",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62def0",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62def0",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61def1",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61def1",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60ddf1",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fddf1",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fddf2",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eddf2",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dddf3",
    offset: 0.61328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dddf3",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5cdcf3",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5bdcf3",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5adcf4",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59dcf4",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59dcf4",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58dbf4",
    offset: 0.65234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58dbf5",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57dbf5",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56dbf5",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56daf6",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55daf6",
    offset: 0.69141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55d9f6",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55d9f6",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55d8f6",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d7f6",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d7f6",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d6f6",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d5f6",
    offset: 0.73828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d5f6",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d5f6",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54d4f6",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d4f6",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d3f6",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d2f6",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d2f7",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53d1f7",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52d0f7",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cff7",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cff7",
    offset: 0.82422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cef7",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cef7",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cdf7",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ccf7",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cbf7",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52cbf7",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52caf7",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51caf7",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c9f7",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c8f7",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c7f7",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c7f7",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51c6f7",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c6f7",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c5f7",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c4f7",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50c3f7",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc2f8",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc1f8",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4fc1f8",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "en"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m283.32 236.04h71.68v118.96h-71.68z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m347.8 265.43-48.613-28.07c-1.7539-1.0117-3.3516-1.0508-4.5625-0.29688l-10.91 6.3047 6.8086 3.9336v60.961c0 5.0195 3.0508 10.852 6.8125 13.023l43.973 25.391v8.2656l10.562-6.1055c1.6641-0.69141 2.7422-2.7148 2.7422-5.7031v-64.68c0-5.0195-3.0508-10.844-6.8125-13.023z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m347.8 265.43-48.613-28.07c-1.7539-1.0117-3.3516-1.0508-4.5625-0.29688l-10.91 6.3047 6.8086 3.9336v60.961c0 5.0195 3.0508 10.852 6.8125 13.023l43.973 25.391v8.2656l10.562-6.1055c1.6641-0.69141 2.7422-2.7148 2.7422-5.7031v-64.68c0-5.0195-3.0508-10.844-6.8125-13.023"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ih"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m376.71 240.58-90.438-17.477-24.645 127.57 90.441 17.469z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: -0.064883,
    x2: 0.95756,
    gradientTransform: "matrix(-24.101 124.77 -124.76 -24.104 329.61 239.87)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffebb",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffdba",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffcb9",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffcb9",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffbb8",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fffab8",
    offset: 0.15234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff9b8",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff9b7",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff9b7",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff8b6",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff8b6",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7b5",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7b5",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7b4",
    offset: 0.19922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff7b4",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff6b4",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff5b3",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff5b3",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff4b2",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff3b1",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff3b1",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff3b1",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff2b0",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff1b0",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff1af",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff0ae",
    offset: 0.27734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff0ad",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffefad",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeead",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeeac",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffedac",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffecab",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffecab",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffecab",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffebaa",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffebaa",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeaa9",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeaa8",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffeaa8",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe9a8",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8a7",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe7a6",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe6a6",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe6a6",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe6a5",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe5a4",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4a4",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe4a3",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe3a3",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe2a2",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1a1",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1a1",
    offset: 0.44922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1a0",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe1a0",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe0a0",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdf9f",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdf9e",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffde9e",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdd9d",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdd9d",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdc9c",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdb9c",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdb9c",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffdb9b",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffda9a",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd99a",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd999",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd899",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd798",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd798",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd697",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd697",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd596",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd596",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd495",
    offset: 0.61328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd394",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd394",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd394",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd293",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd292",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd192",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd092",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffd091",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcf90",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffce90",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffce8f",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcd8f",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcd8e",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcc8e",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcb8d",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffcb8c",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffca8c",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffca8c",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc98b",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc88a",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc78a",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc689",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc689",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc688",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc587",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc587",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc486",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc486",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc385",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc285",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc284",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc184",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc183",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc183",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffc083",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbf82",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbf81",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbe81",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbd80",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbc80",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbc80",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbc7f",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb7f",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbb7e",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffba7e",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb97d",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb97c",
    offset: 0.94922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb87b",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb87b",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb77a",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb77a",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb779",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb679",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb579",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m281 242.09h63v113.34h-63z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288.35 243.63 48.609 28.07c3.7656 2.1719 6.8164 8 6.8164 13.016v64.684c0 5.0156-3.0508 7.3242-6.8164 5.1523l-48.609-28.07c-3.7656-2.1719-6.8164-8.0039-6.8164-13.023v-64.68c0-2.6328 0.84375-4.5234 2.1875-5.4102 1.2188-0.79688 2.8398-0.77344 4.6289 0.26172z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ik"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m288.35 243.63 48.609 28.07c3.7656 2.1719 6.8164 8 6.8164 13.016v64.684c0 5.0156-3.0508 7.3242-6.8164 5.1523l-48.609-28.07c-3.7656-2.1719-6.8164-8.0039-6.8164-13.023v-64.68c0-2.6328 0.84375-4.5234 2.1875-5.4102 1.2188-0.79688 2.8398-0.77344 4.6289 0.26172"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m398.64 283.94-94.555-71.285-77.422 102.71 94.555 71.289z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fx",
    x1: 0.041412,
    x2: 0.59418,
    gradientTransform: "matrix(-138.94 184.32 -184.3 -138.95 356.91 240.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb551",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb551",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb452",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb352",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb353",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb353",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb254",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb255",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb156",
    offset: 0.066406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb156",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb156",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb057",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb058",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaf58",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaf59",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaf5a",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaf5a",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffae5b",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffae5b",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffae5c",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffad5c",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffad5d",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffac5e",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffac5f",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffab60",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffab60",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffab61",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaa62",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaa62",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffaa63",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa964",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa964",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa964",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa865",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa865",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa866",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa767",
    offset: 0.27734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa767",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa768",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa669",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa669",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa56a",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa56a",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa46b",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa46c",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa46d",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa36e",
    offset: 0.36328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa36e",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa36e",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa26f",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa26f",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa170",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa171",
    offset: 0.40234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa171",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa172",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa073",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa073",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9f74",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9f74",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9f75",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9e76",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9e76",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9e77",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9d78",
    offset: 0.48828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9d78",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9d78",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9c79",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9c7a",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9b7a",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9b7b",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9b7b",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9a7c",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9a7d",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9a7d",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9a7e",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff997e",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff997f",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff987f",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9880",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9780",
    offset: 0.60547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9781",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9781",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9782",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9682",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9683",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9684",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9584",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9585",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9585",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9486",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9487",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9388",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9388",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9289",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff928a",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff928a",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff928b",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff928b",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff918c",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff908c",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8f8d",
    offset: 0.76953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8f8d",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8e8d",
    offset: 0.77734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8e8d",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8d8d",
    offset: 0.78516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8d8d",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8c8d",
    offset: 0.79297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b8d",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8b8d",
    offset: 0.80078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8a8d",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff8a8d",
    offset: 0.80859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff898d",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe898d",
    offset: 0.81641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd888e",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd888e",
    offset: 0.82422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd878e",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd878e",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd868e",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd858e",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd848e",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd838e",
    offset: 0.86328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd828e",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd818e",
    offset: 0.87109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd818e",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd808e",
    offset: 0.87891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd808e",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7f8e",
    offset: 0.88672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7e8e",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7e8e",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7d8e",
    offset: 0.90234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7c8e",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7c8e",
    offset: 0.91016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7b8e",
    offset: 0.91406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7b8e",
    offset: 0.91797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7a8e",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd7a8e",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd798e",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fd788e",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc788f",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc778f",
    offset: 0.94922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc778f",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc768f",
    offset: 0.95703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc768f",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc758f",
    offset: 0.96484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc758f",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc748f",
    offset: 0.97266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc748f",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc738f",
    offset: 0.98047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc738f",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc728f",
    offset: 0.98828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc718f",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc718f",
    offset: 0.99609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fc708f",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570 96h63v112.84h-63z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m577.2 96.848 48.613 28.07c3.7656 2.1719 6.8125 8.0039 6.8125 13.023v64.684c0 5.0156-3.0469 7.3242-6.8125 5.1523l-48.613-28.07c-3.7617-2.1797-6.8125-8.0039-6.8125-13.023v-64.684c0-2.6367 0.83984-4.5195 2.1836-5.4062 1.2148-0.79688 2.8438-0.77344 4.6289 0.25391z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m577.2 96.848 48.613 28.07c3.7656 2.1719 6.8125 8.0039 6.8125 13.023v64.684c0 5.0156-3.0469 7.3242-6.8125 5.1523l-48.613-28.07c-3.7617-2.1797-6.8125-8.0039-6.8125-13.023v-64.684c0-2.6367 0.83984-4.5195 2.1836-5.4062 1.2148-0.79688 2.8438-0.77344 4.6289 0.25391"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m687.49 137.16-94.551-71.285-77.422 102.71 94.559 71.281z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cw",
    x1: 0.11279,
    x2: 0.79217,
    gradientTransform: "matrix(-113.17 150.14 -150.12 -113.18 652.71 84.383)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1f5e3",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0f5e3",
    offset: 0.0039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0f5e3",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dff4e4",
    offset: 0.011719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#def4e4",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ddf3e4",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcf3e4",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbf3e5",
    offset: 0.027344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daf3e5",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9f2e5",
    offset: 0.035156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8f1e6",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d7f1e6",
    offset: 0.042969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6f1e6",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5f0e6",
    offset: 0.050781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4f0e7",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3f0e7",
    offset: 0.058594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2efe7",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1efe7",
    offset: 0.066406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0eee8",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cfeee8",
    offset: 0.074219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ceeee8",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cdeee8",
    offset: 0.082031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccede8",
    offset: 0.085938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbede8",
    offset: 0.089844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#caece9",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9ece9",
    offset: 0.097656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8ece9",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7ece9",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6ebea",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5ebea",
    offset: 0.11328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4ebea",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3eaea",
    offset: 0.12109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c2eaea",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0eaea",
    offset: 0.12891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bfeaeb",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bee9eb",
    offset: 0.13672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bde9eb",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bce8eb",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bbe8eb",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#bae7eb",
    offset: 0.15234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b9e7eb",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b8e7ec",
    offset: 0.16016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b7e7ec",
    offset: 0.16406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b6e6ec",
    offset: 0.16797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b5e6ec",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4e5ed",
    offset: 0.17578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3e5ed",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b2e5ed",
    offset: 0.18359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b1e4ed",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b0e4ed",
    offset: 0.19141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#afe3ed",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aee3ee",
    offset: 0.19922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ade3ee",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ace3ee",
    offset: 0.20703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#abe2ee",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#aae2ef",
    offset: 0.21484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a9e1ef",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a8e1ef",
    offset: 0.22266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a7e1ef",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a6e1f0",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a5e0f0",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a4e0f0",
    offset: 0.23828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a3dff0",
    offset: 0.24219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a2dff0",
    offset: 0.24609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a1dff0",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a0dff1",
    offset: 0.25391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9fdff1",
    offset: 0.25781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9edef1",
    offset: 0.26172
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9ddef1",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9cddf2",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9bddf2",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9addf2",
    offset: 0.27734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99dcf3",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98dcf3",
    offset: 0.28516
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97dcf3",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96dbf3",
    offset: 0.29297
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95dbf4",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94daf4",
    offset: 0.30078
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93daf4",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#92daf4",
    offset: 0.30859
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91daf5",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90d9f5",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8fd9f5",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ed8f5",
    offset: 0.32422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8dd8f5",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8cd8f5",
    offset: 0.33203
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8bd7f6",
    offset: 0.33594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8ad7f6",
    offset: 0.33984
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89d6f6",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#88d6f6",
    offset: 0.34766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87d6f7",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86d6f7",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85d5f7",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84d5f7",
    offset: 0.36328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83d4f7",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82d4f7",
    offset: 0.37109
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#81d4f8",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80d4f8",
    offset: 0.37891
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7fd3f8",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ed3f8",
    offset: 0.38672
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7dd2f8",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7cd2f8",
    offset: 0.39453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7bd2f8",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ad2f9",
    offset: 0.40234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79d2f9",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78d1f9",
    offset: 0.41016
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#77d1f9",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76d1f9",
    offset: 0.41797
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75d0fa",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74d0fa",
    offset: 0.42578
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73d0fa",
    offset: 0.42969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72cffa",
    offset: 0.43359
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71cffa",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70cefb",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6fcefb",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ecefb",
    offset: 0.44922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6dcefb",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6ccdfc",
    offset: 0.45703
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6bcdfc",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6accfc",
    offset: 0.46484
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6accfc",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69ccfc",
    offset: 0.47266
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68cbfc",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66cbfd",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65cafd",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64cafd",
    offset: 0.48828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63cafd",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62cafe",
    offset: 0.49609
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61c9fe",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60c9fe",
    offset: 0.50391
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc8ff",
    offset: 0.50781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc8ff",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc8ff",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc7ff",
    offset: 0.52734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc7ff",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc6ff",
    offset: 0.53906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc5ff",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc5ff",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc4ff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc3ff",
    offset: 0.56641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc2ff",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc2ff",
    offset: 0.57422
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5fc1ff",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ec1ff",
    offset: 0.58594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ec0ff",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebfff",
    offset: 0.60156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebeff",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebeff",
    offset: 0.61328
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebdff",
    offset: 0.61719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebdff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebcff",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebbff",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ebaff",
    offset: 0.64453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb9ff",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb9ff",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb8ff",
    offset: 0.66406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb7ff",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb6ff",
    offset: 0.67969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb5ff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb4ff",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb4ff",
    offset: 0.69922
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb3ff",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5eb3ff",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5db2ff",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5db1ff",
    offset: 0.72656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5db0ff",
    offset: 0.73047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dafff",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dafff",
    offset: 0.73828
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5daeff",
    offset: 0.74219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5daeff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dadff",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dacff",
    offset: 0.77344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5dabff",
    offset: 0.77734
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5daaff",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5daaff",
    offset: 0.78906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5da9ff",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5da8ff",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5da7ff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5da6ff",
    offset: 0.82031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5da5ff",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5da5ff",
    offset: 0.83594
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5da4ff",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5da3ff",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ca2ff",
    offset: 0.85547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ca1ff",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ca1ff",
    offset: 0.86719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ca0ff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ca0ff",
    offset: 0.88281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9fff",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9eff",
    offset: 0.89453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9dff",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9dff",
    offset: 0.90234
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9cff",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9cff",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9bff",
    offset: 0.92969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c9aff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c99ff",
    offset: 0.94141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c98ff",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c98ff",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c97ff",
    offset: 0.96094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c97ff",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c96ff",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c95ff",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c94ff",
    offset: 0.99219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5c93ff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m380.03 217h46.844v59h-46.844z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m415.58 265.8c0.86719-2.7109 1.3984-6.0234 1.5117-9.8242l6.5938 3.8125c-0.25 4.6836-1.7852 8.2344-4.2031 10.449-1.1875-1.5156-2.4961-3.0039-3.9023-4.4375zm-4.4648 6.9766c1.4531-1.0234 2.707-2.6914 3.6836-4.9062 1.1172 1.1445 2.1602 2.3242 3.125 3.5234-1.9531 1.1797-4.2734 1.6367-6.8086 1.3828zm-19.984-14.5-0.18359-0.26563c-0.10156-0.14844-0.12891-0.19531-0.16406-0.24609l-0.11328-0.17188c-0.67969-1.0156-1.2812-2-1.8477-3.0039 0.96094-0.089844 2.0117-0.054688 3.1328 0.09375 0.96484 3.3281 2.1992 6.4297 3.6445 9.1328-1.5898-1.6758-3.0898-3.5352-4.4688-5.5391zm-3.8477-6.6328c-2.4023-4.9961-3.9023-10.305-4.1289-15.262l6.582 3.8008c0.089844 3.9141 0.60156 7.8281 1.4531 11.531-1.4062-0.19141-2.7227-0.21875-3.9062-0.070313zm0.074219-28.383c1.1875 1.5195 2.4922 3.0039 3.8984 4.4375-0.87109 2.7109-1.4023 6.0156-1.5078 9.8125l-6.5859-3.8047c0.24609-4.6797 1.7773-8.2344 4.1953-10.445zm17.23 22.82 0.023437-8.2227c3.0938 1.6758 6.0938 2.8633 8.8242 3.5117 0.77344 3.3945 1.2461 7 1.3359 10.59zm-11.121-16.238c2.7266 2.5 5.7266 4.7734 8.8203 6.6758l-0.023437 8.2227-10.188-5.8867c0.10547-3.4766 0.60156-6.5234 1.3906-9.0117zm-1.4336-4.2148c-1.1172-1.1406-2.1602-2.3203-3.1211-3.5195 1.957-1.1797 4.2734-1.6406 6.8047-1.3945-1.4531 1.0273-2.7031 2.6992-3.6836 4.9141zm10.258 8.1992c-2.8242-1.7383-5.5586-3.8047-8.0391-6.0625 1.8672-4.168 4.7695-6.1133 8.0742-4.8945zm8.9492-4.1562c2.5273 2.6719 4.8359 5.8086 6.7773 9.2422-0.96875 0.085938-2.0117 0.054688-3.1328-0.09375-0.96484-3.3359-2.1992-6.4414-3.6445-9.1484zm-6.5859-5.457c3.3008 2.5977 6.1719 7.8711 8.0078 14.18-2.4766-0.60547-5.2109-1.6914-8.043-3.2227zm-12.586 17.316 10.188 5.8867-0.023437 8.2266c-3.0977-1.6758-6.0977-2.8633-8.8242-3.5117-0.77734-3.3984-1.25-7.0078-1.3398-10.602zm10.125 27.75c-3.3008-2.5977-6.1758-7.8672-8.0156-14.18 2.4844 0.60938 5.2148 1.6953 8.0508 3.2188zm2.3242 1.3477 0.035157-10.965c2.8281 1.7422 5.5547 3.8086 8.0352 6.0703-1.8672 4.168-4.7656 6.1055-8.0703 4.8945zm8.8477-6.9727c-2.7188-2.4961-5.7148-4.7695-8.8047-6.6641l0.023438-8.2344 10.176 5.8789c-0.10547 3.4766-0.59766 6.5273-1.3945 9.0195zm10.332-6.5391-6.6016-3.8086c-0.085937-3.9141-0.59375-7.8242-1.4453-11.52 1.4102 0.19141 2.7227 0.21484 3.9141 0.066406 2.4023 4.9922 3.9062 10.301 4.1328 15.262zm2.3555 2.6953c0.011718-5.8789-1.6797-12.297-4.5469-18.316l-0.52344-1.0859-0.28516-0.53906c-0.16016-0.3125-0.33594-0.60156-0.5-0.91016-0.32812-0.59375-0.64453-1.1914-0.98828-1.7734-0.23438-0.39844-0.47656-0.77344-0.71875-1.1602-0.33594-0.54297-0.67188-1.0898-1.0352-1.6211-0.26562-0.39844-0.54297-0.76953-0.8125-1.1523-0.35938-0.5-0.71484-1.0078-1.0859-1.5039-0.28516-0.36719-0.57812-0.71484-0.86719-1.0742-0.38672-0.48047-0.76953-0.96484-1.1719-1.4258-0.28906-0.33594-0.59375-0.64844-0.89062-0.97266-0.41016-0.44922-0.82422-0.91016-1.2578-1.3398-0.30469-0.3125-0.625-0.59766-0.9375-0.89062-0.42969-0.40625-0.85547-0.82812-1.2969-1.2148-0.37109-0.32812-0.75781-0.61719-1.1328-0.92188-0.39062-0.32031-0.77344-0.65625-1.1758-0.95312-0.78516-0.58984-1.582-1.1367-2.3789-1.6406l-0.28906-0.17578-0.28516-0.17188c-0.17578-0.10547-0.27734-0.16406-0.375-0.22266l-0.30078-0.17188c-0.15625-0.082031-0.23828-0.12891-0.31641-0.17187l-0.3125-0.17188c-0.8125-0.42969-1.6172-0.79687-2.4023-1.1211-0.39844-0.16016-0.78516-0.26953-1.1719-0.40625-0.38672-0.12891-0.77344-0.28516-1.1445-0.39062-0.44531-0.11719-0.86328-0.19531-1.293-0.28125-0.32031-0.066406-0.64453-0.14844-0.96484-0.19531-0.41797-0.066406-0.83203-0.082031-1.2383-0.10938-0.30859-0.023437-0.62109-0.058594-0.92188-0.058594-0.39453 0-0.76562 0.035157-1.1484 0.066407-0.30469 0.023437-0.60938 0.035156-0.89844 0.082031-0.36719 0.058594-0.71875 0.14844-1.0703 0.23828-0.28125 0.070313-0.57031 0.12891-0.84375 0.21875-0.35156 0.12109-0.69141 0.27734-1.0273 0.42188-0.24219 0.11328-0.49609 0.20703-0.72656 0.33594-0.35938 0.19141-0.6875 0.42188-1.0195 0.65625-0.14844 0.10156-0.3125 0.17969-0.45312 0.28906l-0.35938 0.27344-0.48438 0.375c-2.8633 2.7344-4.5898 7.1797-4.6055 13.059-0.011719 5.8867 1.6758 12.309 4.5469 18.332l0.57031 1.168 0.23828 0.45312c0.46484 0.90625 0.96094 1.8008 1.4727 2.6758l0.19141 0.32031 0.097656 0.16406 0.089844 0.14844 0.14062 0.23047c1.1758 1.918 2.4102 3.6758 3.7188 5.3242l0.20703 0.25781c0.13672 0.16797 0.18359 0.23047 0.23047 0.28906l0.16016 0.19141c0.80078 0.96875 1.5508 1.8125 2.3242 2.6211l0.13672 0.13281c0.72656 0.75781 1.4648 1.4883 2.2188 2.1758l0.21484 0.16797c0.73047 0.66406 1.4727 1.293 2.2344 1.8789 0.82812 0.63672 1.6641 1.2344 2.5156 1.7773l0.29688 0.18359 0.27734 0.17578c0.14062 0.082032 0.21094 0.12891 0.28906 0.17188 0.17969 0.11328 0.28125 0.16406 0.38281 0.22266l0.30078 0.17969c0.16016 0.085937 0.23438 0.12891 0.30859 0.16406 0.15234 0.082031 0.22656 0.12891 0.3125 0.17187l0.3125 0.16016c0.84375 0.43359 1.6562 0.80078 2.4648 1.1133 0.79297 0.30859 1.5703 0.55469 2.332 0.75781 0.80859 0.20703 1.5664 0.34766 2.2969 0.43359 0.80469 0.097656 1.5352 0.13281 2.25 0.10938l0.24219-0.007812c0.28906-0.015625 0.33984-0.023438 0.39453-0.027344 0.14062-0.011719 0.20703-0.019531 0.26953-0.023437 1.7891-0.18359 3.418-0.72266 4.8711-1.6211 0.36719-0.23828 0.41406-0.26953 0.46094-0.30469l0.21094-0.15234 0.22656-0.16797 0.84375-0.64844c2.8555-2.7383 4.5859-7.1836 4.6055-13.07z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ct"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m415.58 265.8c0.86719-2.7109 1.3984-6.0234 1.5117-9.8242l6.5938 3.8125c-0.25 4.6836-1.7852 8.2344-4.2031 10.449-1.1875-1.5156-2.4961-3.0039-3.9023-4.4375zm-4.4648 6.9766c1.4531-1.0234 2.707-2.6914 3.6836-4.9062 1.1172 1.1445 2.1602 2.3242 3.125 3.5234-1.9531 1.1797-4.2734 1.6367-6.8086 1.3828zm-19.984-14.5-0.18359-0.26563c-0.10156-0.14844-0.12891-0.19531-0.16406-0.24609l-0.11328-0.17188c-0.67969-1.0156-1.2812-2-1.8477-3.0039 0.96094-0.089844 2.0117-0.054688 3.1328 0.09375 0.96484 3.3281 2.1992 6.4297 3.6445 9.1328-1.5898-1.6758-3.0898-3.5352-4.4688-5.5391zm-3.8477-6.6328c-2.4023-4.9961-3.9023-10.305-4.1289-15.262l6.582 3.8008c0.089844 3.9141 0.60156 7.8281 1.4531 11.531-1.4062-0.19141-2.7227-0.21875-3.9062-0.070313zm0.074219-28.383c1.1875 1.5195 2.4922 3.0039 3.8984 4.4375-0.87109 2.7109-1.4023 6.0156-1.5078 9.8125l-6.5859-3.8047c0.24609-4.6797 1.7773-8.2344 4.1953-10.445zm17.23 22.82 0.023437-8.2227c3.0938 1.6758 6.0938 2.8633 8.8242 3.5117 0.77344 3.3945 1.2461 7 1.3359 10.59zm-11.121-16.238c2.7266 2.5 5.7266 4.7734 8.8203 6.6758l-0.023437 8.2227-10.188-5.8867c0.10547-3.4766 0.60156-6.5234 1.3906-9.0117zm-1.4336-4.2148c-1.1172-1.1406-2.1602-2.3203-3.1211-3.5195 1.957-1.1797 4.2734-1.6406 6.8047-1.3945-1.4531 1.0273-2.7031 2.6992-3.6836 4.9141zm10.258 8.1992c-2.8242-1.7383-5.5586-3.8047-8.0391-6.0625 1.8672-4.168 4.7695-6.1133 8.0742-4.8945zm8.9492-4.1562c2.5273 2.6719 4.8359 5.8086 6.7773 9.2422-0.96875 0.085938-2.0117 0.054688-3.1328-0.09375-0.96484-3.3359-2.1992-6.4414-3.6445-9.1484zm-6.5859-5.457c3.3008 2.5977 6.1719 7.8711 8.0078 14.18-2.4766-0.60547-5.2109-1.6914-8.043-3.2227zm-12.586 17.316 10.188 5.8867-0.023437 8.2266c-3.0977-1.6758-6.0977-2.8633-8.8242-3.5117-0.77734-3.3984-1.25-7.0078-1.3398-10.602zm10.125 27.75c-3.3008-2.5977-6.1758-7.8672-8.0156-14.18 2.4844 0.60938 5.2148 1.6953 8.0508 3.2188zm2.3242 1.3477 0.035157-10.965c2.8281 1.7422 5.5547 3.8086 8.0352 6.0703-1.8672 4.168-4.7656 6.1055-8.0703 4.8945zm8.8477-6.9727c-2.7188-2.4961-5.7148-4.7695-8.8047-6.6641l0.023438-8.2344 10.176 5.8789c-0.10547 3.4766-0.59766 6.5273-1.3945 9.0195zm10.332-6.5391-6.6016-3.8086c-0.085937-3.9141-0.59375-7.8242-1.4453-11.52 1.4102 0.19141 2.7227 0.21484 3.9141 0.066406 2.4023 4.9922 3.9062 10.301 4.1328 15.262zm2.3555 2.6953c0.011718-5.8789-1.6797-12.297-4.5469-18.316l-0.52344-1.0859-0.28516-0.53906c-0.16016-0.3125-0.33594-0.60156-0.5-0.91016-0.32812-0.59375-0.64453-1.1914-0.98828-1.7734-0.23438-0.39844-0.47656-0.77344-0.71875-1.1602-0.33594-0.54297-0.67188-1.0898-1.0352-1.6211-0.26562-0.39844-0.54297-0.76953-0.8125-1.1523-0.35938-0.5-0.71484-1.0078-1.0859-1.5039-0.28516-0.36719-0.57812-0.71484-0.86719-1.0742-0.38672-0.48047-0.76953-0.96484-1.1719-1.4258-0.28906-0.33594-0.59375-0.64844-0.89062-0.97266-0.41016-0.44922-0.82422-0.91016-1.2578-1.3398-0.30469-0.3125-0.625-0.59766-0.9375-0.89062-0.42969-0.40625-0.85547-0.82812-1.2969-1.2148-0.37109-0.32812-0.75781-0.61719-1.1328-0.92188-0.39062-0.32031-0.77344-0.65625-1.1758-0.95312-0.78516-0.58984-1.582-1.1367-2.3789-1.6406l-0.28906-0.17578-0.28516-0.17188c-0.17578-0.10547-0.27734-0.16406-0.375-0.22266l-0.30078-0.17188c-0.15625-0.082031-0.23828-0.12891-0.31641-0.17187l-0.3125-0.17188c-0.8125-0.42969-1.6172-0.79687-2.4023-1.1211-0.39844-0.16016-0.78516-0.26953-1.1719-0.40625-0.38672-0.12891-0.77344-0.28516-1.1445-0.39062-0.44531-0.11719-0.86328-0.19531-1.293-0.28125-0.32031-0.066406-0.64453-0.14844-0.96484-0.19531-0.41797-0.066406-0.83203-0.082031-1.2383-0.10938-0.30859-0.023437-0.62109-0.058594-0.92188-0.058594-0.39453 0-0.76562 0.035157-1.1484 0.066407-0.30469 0.023437-0.60938 0.035156-0.89844 0.082031-0.36719 0.058594-0.71875 0.14844-1.0703 0.23828-0.28125 0.070313-0.57031 0.12891-0.84375 0.21875-0.35156 0.12109-0.69141 0.27734-1.0273 0.42188-0.24219 0.11328-0.49609 0.20703-0.72656 0.33594-0.35938 0.19141-0.6875 0.42188-1.0195 0.65625-0.14844 0.10156-0.3125 0.17969-0.45312 0.28906l-0.35938 0.27344-0.48438 0.375c-2.8633 2.7344-4.5898 7.1797-4.6055 13.059-0.011719 5.8867 1.6758 12.309 4.5469 18.332l0.57031 1.168 0.23828 0.45312c0.46484 0.90625 0.96094 1.8008 1.4727 2.6758l0.19141 0.32031 0.097656 0.16406 0.089844 0.14844 0.14062 0.23047c1.1758 1.918 2.4102 3.6758 3.7188 5.3242l0.20703 0.25781c0.13672 0.16797 0.18359 0.23047 0.23047 0.28906l0.16016 0.19141c0.80078 0.96875 1.5508 1.8125 2.3242 2.6211l0.13672 0.13281c0.72656 0.75781 1.4648 1.4883 2.2188 2.1758l0.21484 0.16797c0.73047 0.66406 1.4727 1.293 2.2344 1.8789 0.82812 0.63672 1.6641 1.2344 2.5156 1.7773l0.29688 0.18359 0.27734 0.17578c0.14062 0.082032 0.21094 0.12891 0.28906 0.17188 0.17969 0.11328 0.28125 0.16406 0.38281 0.22266l0.30078 0.17969c0.16016 0.085937 0.23438 0.12891 0.30859 0.16406 0.15234 0.082031 0.22656 0.12891 0.3125 0.17187l0.3125 0.16016c0.84375 0.43359 1.6562 0.80078 2.4648 1.1133 0.79297 0.30859 1.5703 0.55469 2.332 0.75781 0.80859 0.20703 1.5664 0.34766 2.2969 0.43359 0.80469 0.097656 1.5352 0.13281 2.25 0.10938l0.24219-0.007812c0.28906-0.015625 0.33984-0.023438 0.39453-0.027344 0.14062-0.011719 0.20703-0.019531 0.26953-0.023437 1.7891-0.18359 3.418-0.72266 4.8711-1.6211 0.36719-0.23828 0.41406-0.26953 0.46094-0.30469l0.21094-0.15234 0.22656-0.16797 0.84375-0.64844c2.8555-2.7383 4.5859-7.1836 4.6055-13.07"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m452.8 235.29-58.301-38.441-40.457 61.375 58.301 38.441z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cn",
    x1: 0.05226,
    x2: 0.77771,
    gradientTransform: "matrix(-55.764 84.598 -84.589 -55.769 426.56 211.65)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdffff",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fcffff",
    offset: 0.019531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbffff",
    offset: 0.023438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbffff",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fbffff",
    offset: 0.039062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#faffff",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9ffff",
    offset: 0.054688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f9ffff",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8ffff",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7ffff",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6ffff",
    offset: 0.10156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5ffff",
    offset: 0.10547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5ffff",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5ffff",
    offset: 0.11719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4ffff",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4ffff",
    offset: 0.13281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3ffff",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2ffff",
    offset: 0.14453
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1ffff",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1ffff",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1ffff",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0ffff",
    offset: 0.17969
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#efffff",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edffff",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edffff",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ecffff",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ecffff",
    offset: 0.23047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.26953
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.30469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ffff",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.31641
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.32031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.34766
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.35547
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.36719
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0ffff",
    offset: 0.38281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0ffff",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfffff",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#deffff",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dff",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcffff",
    offset: 0.44141
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbffff",
    offset: 0.44531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbffff",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbffff",
    offset: 0.46094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daffff",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daffff",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9ffff",
    offset: 0.48047
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8ffff",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8ffff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d7ffff",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6ffff",
    offset: 0.52344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5ffff",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5ffff",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4ffff",
    offset: 0.55469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3ffff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2feff",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2feff",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1fdff",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1fdff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0fcff",
    offset: 0.63281
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0fcff",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cffcff",
    offset: 0.64844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cffcff",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cefbff",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cefbff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cdfaff",
    offset: 0.69531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cdfaff",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccfaff",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbf9ff",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbf9ff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#caf8ff",
    offset: 0.75781
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#caf8ff",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9f8ff",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8f8ff",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8f7ff",
    offset: 0.80469
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8f7ff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7f7ff",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6f6ff",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6f6ff",
    offset: 0.85156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6f6ff",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5f5ff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5f5ff",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4f4ff",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4f4ff",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3f4ff",
    offset: 0.92188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c3f3ff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c2f2ff",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c2f2ff",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c1f1ff",
    offset: 0.97656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c1f1ff",
    offset: 0.98438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c0f1ff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ee"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m579.5 121.19h42.309v65.812h-42.309z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m582.86 161.3 0.11328-37.992-2.9102-1.6758-0.12109 41.336 41.367 23.879 0.011718-3.3438z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m582.86 161.3 0.11328-37.992-2.9102-1.6758-0.12109 41.336 41.367 23.879 0.011718-3.3438-38.461-22.203"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "at"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m547.39 156.14 54.441 51.367 52.031-55.164-54.438-51.363z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hr",
    x1: 0.099642,
    x2: 0.46667,
    gradientTransform: "matrix(141.77 -150.29 150.28 141.79 560.52 196.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8ffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8ffff",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7ffff",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6ffff",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6ffff",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5ffff",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5ffff",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4ffff",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3ffff",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3ffff",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2ffff",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2ffff",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1ffff",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0ffff",
    offset: 0.21094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0ffff",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#efffff",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#efffff",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edffff",
    offset: 0.28906
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edffff",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ecffff",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ecffff",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.41406
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ffff",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.49219
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.57031
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0ffff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0ffff",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfffff",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfffff",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#deffff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#deffff",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dff",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dff",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcffff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbffff",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbffff",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daffff",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daffff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9ffff",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8ffff",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8ffff",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d7ffff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6ffff",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6ffff",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5ffff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4ffff",
    offset: 0.94531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4ffff",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3ffff",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3ffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ea"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m586 152h7v11.504h-7z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m592.25 155.62-6.0508-3.4961-0.023437 7.8516 6.0508 3.4961z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m592.25 155.62-6.0508-3.4961-0.023437 7.8516 6.0508 3.4961 0.023438-7.8516"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "es"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m580.5 158.12 8.8789 8.375 8.5234-9.0352-8.8789-8.3789z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: 0.20264,
    x2: 0.26276,
    gradientTransform: "matrix(141.77 -150.29 150.27 141.78 556.22 192.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edffff",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ecffff",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ecffff",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m594.61 144h6.3945v25h-6.3945z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m600.77 147.71-6.0625-3.5078-0.058593 20.668 6.0586 3.5z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m600.77 147.71-6.0625-3.5078-0.058593 20.668 6.0586 3.5 0.0625-20.66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m582.59 156.98 15.301 14.441 14.945-15.844-15.297-14.434z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ff",
    x1: 0.21355,
    x2: 0.31897,
    gradientTransform: "matrix(141.77 -150.29 150.27 141.78 559.96 196.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ffff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m603 155h6.7148v19h-6.7148z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m609.23 158.8-6.0508-3.4961-0.039062 14.465 6.0469 3.4922z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "az"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m609.23 158.8-6.0508-3.4961-0.039062 14.465 6.0469 3.4922 0.042968-14.461"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "iq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m594.18 164.81 12.184 11.5 11.832-12.547-12.188-11.492z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 0.22414,
    x2: 0.30759,
    gradientTransform: "matrix(141.77 -150.29 150.27 141.78 568.5 204.26)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ffff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ffff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m611.23 146h6.7734v32.613h-6.7734z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m617.76 149.99-6.0625-3.5-0.085937 28.176 6.0703 3.5039z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m617.76 149.99-6.0625-3.5-0.085937 28.176 6.0703 3.5039 0.078124-28.18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gs"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m595.8 163.25 19.059 17.984 18.707-19.828-19.062-17.988z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa",
    x1: 0.23541,
    x2: 0.36734,
    gradientTransform: "matrix(141.77 -150.29 150.28 141.79 571.96 207.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ffff",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ffff",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0ffff",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0ffff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfffff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#deffff",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#deffff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m425.36 96h22.637v32h-22.637z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426.03 96.059-0.089844 31.41 21.266-3.4414z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426.03 96.059-0.089844 31.41 21.266-3.4414z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ef"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410.28 112.98 27.109 25.102 25.477-27.527-27.117-25.102z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 0.39141,
    x2: 0.63203,
    gradientTransform: "matrix(105.86 -114.37 114.36 105.87 381.57 169.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9ffff",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9ffff",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8ffff",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8ffff",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d7ffff",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6ffff",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6ffff",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5ffff",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5ffff",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4ffff",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3ffff",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3feff",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2feff",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2feff",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1fdff",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1fdff",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0fdff",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0fdff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cffcff",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cffcff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cefbff",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cefbff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cdfbff",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cdfbff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccfaff",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccfaff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbf9ff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbf9ff",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbf9ff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#caf8ff",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#caf8ff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9f8ff",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9f8ff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m411 86.43h47v60.449h-47z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m434.4 90.105c-12.695-7.332-23.066-1.4219-23.109 13.176-0.039062 14.605 10.266 32.453 22.961 39.785 12.711 7.3359 23.074 1.4258 23.117-13.176 0.042968-14.602-10.258-32.453-22.969-39.785zm-0.14063 50.668c-11.605-6.6992-21.02-23.004-20.977-36.34 0.035156-13.34 9.5078-18.75 21.113-12.047 11.617 6.7031 21.031 23.023 20.988 36.355-0.035156 13.336-9.5078 18.738-21.125 12.031z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m434.4 90.105c-12.695-7.332-23.066-1.4219-23.109 13.176-0.039062 14.605 10.266 32.453 22.961 39.785 12.711 7.3359 23.074 1.4258 23.117-13.176 0.042968-14.602-10.258-32.453-22.969-39.785zm-0.14063 50.668c-11.605-6.6992-21.02-23.004-20.977-36.34 0.035156-13.34 9.5078-18.75 21.113-12.047 11.617 6.7031 21.031 23.023 20.988 36.355-0.035156 13.336-9.5078 18.738-21.125 12.031"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m377.54 119.2 58.57 54.215 55.008-59.434-58.566-54.223z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.23592,
    x2: 0.72179,
    gradientTransform: "matrix(105.86 -114.37 114.36 105.87 383.58 171.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ffff",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0ffff",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfffff",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#deffff",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dff",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcffff",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbffff",
    offset: 0.29688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbffff",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daffff",
    offset: 0.32812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9ffff",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8ffff",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d7ffff",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6ffff",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6ffff",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5ffff",
    offset: 0.42188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5ffff",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4ffff",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3ffff",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2feff",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2feff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1fdff",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d1fdff",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0fdff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d0fcff",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cffcff",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cffbff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cefbff",
    offset: 0.64062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cdfaff",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccfaff",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccfaff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cbf9ff",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#caf9ff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#caf8ff",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c9f8ff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c8f7ff",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c7f6ff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c6f6ff",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c5f5ff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c4f4ff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m478 288h49v52h-49z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "im"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m504.59 289.42c-2.2109-1.2773-4.2617-1.543-6.0156-0.80469-2.2227 0.93359-3.1211 3.0703-3.6758 5.2109-0.51172 2.0195-0.96094 4.0977-2.4453 4.9297-1.5859 0.90625-3.6055 0.24219-5.625-0.32422-2.1406-0.625-4.4492-0.91406-6.3906 0.52734-1.9883 1.4805-2.7578 4.2852-2.1016 8.1328 0.1875 1.0938 0.5 2.207 0.875 3.332l6.1133 19.309c1.3594 3.7656 4.0078 7.0195 6.7578 8.6133 1.0742 0.61719 2.168 0.98438 3.207 1.0391 3.4648 0.15234 5.2305-3.3008 4.1484-8.1172l-0.76562-3.4141c-0.32422-1.2461-0.089843-2.3203 0.64844-2.6328 0.085937-0.039062 3.1211-1.7695 6.2852-3.5586 3.1523-1.8008 6.1797-3.5469 6.2578-3.6016 0.46094-0.32812 1.1094-0.25781 1.7773 0.125 0.28906 0.16406 0.57812 0.39062 0.84766 0.66797l2.582 2.3672c0.72656 0.67188 1.4609 1.2148 2.1875 1.6328 2.9102 1.6836 5.668 1.3477 6.9531-1.0859 1.7188-3.2617 0.25-9.168-3.3516-13.418l-13.688-14.992c-0.79688-0.89453-1.6133-1.7383-2.4609-2.4414-0.72266-0.60156-1.4297-1.0977-2.1211-1.4961zm4.6328 15.488c-0.78516-0.45312-1.5625-1.25-2.1602-2.2852-1.1953-2.0547-1.1914-4.2891 0.011719-4.9648 0.60547-0.33984 1.3906-0.23438 2.168 0.21875 0.78516 0.45703 1.5703 1.2461 2.168 2.2812 1.1797 2.0508 1.1719 4.2891-0.019531 4.9688-0.59766 0.34375-1.3828 0.23047-2.168-0.21875zm-8.0977-4.6758c-0.77734-0.45312-1.5625-1.25-2.1602-2.2852-1.1914-2.0547-1.1875-4.2891 0.011719-4.9648 0.60156-0.33984 1.3867-0.23438 2.1719 0.21875 0.78125 0.44922 1.5664 1.2461 2.1602 2.2852 1.1953 2.0547 1.1875 4.293-0.011719 4.9648-0.60156 0.34375-1.3867 0.23047-2.1719-0.21875zm8.0703 13.98c-0.78125-0.45703-1.5664-1.2539-2.1602-2.2852-1.1914-2.0664-1.1875-4.293 0.015626-4.9766 0.59766-0.33594 1.3828-0.22266 2.168 0.23047 0.78516 0.44922 1.5625 1.2461 2.1602 2.2734 1.1875 2.0586 1.1797 4.2852-0.011718 4.9766-0.60156 0.33984-1.3867 0.23438-2.1719-0.21875zm-8.0938-4.6758c-0.78516-0.44922-1.5625-1.25-2.1641-2.2852-1.1953-2.0664-1.1875-4.293 0.015625-4.9766 0.60156-0.33594 1.3828-0.22266 2.168 0.23047 0.78516 0.44922 1.5625 1.2461 2.1641 2.2734 1.1953 2.0664 1.1875 4.293-0.015624 4.9766-0.60156 0.33984-1.3867 0.23438-2.168-0.21875zm-11.863 0.16406 2.9102-1.6562c0.37109-0.20703 0.85547-0.14453 1.3398 0.13281 0.48828 0.28516 0.97266 0.77344 1.3438 1.418 0.73828 1.2812 0.73437 2.6562-0.011719 3.0938l-2.9102 1.6484 2.8945 5c0.73828 1.2852 0.73047 2.6602-0.007813 3.0898-0.375 0.21484-0.85938 0.14453-1.3438-0.13281-0.49219-0.28516-0.96875-0.77344-1.3398-1.4102l-2.8945-5.0156-2.9023 1.668c-0.37109 0.20703-0.86328 0.14063-1.3477-0.14453-0.48438-0.27734-0.96484-0.76562-1.332-1.4023-0.75-1.293-0.74609-2.668 0.003906-3.0938l2.9062-1.6602-2.8867-4.9922c-0.74609-1.293-0.73828-2.668 0.011719-3.0938 0.37109-0.21484 0.85547-0.14844 1.3398 0.13672 0.48438 0.27734 0.96875 0.76953 1.3398 1.4102z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m504.59 289.42c-2.2109-1.2773-4.2617-1.543-6.0156-0.80469-2.2227 0.93359-3.1211 3.0703-3.6758 5.2109-0.51172 2.0195-0.96094 4.0977-2.4453 4.9297-1.5859 0.90625-3.6055 0.24219-5.625-0.32422-2.1406-0.625-4.4492-0.91406-6.3906 0.52734-1.9883 1.4805-2.7578 4.2852-2.1016 8.1328 0.1875 1.0938 0.5 2.207 0.875 3.332l6.1133 19.309c1.3594 3.7656 4.0078 7.0195 6.7578 8.6133 1.0742 0.61719 2.168 0.98438 3.207 1.0391 3.4648 0.15234 5.2305-3.3008 4.1484-8.1172l-0.76562-3.4141c-0.32422-1.2461-0.089843-2.3203 0.64844-2.6328 0.085937-0.039062 3.1211-1.7695 6.2852-3.5586 3.1523-1.8008 6.1797-3.5469 6.2578-3.6016 0.46094-0.32812 1.1094-0.25781 1.7773 0.125 0.28906 0.16406 0.57812 0.39062 0.84766 0.66797l2.582 2.3672c0.72656 0.67188 1.4609 1.2148 2.1875 1.6328 2.9102 1.6836 5.668 1.3477 6.9531-1.0859 1.7188-3.2617 0.25-9.168-3.3516-13.418l-13.688-14.992c-0.79688-0.89453-1.6133-1.7383-2.4609-2.4414-0.72266-0.60156-1.4297-1.0977-2.1211-1.4961zm4.6328 15.488c-0.78516-0.45312-1.5625-1.25-2.1602-2.2852-1.1953-2.0547-1.1914-4.2891 0.011719-4.9648 0.60547-0.33984 1.3906-0.23438 2.168 0.21875 0.78516 0.45703 1.5703 1.2461 2.168 2.2812 1.1797 2.0508 1.1719 4.2891-0.019531 4.9688-0.59766 0.34375-1.3828 0.23047-2.168-0.21875zm-8.0977-4.6758c-0.77734-0.45312-1.5625-1.25-2.1602-2.2852-1.1914-2.0547-1.1875-4.2891 0.011719-4.9648 0.60156-0.33984 1.3867-0.23438 2.1719 0.21875 0.78125 0.44922 1.5664 1.2461 2.1602 2.2852 1.1953 2.0547 1.1875 4.293-0.011719 4.9648-0.60156 0.34375-1.3867 0.23047-2.1719-0.21875zm8.0703 13.98c-0.78125-0.45703-1.5664-1.2539-2.1602-2.2852-1.1914-2.0664-1.1875-4.293 0.015626-4.9766 0.59766-0.33594 1.3828-0.22266 2.168 0.23047 0.78516 0.44922 1.5625 1.2461 2.1602 2.2734 1.1875 2.0586 1.1797 4.2852-0.011718 4.9766-0.60156 0.33984-1.3867 0.23438-2.1719-0.21875zm-8.0938-4.6758c-0.78516-0.44922-1.5625-1.25-2.1641-2.2852-1.1953-2.0664-1.1875-4.293 0.015625-4.9766 0.60156-0.33594 1.3828-0.22266 2.168 0.23047 0.78516 0.44922 1.5625 1.2461 2.1641 2.2734 1.1953 2.0664 1.1875 4.293-0.015624 4.9766-0.60156 0.33984-1.3867 0.23438-2.168-0.21875zm-11.863 0.16406 2.9102-1.6562c0.37109-0.20703 0.85547-0.14453 1.3398 0.13281 0.48828 0.28516 0.97266 0.77344 1.3438 1.418 0.73828 1.2812 0.73437 2.6562-0.011719 3.0938l-2.9102 1.6484 2.8945 5c0.73828 1.2852 0.73047 2.6602-0.007813 3.0898-0.375 0.21484-0.85938 0.14453-1.3438-0.13281-0.49219-0.28516-0.96875-0.77344-1.3398-1.4102l-2.8945-5.0156-2.9023 1.668c-0.37109 0.20703-0.86328 0.14063-1.3477-0.14453-0.48438-0.27734-0.96484-0.76562-1.332-1.4023-0.75-1.293-0.74609-2.668 0.003906-3.0938l2.9062-1.6602-2.8867-4.9922c-0.74609-1.293-0.73828-2.668 0.011719-3.0938 0.37109-0.21484 0.85547-0.14844 1.3398 0.13672 0.48438 0.27734 0.96875 0.76953 1.3398 1.4102l2.8867 5.0039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m453.55 322.92 58.211 40.094 40.301-58.512-58.215-40.098z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.10694,
    x2: 0.47367,
    gradientTransform: "matrix(109.89 -159.56 159.54 109.9 469.6 359.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f8ffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7ffff",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7ffff",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6ffff",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f6ffff",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5ffff",
    offset: 0.070312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f5ffff",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4ffff",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4ffff",
    offset: 0.10938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3ffff",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f3ffff",
    offset: 0.14062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2ffff",
    offset: 0.14844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f2ffff",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f1ffff",
    offset: 0.17188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0ffff",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0ffff",
    offset: 0.19531
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f0ffff",
    offset: 0.20312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#efffff",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#efffff",
    offset: 0.22656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#efffff",
    offset: 0.23438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eff",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edffff",
    offset: 0.26562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edffff",
    offset: 0.27344
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#edffff",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ecffff",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ebffff",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.35156
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.35938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eaffff",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e9ffff",
    offset: 0.39062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.39844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ffff",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e7ffff",
    offset: 0.45312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e6ffff",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.47656
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e5ffff",
    offset: 0.48438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e4ffff",
    offset: 0.51562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e3ffff",
    offset: 0.54688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2ffff",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.57812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e1ffff",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0ffff",
    offset: 0.60938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0ffff",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dfffff",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#deffff",
    offset: 0.67188
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#deffff",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dff",
    offset: 0.70312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcffff",
    offset: 0.71094
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcffff",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dcffff",
    offset: 0.73438
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbffff",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#dbffff",
    offset: 0.76562
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#daffff",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9ffff",
    offset: 0.79688
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d9ffff",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8ffff",
    offset: 0.82812
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d8ffff",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d7ffff",
    offset: 0.85938
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6ffff",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d6ffff",
    offset: 0.89062
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5ffff",
    offset: 0.89844
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5ffff",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d4ffff",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3ffff",
    offset: 0.95312
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d3ffff",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d2ffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m304 319.16h309v290.16h-309z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m364.82 608.09-49.09-28.34c-2.1484-1.2422-2.4648-3.1172-1.0508-4.5742-1.4414-1.4531-1.0977-3.3594 1.0195-4.582l39.223-22.801c-5.8203-1.4102-10.949-3.4102-15.059-5.8438l-35.699 20.746v-60.633l28.641 16.535c2.4258-2.8047 5.9609-5.332 10.355-7.4258l-28.848-16.648c-2.1367-1.2539-2.4922-3.1289-1.0469-4.5859-1.457-1.4414-1.1133-3.3477 1.0039-4.5703l26.742-15.543c-0.097656-0.15234-0.19141-0.3125-0.28906-0.46875-6.3125 1.7734-13.613 2.7773-21.395 2.7773-2.3672 0-4.6719-0.09375-6.9453-0.27344l-8.2188 4.7773v-65.711c12.102 3.7734 20.129 10.406 20.129 17.969 0 0.125 0 0.24219-0.011718 0.36719l0.96094 0.5625c4.6172 0.29297 8.9805 0.96094 13.004 1.9297v-7.8242l-25.363-14.633c-2.1484-1.25-2.4883-3.1289-1.0625-4.5703-1.4375-1.457-1.0977-3.3594 1.0234-4.5859l48.785-28.359c2.543-1.4805 6.7188-1.4805 9.2852 0l49.098 28.359c2.1484 1.2383 2.5039 3.1406 1.0469 4.5977 1.4258 1.4414 1.0859 3.3203-1.0234 4.5586l-11.977 6.9609c1.9531 2.7383 3.2773 6.3672 3.2773 9.6562v3.0352l24.562-14.27c2.5547-1.4922 6.7266-1.4922 9.3008 0l49.082 28.332c2.1602 1.25 2.5156 3.1562 1.043 4.6172 1.4297 1.4492 1.1055 3.3164-1.0195 4.5508l-17.324 10.062c2.1484 2.6289 3.3359 5.4844 3.3359 8.4805 0 1.6406-0.35547 3.2461-1.0352 4.7969l30.895-17.953c2.5469-1.4805 6.7188-1.4805 9.2812-0.015625l49.094 28.359c2.1484 1.2383 2.5117 3.1406 1.0586 4.5977 1.4141 1.4609 1.0898 3.3203-1.0195 4.5586l-48.785 28.359c-2.5391 1.4688-6.7305 1.4688-9.2852-0.019531l-49.098-28.34c-2.1484-1.2383-2.4766-3.1289-1.0469-4.5703-0.28125-0.28906-0.48828-0.58203-0.63672-0.88281-7.3203 2.3906-16.121 3.793-25.582 3.793-3.7852 0-7.4688-0.21875-10.992-0.65625-0.26953 0.65625-0.82422 1.2656-1.6992 1.7734l-22.902 13.312c5.5898 1.6055 10.43 3.7695 14.203 6.3398l24.559-14.281c2.5469-1.4688 6.7305-1.4805 9.2852 0l49.102 28.344c2.1484 1.25 2.5 3.168 1.043 4.6094 1.418 1.457 1.0938 3.3359-1.0195 4.5586l-48.77 28.348c-2.543 1.4805-6.7305 1.4688-9.2852 0l-34.82-20.109c-4.8633 1.7852-10.473 3.1055-16.562 3.8281l36.555 21.109c2.1484 1.25 2.5195 3.1523 1.0625 4.6211 1.3984 1.4414 1.0859 3.3047-1.0195 4.5469l-48.781 28.34c-1.2695 0.73828-2.9531 1.1172-4.6406 1.1172s-3.3711-0.37891-4.6523-1.1172m77.199-45.02c-1.582-0.039062-3.1484-0.40625-4.3398-1.1016 1.1914 0.69531 2.7578 1.0625 4.3398 1.1016m72.84-42.324c-1.5781-0.054688-3.1406-0.42578-4.3398-1.1172 1.1992 0.69141 2.7617 1.0625 4.3398 1.1172m53.73-29.465c0.066406-0.039063 0.13672-0.074219 0.19922-0.11719-0.0625 0.042969-0.13281 0.078125-0.19922 0.11719m-74.285-42.883c0.070313-0.039062 0.14062-0.082031 0.20703-0.12109-0.066406 0.039062-0.13672 0.082031-0.20703 0.12109m89.066 32.672-49.105-28.344c-2.125-1.2383-2.4805-3.1172-1.0508-4.5547-1.4414-1.4609-1.1172-3.3594 1.0312-4.6016l48.77-28.348c2.5625-1.4805 6.7227-1.4805 9.2812-0.011719l20.547 11.871v42.262l-20.184 11.727c-1.2812 0.75-2.9492 1.1133-4.6367 1.1133-1.6836 0-3.3711-0.36328-4.6523-1.1133m-74.281-42.883-49.082-28.336c-2.1641-1.25-2.4883-3.1289-1.0625-4.582-1.4375-1.457-1.1016-3.3477 1.0352-4.5859l3.3984-1.9727v-0.29297c0-11.348 16.949-20.746 39.078-22.414l6.25-3.6484c-4.6094-3.5273-7.2734-7.7227-7.2734-12.227 0-12.527 20.66-22.688 46.145-22.688s46.145 10.16 46.145 22.688c0 12.539-20.66 22.688-46.145 22.688-1.6172 0-3.1953-0.042969-4.7695-0.125 5.7344 2.9375 9.8867 6.6406 11.762 10.742l12.551 7.25c2.1602 1.2383 2.5156 3.1484 1.0625 4.5977 1.4102 1.4609 1.0859 3.3203-1.0352 4.5703l-48.766 28.336c-1.2812 0.73047-2.9531 1.1094-4.6406 1.1094s-3.3711-0.37891-4.6523-1.1094m-74.254-42.875-49.113-28.359c-2.1289-1.2344-2.4727-3.1133-1.043-4.5703-1.1172-1.0977-1.1875-2.4727-0.19141-3.6172-8.7578-4.1211-14.199-9.9258-14.199-16.359 0-12.527 20.66-22.688 46.145-22.688 23.98 0 43.699 8.9922 45.941 20.484l30.488 17.598c2.1484 1.2539 2.5039 3.1406 1.0352 4.6016 1.4258 1.4492 1.1016 3.3164-1.0156 4.5508l-48.773 28.348c-1.2773 0.75-2.9648 1.1133-4.6523 1.1133-1.6719 0-3.3438-0.36328-4.6211-1.1016m4.9336-2.6797h-0.3125 0.3125m-0.3125 0c-1.6719 0-3.3438-0.36719-4.6211-1.0977 1.2773 0.73047 2.9492 1.0977 4.6211 1.0977m53.426-29.457c0.0625-0.042969 0.13281-0.085937 0.19922-0.125-0.066406 0.039063-0.13672 0.082031-0.19922 0.125"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m252 407h52.473v160h-52.473z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ir"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m290.55 565.21-37.82-21.84v-22.242l37.477-21.777c2.543-1.4883 6.707-1.4883 9.2812 0.011719l4.6719 2.6992v60.633l-4.3203 2.5156c-1.2734 0.73047-2.9609 1.1016-4.6523 1.1016-1.6797 0-3.3633-0.36719-4.6367-1.1016m4.9648-2.6836h-0.32812 0.32812m-0.32812 0c-1.6875 0-3.3555-0.37109-4.6367-1.1016 1.2812 0.73047 2.9492 1.1016 4.6367 1.1016m-6.0547-82.543-36.402-21.023v-46.129c7.5859-3.2344 17.48-5.1953 28.309-5.1953 8.5078 0 16.434 1.207 23.121 3.2891v65.711l-5.7461 3.3477c-1.2773 0.73828-2.9531 1.1094-4.6367 1.1094-1.6797 0-3.3633-0.37109-4.6445-1.1094"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m612.74 427h31.262v43h-31.262z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m612.84 427.08 28.543 16.488c2.1484 1.2422 2.5156 3.1523 1.0625 4.6133 1.418 1.4375 1.0859 3.3164-1.0195 4.5547l-28.586 16.605v-42.262"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m237 412h16v47h-16z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m240.04 451.63c-2.1484-1.2539-2.4883-3.1289-1.0625-4.582-1.4375-1.457-1.0977-3.3477 1.0234-4.5703l4.2148-2.4492c-4.0703-3.2344-6.4062-7.0586-6.4062-11.141 0-6.4141 5.7773-12.164 14.922-16.062v46.129l-12.691-7.3242"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ax"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m239.5 521h13.504v23h-13.504z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m241.46 536.86c-2.1367-1.2422-2.4805-3.1289-1.0625-4.5703-1.4414-1.457-1.0938-3.3594 1.0312-4.5977l11.305-6.5664v22.242l-11.273-6.5078"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ht)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m294.8 809.76c-9.4219 0-18.418-1.9023-25.137-5.7812l-212.07-122.45c-7.4141-4.2852-10.652-10.168-9.9023-16.211 0.75-6.0469 5.4922-12.258 14.059-17.203l58.504-33.777 1.2266 0.71484-55.859 32.254c-8.4688 4.8867-13.16 11.027-13.906 17.008-0.74219 5.9805 2.4688 11.793 9.8008 16.027l209.7 121.08c6.6445 3.8359 15.535 5.7148 24.852 5.7148 11.242 0 23.102-2.7383 32.363-8.0859l415.98-240.18c16.93-9.7812 18.77-24.57 4.1094-33.039l-61.223-35.352 2.3945-1.3789 62.652 36.172c14.828 8.5664 12.969 23.52-4.1562 33.41l-420.66 242.89c-9.3672 5.4102-21.355 8.1797-32.723 8.1797",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fz)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fp)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m831.89 789.53-111.97-461.41-741.51 179.98 111.98 461.41z",
    fill: "url(#dm)"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gr)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ey)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m826.44 787.13-110.57-455.64-732.38 177.77 110.57 455.64z",
    fill: "url(#gn)"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ay)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fk)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m822.5 784.75-109.24-450.14-724.33 175.81 109.24 450.14z",
    fill: "url(#hs)"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ec)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fs)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hc)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m817.05 782.35-107.88-444.54-715.91 173.77 107.88 444.54z",
    fill: "url(#iu)"
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#he)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gw)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bn)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ft)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m811.6 779.96-106.48-438.78-706.79 171.56 106.48 438.78z",
    fill: "url(#ib)"
  })))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ds)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cz)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#em)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m807.66 777.57-105.18-433.41-699.32 169.75 105.18 433.41z",
    fill: "url(#ae)"
  })))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bv)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m802.21 775.18-103.79-427.68-690.31 167.55 103.79 427.68z",
    fill: "url(#dw)"
  })))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fn)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fh)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bk)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hz)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m798.27 772.78-102.47-422.25-682.64 165.7 102.47 422.25z",
    fill: "url(#hw)"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m792.82 770.39-101.09-416.54-673.72 163.53 101.09 416.54z",
    fill: "url(#ex)"
  })))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m787.38 768-99.691-410.8-664.71 161.34 99.691 410.8z",
    fill: "url(#ag)"
  })))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fv)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#du)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m783.44 765.61-98.379-405.39-657.06 159.48 98.379 405.39z",
    fill: "url(#aq)"
  })))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#in)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#is)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ck)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m777.99 763.21-96.992-399.67-648.12 157.32 96.988 399.67z",
    fill: "url(#bz)"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ho)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m774.05 760.82-95.684-394.27-640.54 155.48 95.68 394.27z",
    fill: "url(#cf)"
  })))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#z)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dv)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#an)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#as)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m768.6 758.43-94.285-388.52-631.48 153.27 94.285 388.52z",
    fill: "url(#it)"
  })))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ci)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dk)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cs)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gi)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m763.15 756.03-92.898-382.8-622.53 151.11 92.895 382.8z",
    fill: "url(#ii)"
  })))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ev)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#il)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m759.21 753.64-91.586-377.41-614.95 149.27 91.586 377.4z",
    fill: "url(#am)"
  })))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hi)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bu)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m753.76 751.25-90.191-371.66-605.9 147.07 90.195 371.66z",
    fill: "url(#ah)"
  })))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hn)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ip)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#av)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m749.82 748.86-88.887-366.27-598.36 145.23 88.887 366.27z",
    fill: "url(#fu)"
  })))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m744.38 746.46-87.492-360.53-589.35 143.05 87.492 360.53z",
    fill: "url(#d)"
  })))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bs)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m738.93 744.07-86.098-354.79-580.32 140.86 86.098 354.79z",
    fill: "url(#hy)"
  })))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ez)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dy)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#br)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m734.99 741.68-84.793-349.4-572.76 139.02 84.793 349.4z",
    fill: "url(#ek)"
  })))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hp)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#df)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m47.586 293.66v412.73h714.75v-412.73z",
    fill: "url(#ew)"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m752.34 389.16-212.07-122.45c-14.828-8.5625-40.734-7.4883-57.859 2.3984l-420.66 242.89c-8.5664 4.9492-13.309 11.156-14.059 17.203-0.75 6.043 2.4883 11.93 9.9023 16.211l212.07 122.45c14.836 8.5664 40.738 7.4922 57.859-2.3945l420.66-242.89c17.125-9.8867 18.984-24.848 4.1562-33.41",
    fill: "#f7f8fc"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gk)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dn)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.891 299.68 72.793 442.69 653.37-107.46-72.797-442.69z",
    fill: "url(#fc)"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m275.34 489.4c-0.27734 0.27734-0.59375 0.54688-1.0039 0.77734l-48.777 28.355c-2.5391 1.4727-6.7266 1.4805-9.2812 0.011719l-49.098-28.355c-0.42578-0.24219-0.75781-0.52344-1.0391-0.80859-1.4414 1.4453-1.1172 3.3477 1.0391 4.5938l49.098 28.348c2.5547 1.4766 6.7422 1.4688 9.2812-0.007813l48.777-28.352c2.1211-1.2344 2.4375-3.1133 1.0039-4.5625",
    fill: "#54dbde"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m649.53 358.06-55.398-31.984c-1.6953-0.97656-4.4375-0.97656-6.1328 0s-1.6953 2.5625 0 3.543l55.398 31.984c1.6914 0.98047 4.4375 0.98047 6.1328 0 1.6914-0.98047 1.6914-2.5625 0-3.543",
    fill: "#b6c2dc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m214.8 613.36c4.457 2.5781 12.309 2.2305 17.496-0.76953 2.5508-1.4688 4.0156-3.3477 4.0156-5.1406 0-1.4297-0.92578-2.7227-2.6797-3.7305l-63.875-36.883c-4.4609-2.582-12.312-2.2344-17.5 0.77344-2.5508 1.4688-4.0156 3.3398-4.0156 5.1328 0 1.4375 0.92578 2.7227 2.6797 3.7383zm7.5508 3.8594c-3.2031 0-6.2734-0.66797-8.6133-2.0195l-63.879-36.875c-2.4141-1.3945-3.7422-3.3789-3.7422-5.582 0-2.5703 1.8555-5.1172 5.0781-6.9805 5.7773-3.3359 14.578-3.6836 19.625-0.76953l63.875 36.879c2.4141 1.3984 3.7422 3.375 3.7422 5.5781 0 2.5742-1.8477 5.125-5.0781 6.9883-3.1914 1.8359-7.1953 2.7812-11.008 2.7812",
    fill: "#b6c2dc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m344.96 655.4v32.746l4.1562-2.3984v-32.75l-4.1562 2.4023",
    fill: "#90a2ca"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m209.19 645.94c-1.9766-1.1445-3.5781-0.21875-3.5781 2.0625 0 2.2852 1.6016 5.0508 3.5781 6.1914 1.9688 1.1445 3.5703 0.21875 3.5703-2.0586 0-2.2852-1.6016-5.0547-3.5703-6.1953",
    fill: "#7386a5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m221.39 652.96c-1.9688-1.1406-3.5703-0.21484-3.5703 2.0664 0 2.2773 1.6016 5.0508 3.5703 6.1914 1.9766 1.1406 3.5781 0.21875 3.5781-2.0664 0-2.2773-1.6016-5.0469-3.5781-6.1914",
    fill: "#7386a5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m233.59 660c-1.9766-1.1406-3.5781-0.21875-3.5781 2.0664 0 2.2773 1.6016 5.0469 3.5781 6.1914 1.9727 1.1406 3.5781 0.21094 3.5781-2.0664s-1.6055-5.0547-3.5781-6.1914",
    fill: "#7386a5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m245.8 667.03c-1.9727-1.1484-3.5742-0.21875-3.5742 2.0586 0 2.2773 1.6016 5.0547 3.5742 6.1914 1.9766 1.1406 3.5742 0.21875 3.5742-2.0586 0-2.2852-1.5977-5.0547-3.5742-6.1914",
    fill: "#7386a5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m258 674.05c-1.9805-1.1406-3.5781-0.21094-3.5781 2.0664 0 2.2773 1.5977 5.0508 3.5781 6.1914 1.9688 1.1406 3.5742 0.21875 3.5742-2.0664 0-2.2773-1.6055-5.0508-3.5742-6.1914",
    fill: "#7386a5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m71.375 566.11c-1.9727-1.1406-3.5703-0.21484-3.5703 2.0664 0 2.2773 1.5977 5.0508 3.5703 6.1914 1.9766 1.1406 3.5781 0.21875 3.5781-2.0664 0-2.2773-1.6016-5.0547-3.5781-6.1914",
    fill: "#7386a5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m83.582 573.14c-1.9766-1.1406-3.5781-0.21875-3.5781 2.0664 0 2.2773 1.6016 5.0508 3.5781 6.1914 1.9727 1.1406 3.5781 0.21094 3.5781-2.0664 0-2.2773-1.6055-5.0547-3.5781-6.1914",
    fill: "#7386a5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m95.785 580.17c-1.9727-1.1484-3.5742-0.21875-3.5742 2.0586 0 2.2852 1.6016 5.0547 3.5742 6.1914 1.9766 1.1406 3.5742 0.21875 3.5742-2.0586 0-2.2852-1.5977-5.0547-3.5742-6.1914",
    fill: "#7386a5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m107.99 587.2c-1.9766-1.1406-3.5742-0.21094-3.5742 2.0664 0 2.2773 1.5977 5.0547 3.5742 6.1914 1.9805 1.1406 3.5781 0.21875 3.5781-2.0664 0-2.2773-1.5977-5.0508-3.5781-6.1914",
    fill: "#7386a5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m120.2 594.23c-1.9766-1.1406-3.5742-0.21875-3.5742 2.0664 0 2.2773 1.5977 5.0469 3.5742 6.1914 1.9727 1.1406 3.5742 0.21094 3.5742-2.0664 0-2.2773-1.6016-5.0508-3.5742-6.1914",
    fill: "#7386a5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m181.17 636.29-34.648-20.012c-1.168-0.67188-2.125-2.4961-2.125-4.0547 0-1.5586 0.95703-2.2852 2.125-1.6055l34.648 20.004c1.168 0.67969 2.125 2.5039 2.125 4.0625s-0.95703 2.2773-2.125 1.6055",
    fill: "#7386a5"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fj)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0894 0 0 1.09 162.87 453.99)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 106,
    height: 62,
    xlinkHref: "data:image/png;base64,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"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#di)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.12 489.38v30.262h109.23v-30.262z",
    fill: "url(#gt)"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cv)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bh)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ei)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ha)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m497.33 334.36-90.445-17.477-24.641 127.57 90.445 17.473z",
    fill: "url(#ia)"
  })))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hx)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gm)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m519.26 377.72-94.551-71.285-77.422 102.71 94.555 71.285z",
    fill: "url(#dz)"
  })))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#et)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#by)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m583.72 4.5938-90.383-17.465-24.59 127.3 90.387 17.465z",
    fill: "url(#cb)"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dx)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#do)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ge)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#co)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m605.32 47.406-94.168-70.996-77.031 102.2 94.168 70.992z",
    fill: "url(#id)"
  })))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ig)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cm)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#io)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m609.6 190.44-90.434-17.473-24.641 127.55 90.438 17.473z",
    fill: "url(#ie)"
  })))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#go)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#er)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fi)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m631.04 233.42-94.066-70.918-76.93 102.06 94.066 70.922z",
    fill: "url(#fo)"
  })))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fw)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m492.01 250.12 49.148 51.812 51.473-48.836-49.148-51.812z",
    fill: "url(#n)"
  })))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bx)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cj)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hv)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dj)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m386.16 89.812-90.438-17.473-24.645 127.57 90.441 17.473z",
    fill: "url(#y)"
  })))))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ep)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ap)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bo)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#if)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m408.02 133.12-94.488-71.238-77.352 102.62 94.484 71.238z",
    fill: "url(#ga)"
  })))))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m440.18 212.86-48.617-28.078c-1.7539-1.0078-3.3516-1.0508-4.5625-0.29297l-10.906 6.3047 6.8047 3.9297v60.965c0 5.0156 3.0508 10.848 6.8164 13.023l43.969 25.387v8.2656l10.562-6.1016c1.6641-0.69141 2.7422-2.7188 2.7422-5.7031v-64.684c0-5.0195-3.0508-10.844-6.8086-13.016",
    fill: "#fff"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ar)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#al)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bi)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m489.86 227.87-95.289-67.195-74.379 105.5 95.285 67.195z",
    fill: "url(#ej)"
  })))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m536.36 280.68-48.613-28.062c-1.7617-1.0156-3.3594-1.0586-4.5664-0.30078l-10.914 6.3086 6.8125 3.9258v60.973c0 5.0117 3.0547 10.844 6.8125 13.016l43.969 25.391v8.2617l10.566-6.1016c1.6641-0.69141 2.7461-2.7148 2.7461-5.7031v-64.684c0-5.0156-3.0508-10.844-6.8125-13.023",
    fill: "#ebfbfb"
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#el)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fr)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bw)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m575.58 277.66-94.676-43.434-54.074 117.9 94.676 43.434z",
    fill: "url(#fb)"
  })))))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m309.31 292.14-48.613-28.062c-1.7617-1.0156-3.3594-1.0586-4.5625-0.30078l-10.914 6.3047 6.8086 3.9297v60.965c0 5.0156 3.0547 10.852 6.8125 13.023l43.969 25.391v8.2578l10.566-6.0977c1.6641-0.69141 2.7461-2.7148 2.7461-5.7031v-64.684c0-5.0156-3.0508-10.844-6.8125-13.023",
    fill: "#ebfbfb"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dt)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m224.4 272.44 20.359 120.43 79.141-13.383-20.359-120.43z",
    fill: "url(#gq)"
  })))))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m273.71 300.54-1.9141-1.1016c-2.8086-1.625-5.4883-1.8672-7.5508-0.6875-2.043 1.1836-3.1758 3.5977-3.1797 6.8086l-0.023437 7.6953 0.10938 0.44531 2.9414 1.6953 0.023438-8.8164c0.011718-2.1953 0.72656-3.8125 2.0195-4.5547 1.3047-0.75 3.082-0.55469 5.0039 0.55859l1.9141 1.1055c4.2148 2.4297 7.6328 8.3516 7.6211 13.191l-0.023437 8.0703 3.0391 1.7773 0.027344-8.8359c0.019531-6.3711-4.4727-14.156-10.008-17.352",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m269.25 339.85 1.9648-4.918c-0.94141-1.0508-1.6094-2.5273-1.6094-3.8047 0.003907-1.7383 1.2344-2.4453 2.75-1.5664 1.5039 0.86719 2.7344 2.9922 2.7266 4.7305-0.003906 1.2812-0.67969 1.9805-1.6406 1.9219l1.9375 7.1719zm14.609-10.105-22.98-13.27c-0.91797-0.53906-1.6758-0.12109-1.6797 0.94141l-0.058593 21.141c0 1.0586 0.75 2.3516 1.668 2.8828l22.98 13.262c0.92578 0.53906 1.6719 0.11328 1.6719-0.94922l0.0625-21.133c0-1.0625-0.73828-2.3438-1.6641-2.875",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m469.73 82.055-48.613-28.07c-1.7539-1.0078-3.3555-1.0508-4.5625-0.29688l-10.91 6.3047 6.8047 3.9336v60.965c0 5.0156 3.0547 10.848 6.8203 13.02l43.969 25.391v8.2656l10.559-6.1055c1.6719-0.6875 2.7461-2.7188 2.7461-5.6992v-64.684c0-5.0195-3.0469-10.844-6.8125-13.023",
    fill: "#fff"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ij)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ch)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m521.85 108.32-91.434-79.941-83.117 95.09 91.438 79.941z",
    fill: "url(#o)"
  })))))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#en)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ih)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m376.71 240.58-90.441-17.477-24.641 127.57 90.438 17.473z",
    fill: "url(#bp)"
  })))))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#x)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ik)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hm)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m398.02 283.47-93.934-70.82-76.801 101.89 93.934 70.82z",
    fill: "url(#fx)"
  })))))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m636.66 118.66-48.609-28.07c-1.7578-1.0156-3.3594-1.0508-4.5625-0.29688l-10.914 6.3047 6.8125 3.9336v60.961c0 5.0195 3.0469 10.852 6.8125 13.023l43.969 25.391v8.2578l10.566-6.0977c1.6641-0.69531 2.7422-2.7227 2.7422-5.7031v-64.68c0-5.0195-3.0508-10.852-6.8164-13.023",
    fill: "#fff"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bm)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cp)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cr)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m686.96 136.76-94.016-70.883-76.887 102 94.016 70.883z",
    fill: "url(#cw)"
  })))))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m432.67 370.85c-13.785-7.9648-25.027-1.5547-25.074 14.285 0 1.332 0.085938 2.7695 0.24219 4.2266l3.2695 1.3633c-0.14062-1.2812-0.21094-2.5195-0.21094-3.6836 0.042969-13.742 9.8047-19.309 21.762-12.402 11.961 6.9062 21.648 23.703 21.613 37.445-0.007812 1.1641-0.085937 2.3125-0.23828 3.4219l3.2695 2.4141c0.17969-1.2617 0.27344-2.5898 0.27734-3.9258 0.042969-15.844-11.137-35.195-24.91-43.145",
    fill: "#f7f8fc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m445.33 392.29-14.145 3.1992c-0.30078 0.015624-0.58203 0.058593-0.83594 0.20703-1.2344 0.69922-1.2422 3.0078-0.011718 5.1523 0.61328 1.0664 1.4219 1.8867 2.2305 2.3555 0.8125 0.47266 1.6289 0.58203 2.2539 0.23438 0.23438-0.15234 0.42969-0.36328 0.58594-0.61719l9.9219-10.531",
    fill: "#f7f8fc"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m304.76 284.94c-1.0664-0.62109-2.1055-1.1016-3.1133-1.4609l-0.011719 4.1055c-1.2695-0.375-2.4648-0.49219-3.5508-0.36719l-2.5195-4.3555c-1.7422 0.35156-3.2383 1.207-4.4258 2.5234l2.5156 4.3594c-0.65625 0.86719-1.1602 1.9531-1.4766 3.2266l-3.5703-2.0586c-0.19531 1.0508-0.30859 2.1914-0.30859 3.4102-0.003906 1.2227 0.10156 2.4883 0.28906 3.7578l3.5703 2.0586c0.30859 1.6367 0.80469 3.3008 1.4531 4.9219l-2.5312 1.4492c1.1719 2.6719 2.6602 5.2578 4.3984 7.6094l2.5312-1.4375c1.0859 1.3789 2.2734 2.6406 3.5391 3.7344l-0.011719 4.1016c1.0117 0.80078 2.0508 1.5234 3.1172 2.1406 1.0703 0.61719 2.1133 1.1016 3.125 1.4609l0.011719-4.1055c1.2617 0.36719 2.4531 0.48438 3.5469 0.36719l2.5156 4.3516c1.7461-0.34766 3.2461-1.2031 4.4258-2.5195l-2.5156-4.3633c0.66016-0.86328 1.1641-1.9492 1.4805-3.2227l3.5742 2.0586c0.19531-1.0508 0.30078-2.1914 0.30469-3.4102 0.007812-1.2227-0.097656-2.4805-0.28906-3.7578l-3.5703-2.0586c-0.30859-1.6367-0.80469-3.3008-1.457-4.9219l2.5391-1.4492c-1.1758-2.6719-2.668-5.2578-4.4062-7.6133l-2.5312 1.4414c-1.0859-1.3828-2.2734-2.6406-3.5352-3.7344l0.011719-4.1016c-1.0117-0.80078-2.0547-1.5273-3.125-2.1406zm-0.074219 28.793c-4.7773-2.7539-8.6406-9.4453-8.625-14.93 0.011719-5.4883 3.9023-7.6953 8.6758-4.9375 4.7773 2.7539 8.6367 9.4375 8.6211 14.926-0.019531 5.4844-3.8984 7.6992-8.6719 4.9414",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m328.32 280.3-0.97656 2.1367c-0.44141-0.33594-0.89062-0.63672-1.332-0.89062-0.46484-0.27344-0.93359-0.49609-1.3945-0.67969l-0.96094-3.2461c-1.457-0.50391-2.8555-0.64453-4.0977-0.41016l0.96875 3.2539c-0.72656 0.1875-1.3789 0.5625-1.9297 1.1055l-2.3359-2.4648c-0.41016 0.47266-0.76172 1.0156-1.0508 1.6602-0.29688 0.63672-0.50781 1.3281-0.65625 2.0781l2.3438 2.457c-0.14844 0.97266-0.14062 2.0352-0.011719 3.1328l-2.3438-0.23047c0.30078 1.8555 0.875 3.7852 1.6953 5.6914l2.3398 0.22656c0.53125 1.1445 1.1836 2.2656 1.9258 3.332l-0.97266 2.1328c0.60547 0.80859 1.2617 1.5938 1.9648 2.3359 0.69531 0.73438 1.4102 1.3906 2.125 1.9688l0.97266-2.1328c0.45703 0.33594 0.91016 0.63672 1.3594 0.89844 0.46094 0.26562 0.92188 0.48828 1.3672 0.66797l0.96484 3.25c1.4609 0.50391 2.8555 0.63672 4.1016 0.41016l-0.96875-3.2539c0.72656-0.20312 1.3828-0.56641 1.9297-1.1055l2.3438 2.4609c0.40234-0.46875 0.75781-1.0273 1.0469-1.6641 0.29297-0.62891 0.50781-1.332 0.65234-2.0664l-2.3438-2.4727c0.14453-0.96875 0.14453-2.0234 0.011719-3.1211l2.3438 0.22266c-0.30078-1.8477-0.87891-3.7852-1.6914-5.6836l-2.3438-0.23828c-0.53125-1.1367-1.1758-2.2617-1.9258-3.3242l0.97266-2.1289c-0.60547-0.81641-1.2617-1.5938-1.9648-2.332-0.70312-0.73828-1.4102-1.3945-2.1289-1.9766zm-2.3672 18.855c-0.78125-0.44922-1.5703-1.0742-2.3398-1.8828-3.1328-3.3008-4.6133-8.2969-3.3086-11.148 0.98047-2.1602 3.2734-2.4844 5.6875-1.0898 0.78125 0.44922 1.5781 1.0781 2.3438 1.8867 3.1289 3.2969 4.6094 8.2852 3.3125 11.148-0.99219 2.1602-3.2891 2.4766-5.6953 1.0859",
    fill: "#fff"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gz)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gh)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ct)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dr)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m452.8 235.29-58.301-38.438-40.453 61.371 58.301 38.438z",
    fill: "url(#cn)"
  })))))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ee)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fy)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gf)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#at)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m547.39 156.14 54.441 51.367 52.035-55.16-54.441-51.367z",
    fill: "url(#hr)"
  })))))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ea)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cy)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bq)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#es)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m580.51 158.12 8.875 8.375 8.5234-9.0352-8.875-8.375z",
    fill: "url(#da)"
  })))))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gv)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dp)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gx)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eo)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m582.59 156.98 15.301 14.438 14.945-15.844-15.305-14.434z",
    fill: "url(#ff)"
  })))))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gy)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#az)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iq)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m594.17 164.81 12.188 11.5 11.828-12.543-12.184-11.496z",
    fill: "url(#v)"
  })))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gp)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gs)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m595.8 163.25 19.062 17.984 18.703-19.828-19.062-17.984z",
    fill: "url(#fa)"
  })))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#au)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fm)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ef)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410.29 112.97 27.109 25.098 25.473-27.52-27.113-25.098z",
    fill: "url(#ao)"
  })))))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ak)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hu)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fe)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m381.12 118.98 54.992 50.906 51.43-55.566-54.992-50.91z",
    fill: "url(#m)"
  })))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m331.38 152.65-7.7578-4.4805 0.023437-7.2773 9.6992 5.6016zm-2.4531 7.6641-5.3281-3.0781 0.015625-6.5977 7.0977 4.0938zm-15.375-15.492 7.9141 4.5742-0.015626 6.6016-7.9219-4.5703zm-9.2969-5.3672 7.1484 4.1289-0.019532 6.6055-5.7539-3.3242zm7.1797-5.6133-0.027344 7.2812-7.6641-4.4297-1.5195-8.168zm10.043 13.09-7.918-4.5703 0.015624-7.2773 7.9219 4.5664zm25.484-6.4883-7.3477-4.2461c-1.5117-0.875-2.8516-0.49609-3.2773 0.93359l-2.3203 7.2656-34.52-19.93 4.4336 23.887 24.332 14.051-1.1055 3.4453-22.707-13.109c-0.59766-0.34375-1.0742-0.066407-1.0742 0.61328 0 0.67969 0.47266 1.5039 1.0664 1.8516l4.3984 2.5391c-1.3906-0.34766-2.4062 0.52734-2.4141 2.2695-0.003906 2.0859 1.4688 4.6445 3.293 5.6992 1.8203 1.0469 3.3086 0.20312 3.3125-1.8867 0.007812-1.7422-1.0078-3.7891-2.3906-5.043l11.305 6.5312c-1.3945-0.35547-2.4141 0.52344-2.4141 2.2656-0.007813 2.0898 1.4609 4.6445 3.293 5.6953 1.8164 1.0508 3.3047 0.20703 3.3125-1.8828 0-1.7422-1.0117-3.7891-2.3906-5.0391l4.1953 2.418c0.46484 0.27344 0.89062 0.16016 1.0273-0.26953l9.4219-29.477c0.16406-0.54297 0.66016-0.67969 1.207-0.35938l7.3516 4.2422c0.58984 0.33984 1.0781 0.0625 1.0781-0.61328 0-0.69141-0.47656-1.5156-1.0664-1.8516",
    fill: "#f7f8fc"
  })), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fg)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#im)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#be)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ce)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m453.55 322.92 58.211 40.098 40.301-58.512-58.215-40.102z",
    fill: "url(#r)"
  })))))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m519.95 77.238c-5.6172-3.2422-10.164-11.109-10.145-17.574 0.015625-6.457 4.5898-9.0664 10.211-5.8203 5.625 3.2461 10.168 11.113 10.145 17.574-0.015624 6.4648-4.5859 9.0703-10.211 5.8203zm18.613-15.816-6.6758-3.8555-2.1797-7.4883c-0.26563-0.91016-0.86719-1.6914-1.6953-2.1641l-15.504-8.9492c-0.91797-0.53125-2.0859-0.15234-2.5156 0.81641l-1.832 4.0898-7.1328-4.1211c-1.5781-0.91406-2.8711-0.16797-2.875 1.6562l-0.078125 26.293c-0.007813 1.8164 1.2812 4.0469 2.8516 4.957l37.539 21.676c1.582 0.91016 2.8828 0.16797 2.8867-1.6641l0.074219-26.27c0.003906-1.8242-1.2812-4.0625-2.8633-4.9766",
    fill: "#fff"
  })), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hk)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aw)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0889 0 0 1.0883 302.04 317.98)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 287,
    height: 269,
    xlinkHref: "data:image/jpeg;base64,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"
  }))))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gl)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ir)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0916 0 0 1.0895 250.97 406.09)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 149,
    xlinkHref: "data:image/jpeg;base64,/9j/7gAOQWRvYmUAZAAAAAAB/9sAQwAOCgsNCwkODQwNEA8OERYkFxYUFBYsICEaJDQuNzYzLjIyOkFTRjo9Tj4yMkhiSU5WWF1eXThFZm1lWmxTW11Z/9sAQwEPEBAWExYqFxcqWTsyO1lZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZWVlZ/8AAEQgAlQAyAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/aAAwDAQACEQMRAD8A9DZ1UZJAFUbjUlXIiGT6mqE87yn5jx6dqqsa2jDueZVxbekSeS6Z2yxJNR+eah604L61rZHE5SZKJs9qeJB3qCnLTC7JtwoqPA96KY9RzCmFPWrJWmFazTLcSDbikxU5Wk207kcpFtpwWn4oxTHYTFFLRQOxZIpCtIkqv0OD6Gn1nsa6PYZtpCtSUhphYiK0m2pabiqJsM20U/FFAWEeJW56H1FNEjx8ONy+tTEU01KYOPVDlZXGVOaWq7R4O5DtNOWbBxIMH1p27ApdyXFJinAgjI5FIxCjLHAoKExRUf2hPQ0U7Mnnj3J6QrTqKzNGiIjFNYAjBGac8ig7epPYUlWjN2ItjKfkYgUbCTl2LVJSVVyOVCYHpRS0UATO6oMsagLyS/d+VfWlWLnc53NUlZ6It3luRrGqdOT60404AmnhQPrTuNR7EYQmhkI96loouPlRXoqfA9KKq4uQbjNOCetPxjpRWRpyiYopaSmMKSlopiEopaKYDqKrpcFTtmGP9oVYBDDIIIqLWGpKWwlFLRTGJRRRTEFFFFAERAIwRkVFseM5ib8DU1IaSZm0mEdwrHa/yN71NVZ0VxyKarSQ9PnT0p2T2BTa+It0VHHMkg4OD6GleVEGWYfSixpzK17j6Krfa/SM/nRT5WR7WPckpDRRUIBKQ0UVSJGPGrc9D7U1YlHPX60UVSZDih9FFFMZ/9k="
  }))))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cx)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0918 0 0 1.0946 611.06 425.58)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 42,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAqCAIAAABdg87FAAAABmJLR0QA/wD/AP+gvaeTAAAC4UlEQVRIia1WS28TMRCesb2v5rHLq6WqUCrSh3rgAAdUwQWJC0duXHtA/Cj+FQdQo0bQClq1SNBsm9T7Nocm3k3jzXpD5rCyZsbzzXwejxfffY7SDABACBiLXBTXBeXEE9WehbUQQBgBkwIiVIjSQWMXAQBEMCkwUu1fOwMAkq8QDAqUaORVR3IAnMAwUsWYNp9YBMitCBQnjKliTXRCYZuRAsBMLEqA/DddigqmzAhUMrZQI1UASBiCGmev8ijpTSX1qHFdFADF/ZPIcwKNfbQbSYui8u3VjTQNsNg8qAFQKfUzWJAi/QxIaQpLmkh3K6gRVq+R6lOE449mI80ALJuuBSvQz2DZXQQAALQdz9zkJTGDTDh7g/brc3P95lbDlGG1npIZV3Nj5Oz6xEoBgLoRnK0AqgBq5DuOL5gXO3uXzI2kKT53bhcqAGUJJXURK3V2fHPjRmpEgjdf7yeXVjmAZuZE2J2h1b1CmiNHpw3ec7OASs2CFBmr3N71yUoiNcnA5N/uJb55x7MAoMcMbcb2js8eBFKThZT33OiskXsWdqkrUGOxzO5emU+GeftmGJw0g35bpKX3SY8iBGNjZHd9NDKpi387/NDNOBMCAETZrSkBKJRAvdDeGZBWLI3p0OCHbvLH1smNzblXxE7Nrs/Wii1Ign47/NlUb1GFKjkDIqzONetcI5G/+hCdNviRK+J640sBwFa58XSAdio1yaXFe156bWjPkLyaKQDSjI2tAfFCqckCyo88ee/nx1LKGABZxjZ9uj7KH6oMw+NWeNwSWcVQlRNJ2UgMENj6kG1eASu04IUT9L2U07vuNSYtAIDFgNkvLmBlqgWDnpcMrBphSjJ4swUH+8hkdBGT4LsbnTZ0cyyvZvsRfHqFe2sA4zMQEP5qhj/aIiH6Da4Uz4GDl/h2O/99Zslfm/fdbGjMxqr1tDGE98/gw3N0jCkLG315qBlkjux38OM+Pm4pTP8Aq/XhAEnOA7EAAAAASUVORK5CYII="
  }))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cu)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0951 0 0 1.0921 235.7 411.53)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 17,
    height: 45,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAtCAIAAADHtxd7AAAABmJLR0QA/wD/AP+gvaeTAAAC80lEQVRIiZVWXYscRRQ95/bM7K6redJEEPEbfREi+L/9FZEYYnBR0YiBGAIuxGUzbm9PT3fVPT5UdXf1zKxsimJoqs+599yPuj3ctAFvsgQs3gjtQoRuxUnoAAUp6BachO6VCf3/cwRFoUQHaR3DDRzBgQj0Ui9FqZe27mdt/VN7dYgjODEaTvtZ1zxs/n0dgx/UVhKi9Cp031+vX4bWBUkHOALCgG48/rBZ/7a9ji5JibNbHwFRcilIP7dXjzdXG0UBDqjYi5LgUgRe9O2DzeVF6F0UIEkSJIACUHIIXHp40Fw+7zYxiRhsgZCQjiY/W8Un26uzTd3LNXlW8Zx+SGAh4Gl3/ah93XiMI2RvESCZqIvv6vOL2GsyNksKwYkzbLuIPQ4TEhIADElUPrKZ9x0x4yazB5KAsTBIK3GDVTK5GQi0MUXJGOaGUzw5AQBZaGOhK7+eXDHZTn44+gFAqFBMZtwspIq0We+IRrhAklLGSUa6aAAIA8ys6B0CkNFc2SEkpDoSEFc0UAJn/SbQ6ClIl4yUVJFLkAYXIMakjbOCkpAxt/CKpChCEggBJiyQfc/KT2FpRuWmdsBTJiTy0EwksEilJl05pookIB6aoxVpMAxqLeFEECaJVDkPDDRiRydJSAuaON1wGwnV1PcaqRqKAKkizWhk7lEjyrt8aDFZG3tUO3AVTO0SB21NVHcDbDodjnMOnra6jvrixO4ux0jKuuVnljnYODrh18af1L6Oex7m2cyc94acryN+rP331jsNl3dPZOpxfHLMD1bT6d+dHtbxr859PyRO9xSfH/ObU96p8usoPGv9UR1ehR3iNHcE4J0K90/55QlXg6CN45fGz5pYT+O1mFXjurvEt2/zw9V07y+DHtfhzzb2Am/61lfER0e8t+Tzrf4JebS/7Py890+PqgN+coTUseGrE379lp0OqCD80cb5TCx+x3Wnwv1T++yYy+HFbf+H3Fvy3YW96Py8m31P9y/5bpAfH9n7S/wHEI7ilzvVacQAAAAASUVORK5CYII="
  }))))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ax)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bg)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0974 0 0 1.0906 236.76 519.28)"
  }, /*#__PURE__*/React.createElement("image", {
    width: 16,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAIAAAB8wupbAAAABmJLR0QA/wD/AP+gvaeTAAABpUlEQVQ4jXWTO2/UUBCFvzPX3rU3IKBIxKMjBSARqjT8VPgjRKJCok1LAVtkJUCILbIEVsT22kPhx1p3zRRj3bn3zJwz49Gbn0tHgEPv5YAfRABImDAHHUbnstzCJCC2RFpYkkreV5hKKXAM5RbmFobYdAWBw8JCZma9AB8A6g+DT2VHFsJeq4M0KTpIuYWZQvfsUM+YRm4h7+i696oGcd4BBI7gXkiDhoHEr+MKmVkiiyhIeB9SBLBRrnFWoaHlbT+svSi8bnCNAEIHjASyNraueL/Z/ap94skIJ/UV1juua7/YVJfbumi6QWkKl7TnIwNw+HJbr8rmLLfTLGgkqP3uNTyZ+UnadaRs/HJbX2yqH1VDRGkACF4t/OXC512Am9o/3FQff1fb2ifa2trDlOPErwqtChoAvpXN97J8kSfP85AK2grjbgbxNPPXd/0k7bI4fPq7e7cpr4raQW/XS+gmGu3qZsfnW/2p9xQeJNZTnlhJ7iec3+FZRtrfXu+a6PeOV0/weM5xyqrga4n/b+MiS8VpxqMZy9u+rVHWyLe2MM4W+gcWFJJh9aO1fwAAAABJRU5ErkJggg=="
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile1);
export default __webpack_public_path__ + "static/media/mobile_1.2267e60c98195e2a1f6288e62f4d9508.svg";
export { ForwardRef as ReactComponent };